webpackJsonp([2],{

/***/ "0rFV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subscribe container",
    attrs: {
      "id": "million-bit-subscribe"
    }
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Subscribe")]), _vm._v(" "), _c('h5', {
    staticClass: "text-center"
  }, [_vm._v("Stay up to date with the latest news and updates from the Million Bit Homepage")]), _vm._v(" "), _c('p', [_c('b-form', {
    on: {
      "submit": _vm.subscribeEmail
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "subscribe-form",
      "label": "Email address",
      "label-for": "email",
      "description": "We'll never share your email with anyone else."
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "email",
      "type": "email",
      "required": "",
      "placeholder": "Enter email",
      "disabled": _vm.isLoading
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "btn-block",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.isLoading
    }
  }, [_vm._v("Subscribe")])], 1)], 1), (_vm.subscribed) ? _c('p', [_vm._v("Thank you for subscribing! We'll be in touch.")]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Social")]), _vm._v(" "), _c('p', [_vm._v("\n    Follow along our daily progress and join the conversation!\n\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "href": _vm.appData().twitter,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "bi bi-twitter-x",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
    }
  })]), _vm._v("\n          Twitter\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "href": _vm.appData().telegram,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "bi bi-telegram",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"
    }
  })]), _vm._v("\n          Telegram\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "href": _vm.appData().discord,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "bi bi-discord",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.545 2.907a13.2 13.2 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.2 12.2 0 0 0-3.658 0 8 8 0 0 0-.412-.833.05.05 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.04.04 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032q.003.022.021.037a13.3 13.3 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019q.463-.63.818-1.329a.05.05 0 0 0-.01-.059l-.018-.011a9 9 0 0 1-1.248-.595.05.05 0 0 1-.02-.066l.015-.019q.127-.095.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.05.05 0 0 1 .053.007q.121.1.248.195a.05.05 0 0 1-.004.085 8 8 0 0 1-1.249.594.05.05 0 0 0-.03.03.05.05 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.2 13.2 0 0 0 4.001-2.02.05.05 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.03.03 0 0 0-.02-.019m-8.198 7.307c-.789 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612m5.316 0c-.788 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612"
    }
  })]), _vm._v("\n          Discord\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "href": _vm.appData().youtube,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "bi bi-youtube",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z"
    }
  })]), _vm._v("\n        YouTube\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "href": _vm.appData().tiktok,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "bi bi-tiktok",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"
    }
  })]), _vm._v("\n        TikTok\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "href": _vm.appData().warpcast,
      "target": "_blank"
    }
  }, [_vm._v("\n        Warpcast\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "href": _vm.appData().drakula,
      "target": "_blank"
    }
  }, [_vm._v("\n        Drakula\n      ")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "13aN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("L/hj");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*global axios*/

var BASE_S3_BUCKET = "https://millionbithomepage.com/static/billboard/";
var BASE_S3_BUCKET_TRX = "https://millionbithomepage.com/trx/";
var getTsPath = function getTsPath(path) {
  return BASE_S3_BUCKET + 'dob/' + path + '?' + Date.now();
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dob',
  data: function data() {
    return {
      links: [],
      transactions: [],
      // links: [{c: '0,0,1,1', u: 'http://google.com'}],
      s3Base: BASE_S3_BUCKET,
      s3BaseTrx: BASE_S3_BUCKET_TRX,
      s3ImgSrc: getTsPath('homepage.jpeg'), // BASE_S3_BUCKET+'homepage.jpeg?'+Date.now(),
      s3LinkMap: getTsPath('link_map.json'), // BASE_S3_BUCKET+'link_map.json?'+Date.now(),
      s3PricesJson: getTsPath('prices.json'), // BASE_S3_BUCKET+'prices.json?'+Date.now(),
      s3TransactionsJson: getTsPath('transactions.json'), // BASE_S3_BUCKET+'transactions.json?'+Date.now(),
      isBillboardLoaded: false,
      hovering: false, // To track whether the mouse is hovering over the image
      mouseX: 0, // To store the X coordinate of the mouse
      mouseY: 0, // To store the Y coordinate of the mouse
      tooltipTxt: ''
    };
  },

  inject: ['updateAppRoute', 'saveEvent', 'doUpload', 'appData'],
  methods: {
    onBillboardLoaded: function onBillboardLoaded() {
      if (!this.isBillboardLoaded) {
        // Only trigger once (since we may reload the image later)
        this.isBillboardLoaded = true;
        this.updateAppRoute('/dob');
      }
    },
    clickBillboard: function clickBillboard(e) {
      // console.log('clickBillboard', e, e.target, typeof e.target, e.target.coords);
      // Don't track dragging image
      if (this.appData().canBuy) {
        return;
      }
      var offsetX = e.offsetX,
          offsetY = e.offsetY;

      if (e.target && e.target.coords) {
        var link = this.getLinkFromCoords(offsetX, offsetY);
        if (link) {
          this.saveEvent('clickBillboardDob', {
            url: link.u,
            x: offsetX,
            y: offsetY
          });
          __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboardDob', { url: link.u });
          __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboardDob:' + link.u);
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboardDob:emptySpace');
        if (!this.appData().isMobileOrTouch) {
          // Don't do this on mobile
          this.doUpload(offsetX, offsetY);
        }
      }
    },
    onMouseEnter: function onMouseEnter() {
      this.hovering = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovering = false;
    },
    onMouseMove: function onMouseMove(e) {
      if (this.appData().isMobileOrTouch) {
        return;
      }
      if (this.appData().canBuy) {
        this.hovering = false;
        return;
      }
      // Get the mouse coordinates relative to the image
      var rect = e.target.getBoundingClientRect();
      this.mouseX = e.clientX - rect.left;
      this.mouseY = e.clientY - rect.top;
      // console.log(`Mouse move: ${this.mouseX}, ${this.mouseY}`, e.target.coords);
      if (e.target && e.target.coords) {
        var offsetX = e.offsetX,
            offsetY = e.offsetY;

        var link = this.getLinkFromCoords(offsetX, offsetY);
        if (link && link.u) {
          var _link$c$split = link.c.split(','),
              _link$c$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_link$c$split, 4),
              x1 = _link$c$split2[0],
              y1 = _link$c$split2[1],
              x2 = _link$c$split2[2],
              y2 = _link$c$split2[3];
          // console.log(`Mouse over link: ${link.u}`, link, x1, y1, x2, y2);


          this.$refs.tooltip.innerHTML = link.u;
        }
      } else {
        // console.log('Mouse over blank space');
        this.$refs.tooltip.innerHTML = 'Claim this space';
      }
      this.$refs.tooltip.style.left = this.mouseX + 'px';
      this.$refs.tooltip.style.top = this.mouseY - 50 + 'px';
      this.$refs.tooltip.style.marginLeft = '-' + this.$refs.tooltip.offsetWidth / 2 + 'px';
    },

    getLinkFromCoords: function getLinkFromCoords(x, y) {
      var links = this.links;
      for (var i = 0; i < links.length; i++) {
        var link = links[i];

        var _link$c$split3 = link.c.split(','),
            _link$c$split4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_link$c$split3, 4),
            x1 = _link$c$split4[0],
            y1 = _link$c$split4[1],
            x2 = _link$c$split4[2],
            y2 = _link$c$split4[3];

        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
          return link;
        }
      }
      return null;
    },
    toastTransaction: function toastTransaction(t) {
      __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].toast({
        title: t.pixels + ' pixels sold!',
        message: 'To ' + __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].truncateString(t.from) + '<br />' + t.url,
        img: this.s3BaseTrx + t.hash + '-crop.jpeg',
        type: "success",
        duration: 10000
      });
      __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('toastTransaction');
    },
    toastTransactions: function toastTransactions() {
      var _this = this;

      try {
        var recentTransactions = this.transactions.slice(0, 5);
        if (!window.toastInterval) {
          window.toastInterval = setInterval(function () {
            if (recentTransactions.length > 0) {
              var t = recentTransactions.shift();
              var trxKey = 'toastedTrx-' + t.hash;
              if (localStorage.getItem(trxKey)) {
                return;
              }
              localStorage.setItem(trxKey, true);
              _this.toastTransaction(t);
            }
          }, 30000);
        }
      } catch (e) {
        console.error('toastTransactions', e);
      }
    },
    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(doReload) {
        var self;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;

                if (doReload) {
                  this.s3ImgSrc = getTsPath('homepage.jpeg');
                }
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  axios.get(self.s3LinkMap).then(function (response) {
                    self.links = response.data;
                    axios.get(getTsPath('prices.json')).then(function (response) {
                      window.pricesData = self.prices = response.data;
                      // if (doReload) {
                      //   _.times(1024/16/2, (x) => {
                      //     _.times(1024/16/2, (y) => {
                      //       window.pricesData.push({x: x, y: y, p: "100"});
                      //     });
                      //   });
                      // }
                      if (false) {
                        axios.get(self.s3TransactionsJson).then(function (response) {
                          self.transactions = response.data;
                          // self.toastTransaction(self.transactions[0]);
                          self.toastTransactions();

                          resolve();
                        });
                      } else {
                        resolve();
                      }
                    }).catch(function (error) {
                      console.log('Error loading ' + self.s3PricesJson, error);
                      reject(error);
                    });
                  }).catch(function (error) {
                    console.log('Error loading ' + self.s3LinkMap, error);
                    reject(error);
                  });
                }));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }()
  },
  created: function created() {
    this.fetchData();
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "19pQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("L/hj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("QmSG");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subsocial',
  data: function data() {
    return {
      subscribed: false,
      isLoading: false,
      form: {
        email: ''
      }
    };
  },

  methods: {
    subscribeEmail: function subscribeEmail(event) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var email;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                _this.isLoading = true;
                email = _this.form.email;
                _context.next = 5;
                return _this.saveEvent('subscribeToNewsletter', { email: email });

              case 5:
                __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].LOCAL_STORAGE_KEYS.NEWSLETTER_SUBSCRIBED, email);
                _this.subscribed = true;
                _this.isLoading = false;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  inject: ['updateAppRoute', 'appData', 'saveEvent'],
  created: function created() {
    this.updateAppRoute('subscribe');
  }
});

/***/ }),

/***/ "1MwN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plots_vue__ = __webpack_require__("rk29");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_533387e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Plots_vue__ = __webpack_require__("TAa6");
function injectStyle (ssrContext) {
  __webpack_require__("PHjy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-533387e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plots_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_533387e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Plots_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "26cW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__ = __webpack_require__("4Z64");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3227eda5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__ = __webpack_require__("S/ZD");
function injectStyle (ssrContext) {
  __webpack_require__("tmNq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3227eda5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3227eda5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Z64":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-demo',
  data: function data() {
    return {};
  },

  inject: ['updateAppRoute', 'appData', 'postToLambda'],
  created: function created() {
    this.updateAppRoute('demo');
  },
  methods: {
    close: function close() {
      this.$router.push('/');
    }
  }
});

/***/ }),

/***/ "4sUT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aCA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu container",
    attrs: {
      "id": "million-bit-menu"
    }
  }, [_c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/')
      }
    }
  }, [_vm._v("\n    Homepage\n  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/about')
      }
    }
  }, [_vm._v("\n    About\n  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/leaderboard')
      }
    }
  }, [_vm._v("\n    Leaderboard\n  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/plots')
      }
    }
  }, [_vm._v("\n    My Plots\n  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/list')
      }
    }
  }, [_vm._v("\n    Pixel List\n  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/break')
      }
    }
  }, [_vm._v("\n    Break \n\n    "), _c('svg', {
    staticClass: "bi bi-joystick",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 2a2 2 0 0 1-1.5 1.937v5.087c.863.083 1.5.377 1.5.726 0 .414-.895.75-2 .75s-2-.336-2-.75c0-.35.637-.643 1.5-.726V3.937A2 2 0 1 1 10 2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 9.665v1.717a1 1 0 0 0 .553.894l6.553 3.277a2 2 0 0 0 1.788 0l6.553-3.277a1 1 0 0 0 .553-.894V9.665c0-.1-.06-.19-.152-.23L9.5 6.715v.993l5.227 2.178a.125.125 0 0 1 .001.23l-5.94 2.546a2 2 0 0 1-1.576 0l-5.94-2.546a.125.125 0 0 1 .001-.23L6.5 7.708l-.013-.988L.152 9.435a.25.25 0 0 0-.152.23"
    }
  })])]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/drop')
      }
    }
  }, [_vm._v("\n    Drop \n\n    "), _c('svg', {
    staticClass: "bi bi-joystick",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 2a2 2 0 0 1-1.5 1.937v5.087c.863.083 1.5.377 1.5.726 0 .414-.895.75-2 .75s-2-.336-2-.75c0-.35.637-.643 1.5-.726V3.937A2 2 0 1 1 10 2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 9.665v1.717a1 1 0 0 0 .553.894l6.553 3.277a2 2 0 0 0 1.788 0l6.553-3.277a1 1 0 0 0 .553-.894V9.665c0-.1-.06-.19-.152-.23L9.5 6.715v.993l5.227 2.178a.125.125 0 0 1 .001.23l-5.94 2.546a2 2 0 0 1-1.576 0l-5.94-2.546a.125.125 0 0 1 .001-.23L6.5 7.708l-.013-.988L.152 9.435a.25.25 0 0 0-.152.23"
    }
  })])]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/spaces')
      }
    }
  }, [_vm._v("\n    Based "), _c('svg', {
    staticClass: "bi bi-twitter-x",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
    }
  })]), _vm._v(" Spaces\n  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/subscribe')
      }
    }
  }, [_vm._v("\n    Subscribe\n  ")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5lUk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Break_vue__ = __webpack_require__("YGEE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74e162ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Break_vue__ = __webpack_require__("FQQj");
function injectStyle (ssrContext) {
  __webpack_require__("HZTw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74e162ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Break_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74e162ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Break_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5yYN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'privacy',
  data: function data() {
    return {};
  },

  inject: ['updateAppRoute', 'appData', 'postToLambda'],
  created: function created() {
    this.updateAppRoute('privacy');
  }
});

/***/ }),

/***/ "8Bxh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8DXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tang_vue__ = __webpack_require__("B9kh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_443429b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Tang_vue__ = __webpack_require__("sWtQ");
function injectStyle (ssrContext) {
  __webpack_require__("He5e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-443429b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tang_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_443429b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Tang_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8mQd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__ = __webpack_require__("5yYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069c7336_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__ = __webpack_require__("JQLy");
function injectStyle (ssrContext) {
  __webpack_require__("QK0B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-069c7336"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069c7336_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AlKc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B9kh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("L/hj");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*global axios*/

var BASE_S3_BUCKET = "https://millionbithomepage.com/static/billboard/";
var BASE_S3_BUCKET_TRX = "https://millionbithomepage.com/trx/";
var getTsPath = function getTsPath(path) {
  return BASE_S3_BUCKET + 'tang/' + path + '?' + Date.now();
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tang',
  data: function data() {
    return {
      links: [],
      transactions: [],
      // links: [{c: '0,0,1,1', u: 'http://google.com'}],
      s3Base: BASE_S3_BUCKET,
      s3BaseTrx: BASE_S3_BUCKET_TRX,
      s3ImgSrc: getTsPath('homepage.jpeg'), // BASE_S3_BUCKET+'homepage.jpeg?'+Date.now(),
      s3LinkMap: getTsPath('link_map.json'), // BASE_S3_BUCKET+'link_map.json?'+Date.now(),
      s3PricesJson: getTsPath('prices.json'), // BASE_S3_BUCKET+'prices.json?'+Date.now(),
      s3TransactionsJson: getTsPath('transactions.json'), // BASE_S3_BUCKET+'transactions.json?'+Date.now(),
      isBillboardLoaded: false,
      hovering: false, // To track whether the mouse is hovering over the image
      mouseX: 0, // To store the X coordinate of the mouse
      mouseY: 0, // To store the Y coordinate of the mouse
      tooltipTxt: ''
    };
  },

  inject: ['updateAppRoute', 'saveEvent', 'doUpload', 'appData'],
  methods: {
    onBillboardLoaded: function onBillboardLoaded() {
      if (!this.isBillboardLoaded) {
        // Only trigger once (since we may reload the image later)
        this.isBillboardLoaded = true;
        this.updateAppRoute('/tang');
      }
    },
    clickBillboard: function clickBillboard(e) {
      // console.log('clickBillboard', e, e.target, typeof e.target, e.target.coords);
      // Don't track dragging image
      if (this.appData().canBuy) {
        return;
      }
      var offsetX = e.offsetX,
          offsetY = e.offsetY;

      if (e.target && e.target.coords) {
        var link = this.getLinkFromCoords(offsetX, offsetY);
        if (link) {
          this.saveEvent('clickBillboardTang', {
            url: link.u,
            x: offsetX,
            y: offsetY
          });
          __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboardTang', { url: link.u });
          __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboardTang:' + link.u);
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboardTang:emptySpace');
        if (!this.appData().isMobileOrTouch) {
          // Don't do this on mobile
          this.doUpload(offsetX, offsetY);
        }
      }
    },
    onMouseEnter: function onMouseEnter() {
      this.hovering = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovering = false;
    },
    onMouseMove: function onMouseMove(e) {
      if (this.appData().isMobileOrTouch) {
        return;
      }
      if (this.appData().canBuy) {
        this.hovering = false;
        return;
      }
      // Get the mouse coordinates relative to the image
      var rect = e.target.getBoundingClientRect();
      this.mouseX = e.clientX - rect.left;
      this.mouseY = e.clientY - rect.top;
      // console.log(`Mouse move: ${this.mouseX}, ${this.mouseY}`, e.target.coords);
      if (e.target && e.target.coords) {
        var offsetX = e.offsetX,
            offsetY = e.offsetY;

        var link = this.getLinkFromCoords(offsetX, offsetY);
        if (link && link.u) {
          var _link$c$split = link.c.split(','),
              _link$c$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_link$c$split, 4),
              x1 = _link$c$split2[0],
              y1 = _link$c$split2[1],
              x2 = _link$c$split2[2],
              y2 = _link$c$split2[3];
          // console.log(`Mouse over link: ${link.u}`, link, x1, y1, x2, y2);


          this.$refs.tooltip.innerHTML = link.u;
        }
      } else {
        // console.log('Mouse over blank space');
        this.$refs.tooltip.innerHTML = 'Claim this space';
      }
      this.$refs.tooltip.style.left = this.mouseX + 'px';
      this.$refs.tooltip.style.top = this.mouseY - 50 + 'px';
      this.$refs.tooltip.style.marginLeft = '-' + this.$refs.tooltip.offsetWidth / 2 + 'px';
    },

    getLinkFromCoords: function getLinkFromCoords(x, y) {
      var links = this.links;
      for (var i = 0; i < links.length; i++) {
        var link = links[i];

        var _link$c$split3 = link.c.split(','),
            _link$c$split4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_link$c$split3, 4),
            x1 = _link$c$split4[0],
            y1 = _link$c$split4[1],
            x2 = _link$c$split4[2],
            y2 = _link$c$split4[3];

        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
          return link;
        }
      }
      return null;
    },
    toastTransaction: function toastTransaction(t) {
      __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].toast({
        title: t.pixels + ' pixels sold!',
        message: 'To ' + __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].truncateString(t.from) + '<br />' + t.url,
        img: this.s3BaseTrx + t.hash + '-crop.jpeg',
        type: "success",
        duration: 10000
      });
      __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('toastTransaction');
    },
    toastTransactions: function toastTransactions() {
      var _this = this;

      try {
        var recentTransactions = this.transactions.slice(0, 5);
        if (!window.toastInterval) {
          window.toastInterval = setInterval(function () {
            if (recentTransactions.length > 0) {
              var t = recentTransactions.shift();
              var trxKey = 'toastedTrx-' + t.hash;
              if (localStorage.getItem(trxKey)) {
                return;
              }
              localStorage.setItem(trxKey, true);
              _this.toastTransaction(t);
            }
          }, 30000);
        }
      } catch (e) {
        console.error('toastTransactions', e);
      }
    },
    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(doReload) {
        var self;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;

                if (doReload) {
                  this.s3ImgSrc = getTsPath('homepage.jpeg');
                }
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  axios.get(self.s3LinkMap).then(function (response) {
                    self.links = response.data;
                    axios.get(getTsPath('prices.json')).then(function (response) {
                      window.pricesData = self.prices = response.data;
                      // if (doReload) {
                      //   _.times(1024/16/2, (x) => {
                      //     _.times(1024/16/2, (y) => {
                      //       window.pricesData.push({x: x, y: y, p: "100"});
                      //     });
                      //   });
                      // }
                      if (false) {
                        axios.get(self.s3TransactionsJson).then(function (response) {
                          self.transactions = response.data;
                          // self.toastTransaction(self.transactions[0]);
                          self.toastTransactions();

                          resolve();
                        });
                      } else {
                        resolve();
                      }
                    }).catch(function (error) {
                      console.log('Error loading ' + self.s3PricesJson, error);
                      reject(error);
                    });
                  }).catch(function (error) {
                    console.log('Error loading ' + self.s3LinkMap, error);
                    reject(error);
                  });
                }));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }()
  },
  created: function created() {
    this.fetchData();
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "BEit":
/***/ (function(module, exports) {

module.exports = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"ECDSAInvalidSignature","type":"error"},{"inputs":[{"internalType":"uint256","name":"length","type":"uint256"}],"name":"ECDSAInvalidSignatureLength","type":"error"},{"inputs":[{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"ECDSAInvalidSignatureS","type":"error"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"allowance","type":"uint256"},{"internalType":"uint256","name":"needed","type":"uint256"}],"name":"ERC20InsufficientAllowance","type":"error"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"uint256","name":"balance","type":"uint256"},{"internalType":"uint256","name":"needed","type":"uint256"}],"name":"ERC20InsufficientBalance","type":"error"},{"inputs":[{"internalType":"address","name":"approver","type":"address"}],"name":"ERC20InvalidApprover","type":"error"},{"inputs":[{"internalType":"address","name":"receiver","type":"address"}],"name":"ERC20InvalidReceiver","type":"error"},{"inputs":[{"internalType":"address","name":"sender","type":"address"}],"name":"ERC20InvalidSender","type":"error"},{"inputs":[{"internalType":"address","name":"spender","type":"address"}],"name":"ERC20InvalidSpender","type":"error"},{"inputs":[{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"ERC2612ExpiredSignature","type":"error"},{"inputs":[{"internalType":"address","name":"signer","type":"address"},{"internalType":"address","name":"owner","type":"address"}],"name":"ERC2612InvalidSigner","type":"error"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"currentNonce","type":"uint256"}],"name":"InvalidAccountNonce","type":"error"},{"inputs":[],"name":"InvalidShortString","type":"error"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"OwnableInvalidOwner","type":"error"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"OwnableUnauthorizedAccount","type":"error"},{"inputs":[{"internalType":"string","name":"str","type":"string"}],"name":"StringTooLong","type":"error"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[],"name":"EIP712DomainChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"bool","name":"isExcluded","type":"bool"}],"name":"ExcludeFromLimits","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"_maxTxAmount","type":"uint256"}],"name":"MaxTxAmountUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"paint","type":"string"}],"name":"Paint","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"totalWallets","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"totaBitTokens","type":"uint256"}],"name":"TokensAirdropped","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_buyCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_maxTaxSwap","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_maxTxAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_maxWalletSize","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_taxSwapThreshold","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"addLiquidity","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address[]","name":"addresses","type":"address[]"},{"internalType":"uint256[]","name":"tokenAmounts","type":"uint256[]"}],"name":"airdrop","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"accounts","type":"address[]"},{"internalType":"bool","name":"value","type":"bool"}],"name":"bulkExcludeFromMaxTransaction","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"deadAddress","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"eip712Domain","outputs":[{"internalType":"bytes1","name":"fields","type":"bytes1"},{"internalType":"string","name":"name","type":"string"},{"internalType":"string","name":"version","type":"string"},{"internalType":"uint256","name":"chainId","type":"uint256"},{"internalType":"address","name":"verifyingContract","type":"address"},{"internalType":"bytes32","name":"salt","type":"bytes32"},{"internalType":"uint256[]","name":"extensions","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"enableTrading","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"bool","name":"value","type":"bool"}],"name":"excludeFromMaxTransaction","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isExcludedFromMaxTransaction","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isPair","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"manualSwap","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"string","name":"paintData","type":"string"}],"name":"paint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_newFee","type":"uint256"}],"name":"reduceFee","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"removeLimits","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"setFinalMaxWallet","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"setFinalTax","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"bool","name":"value","type":"bool"}],"name":"setPair","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tradingActive","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"uniswapV2Pair","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"uniswapV2Router","outputs":[{"internalType":"contract IUniswapV2Router02","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"tkn","type":"address"}],"name":"withdrawStuckTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"stateMutability":"payable","type":"receive"}]

/***/ }),

/***/ "FE7F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transactions container",
    attrs: {
      "id": "million-bit-transactions"
    }
  }, [_c('h1', {
    staticClass: "pt-3 honk-text"
  }, [_vm._v("Pixels: "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.pixelCount)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-block"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-block btn-primary my-3",
    class: {
      'disabled': _vm.toggledView === 'mint'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleView()
      }
    }
  }, [_vm._v("\n          Mint\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon btn-block btn-primary my-3",
    class: {
      'disabled': _vm.toggledView === 'repaint'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleView()
      }
    }
  }, [_vm._v("\n          Repaint\n      ")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.transactionsFiltered), function(transaction) {
    return _c('tr', {
      key: transaction._id
    }, [_c('td', [_c('b', {
      staticClass: "mr-1"
    }, [_vm._v(_vm._s(transaction.seq))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'https://basescan.org/tx/' + transaction.hash,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "external-link",
      attrs: {
        "src": "/static/external-link.svg",
        "alt": "View transaction"
      }
    })])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "lazy-load",
        rawName: "v-lazy-load"
      }]
    }, [_c('img', {
      staticClass: "mr-4 my-4",
      attrs: {
        "data-url": _vm.s3Base + transaction.hash + '-crop.jpeg'
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-left link"
    }, [_c('a', {
      attrs: {
        "href": transaction.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(transaction.url))])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('a', {
      staticClass: "btn btn-outline-primary btn-sm",
      attrs: {
        "href": 'https://magiceden.us/item-details/base/0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e/' + transaction.tokenId,
        "target": "_blank"
      }
    }, [_vm._v("Magic Eden")])])])])
  }), 0)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FHx6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("L/hj");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*global axios*/

var BASE_S3_BUCKET = "https://millionbithomepage.com/static/billboard/";
var BASE_S3_BUCKET_TRX = "https://millionbithomepage.com/trx/";
var getTsPath = function getTsPath(path) {
  return BASE_S3_BUCKET + 'preme/' + path + '?' + Date.now();
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'preme',
  data: function data() {
    return {
      links: [],
      transactions: [],
      // links: [{c: '0,0,1,1', u: 'http://google.com'}],
      s3Base: BASE_S3_BUCKET,
      s3BaseTrx: BASE_S3_BUCKET_TRX,
      s3ImgSrc: getTsPath('homepage.jpeg'), // BASE_S3_BUCKET+'homepage.jpeg?'+Date.now(),
      s3LinkMap: getTsPath('link_map.json'), // BASE_S3_BUCKET+'link_map.json?'+Date.now(),
      s3PricesJson: getTsPath('prices.json'), // BASE_S3_BUCKET+'prices.json?'+Date.now(),
      s3TransactionsJson: getTsPath('transactions.json'), // BASE_S3_BUCKET+'transactions.json?'+Date.now(),
      isBillboardLoaded: false,
      hovering: false, // To track whether the mouse is hovering over the image
      mouseX: 0, // To store the X coordinate of the mouse
      mouseY: 0, // To store the Y coordinate of the mouse
      tooltipTxt: ''
    };
  },

  inject: ['updateAppRoute', 'saveEvent', 'doUpload', 'appData'],
  methods: {
    onBillboardLoaded: function onBillboardLoaded() {
      if (!this.isBillboardLoaded) {
        // Only trigger once (since we may reload the image later)
        this.isBillboardLoaded = true;
        this.updateAppRoute('/preme');
      }
    },
    clickBillboard: function clickBillboard(e) {
      // console.log('clickBillboard', e, e.target, typeof e.target, e.target.coords);
      // Don't track dragging image
      if (this.appData().canBuy) {
        return;
      }
      var offsetX = e.offsetX,
          offsetY = e.offsetY;

      if (e.target && e.target.coords) {
        var link = this.getLinkFromCoords(offsetX, offsetY);
        if (link) {
          this.saveEvent('clickBillboardPreme', {
            url: link.u,
            x: offsetX,
            y: offsetY
          });
          __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboardPreme', { url: link.u });
          __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboardPreme:' + link.u);
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboardPreme:emptySpace');
        if (!this.appData().isMobileOrTouch) {
          // Don't do this on mobile
          this.doUpload(offsetX, offsetY);
        }
      }
    },
    onMouseEnter: function onMouseEnter() {
      this.hovering = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovering = false;
    },
    onMouseMove: function onMouseMove(e) {
      if (this.appData().isMobileOrTouch) {
        return;
      }
      if (this.appData().canBuy) {
        this.hovering = false;
        return;
      }
      // Get the mouse coordinates relative to the image
      var rect = e.target.getBoundingClientRect();
      this.mouseX = e.clientX - rect.left;
      this.mouseY = e.clientY - rect.top;
      // console.log(`Mouse move: ${this.mouseX}, ${this.mouseY}`, e.target.coords);
      if (e.target && e.target.coords) {
        var offsetX = e.offsetX,
            offsetY = e.offsetY;

        var link = this.getLinkFromCoords(offsetX, offsetY);
        if (link && link.u) {
          var _link$c$split = link.c.split(','),
              _link$c$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_link$c$split, 4),
              x1 = _link$c$split2[0],
              y1 = _link$c$split2[1],
              x2 = _link$c$split2[2],
              y2 = _link$c$split2[3];
          // console.log(`Mouse over link: ${link.u}`, link, x1, y1, x2, y2);


          this.$refs.tooltip.innerHTML = link.u;
        }
      } else {
        // console.log('Mouse over blank space');
        this.$refs.tooltip.innerHTML = 'Claim this space';
      }
      this.$refs.tooltip.style.left = this.mouseX + 'px';
      this.$refs.tooltip.style.top = this.mouseY - 50 + 'px';
      this.$refs.tooltip.style.marginLeft = '-' + this.$refs.tooltip.offsetWidth / 2 + 'px';
    },

    getLinkFromCoords: function getLinkFromCoords(x, y) {
      var links = this.links;
      for (var i = 0; i < links.length; i++) {
        var link = links[i];

        var _link$c$split3 = link.c.split(','),
            _link$c$split4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_link$c$split3, 4),
            x1 = _link$c$split4[0],
            y1 = _link$c$split4[1],
            x2 = _link$c$split4[2],
            y2 = _link$c$split4[3];

        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
          return link;
        }
      }
      return null;
    },
    toastTransaction: function toastTransaction(t) {
      __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].toast({
        title: t.pixels + ' pixels sold!',
        message: 'To ' + __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].truncateString(t.from) + '<br />' + t.url,
        img: this.s3BaseTrx + t.hash + '-crop.jpeg',
        type: "success",
        duration: 10000
      });
      __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('toastTransaction');
    },
    toastTransactions: function toastTransactions() {
      var _this = this;

      try {
        var recentTransactions = this.transactions.slice(0, 5);
        if (!window.toastInterval) {
          window.toastInterval = setInterval(function () {
            if (recentTransactions.length > 0) {
              var t = recentTransactions.shift();
              var trxKey = 'toastedTrx-' + t.hash;
              if (localStorage.getItem(trxKey)) {
                return;
              }
              localStorage.setItem(trxKey, true);
              _this.toastTransaction(t);
            }
          }, 30000);
        }
      } catch (e) {
        console.error('toastTransactions', e);
      }
    },
    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(doReload) {
        var self;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;

                if (doReload) {
                  this.s3ImgSrc = getTsPath('homepage.jpeg');
                }
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  axios.get(self.s3LinkMap).then(function (response) {
                    self.links = response.data;
                    axios.get(getTsPath('prices.json')).then(function (response) {
                      window.pricesData = self.prices = response.data;
                      // if (doReload) {
                      //   _.times(1024/16/2, (x) => {
                      //     _.times(1024/16/2, (y) => {
                      //       window.pricesData.push({x: x, y: y, p: "100"});
                      //     });
                      //   });
                      // }
                      if (false) {
                        axios.get(self.s3TransactionsJson).then(function (response) {
                          self.transactions = response.data;
                          // self.toastTransaction(self.transactions[0]);
                          self.toastTransactions();

                          resolve();
                        });
                      } else {
                        resolve();
                      }
                    }).catch(function (error) {
                      console.log('Error loading ' + self.s3PricesJson, error);
                      reject(error);
                    });
                  }).catch(function (error) {
                    console.log('Error loading ' + self.s3LinkMap, error);
                    reject(error);
                  });
                }));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }()
  },
  created: function created() {
    this.fetchData();
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "FIYo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dob_vue__ = __webpack_require__("13aN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2433f36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dob_vue__ = __webpack_require__("Xpnt");
function injectStyle (ssrContext) {
  __webpack_require__("iDuB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a2433f36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dob_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2433f36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dob_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FQQj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bit-breaker",
    attrs: {
      "id": "million-bit-breaker"
    }
  }, [_c('div', {
    attrs: {
      "id": "game-menu"
    }
  }, [_c('div', [_c('span', {
    staticClass: "btn-group nav-buttons"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-outline-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/')
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-house",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z"
    }
  })])]), _vm._v(" "), (!_vm.isMuted) ? _c('button', {
    staticClass: "btn btn-icon btn-outline-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.mute(true)
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-volume-up-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isMuted) ? _c('button', {
    staticClass: "btn btn-icon btn-outline-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.mute(false)
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-volume-mute-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"
    }
  })])]) : _vm._e()])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('h3', [_c('span', {
    attrs: {
      "id": "score-label"
    }
  }, [_vm._v("Score")]), _vm._v(" "), _c('span', {
    staticClass: "honk-text",
    domProps: {
      "textContent": _vm._s(_vm.score)
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "game-frame"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "gameCanvas",
      "width": "1024",
      "height": "1024"
    }
  }), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    attrs: {
      "id": "game-over"
    }
  }, [_c('h1', [_vm._v("Your Score "), _c('span', {
    staticClass: "honk-text",
    domProps: {
      "textContent": _vm._s(_vm.score)
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("High Score "), _c('span', {
    staticClass: "honk-text",
    domProps: {
      "textContent": _vm._s(_vm.highscore)
    }
  })]), _vm._v(" "), (_vm.score > 0) ? _c('a', {
    staticClass: "btn btn-block btn-lg btn-outline-light",
    attrs: {
      "href": _vm.xPost,
      "target": "_blank"
    }
  }, [_vm._v("Share on X")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-lg btn-warning my-5",
    on: {
      "click": function($event) {
        return _vm.newGame();
      }
    }
  }, [_vm._v("New Game")]), _vm._v(" "), _c('div', {
    staticClass: "mt-4",
    attrs: {
      "id": "game-leaderboard"
    }
  }, [_c('h3', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Leaderboard")]), _vm._v(" "), (!_vm.appData().connectedAccount.address) ? _c('p', [_vm._v("Join the leaderboard by first connecting your wallet! "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon btn-block btn-info mt-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.connectWallet()
      }
    }
  }, [_vm._v("\n                      Connect Wallet\n                  ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-block"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-block btn-outline-light my-3",
    class: {
      'disabled': this.leaderBoardToggle === 'all'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLeaderBoard()
      }
    }
  }, [_vm._v("\n                      This Week\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon btn-block btn-outline-light my-3",
    class: {
      'disabled': this.leaderBoardToggle === 'week'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLeaderBoard()
      }
    }
  }, [_vm._v("\n                      All Time\n                  ")])]), _vm._v(" "), (_vm.appData().connectedAccount.address) ? _c('p', [_vm._v("\n                  Player: \n                  "), (_vm.appData().connectedAccount.avatar) ? _c('img', {
    staticClass: "ensAvatar",
    staticStyle: {
      "max-height": "22px"
    },
    attrs: {
      "src": _vm.appData().connectedAccount.avatar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.appData().connectedAccount.name) ? _c('span', [_vm._v(_vm._s(_vm.appData().connectedAccount.name))]) : _vm._e(), _vm._v(" "), (!_vm.appData().connectedAccount.name) ? _c('span', [_vm._v(_vm._s(_vm.appData().connectedAccount.addressTrunc))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.gameLeaderboard.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.gameLeaderboard), function(entry, index) {
    return _c('tr', {
      key: entry._id
    }, [_c('td', [_c('h5', {
      staticClass: "mr-1 honk-text"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [(entry.player.avatar) ? _c('span', [_c('img', {
      staticClass: "ensAvatar",
      staticStyle: {
        "max-height": "22px"
      },
      attrs: {
        "src": entry.player.avatar
      }
    })]) : _vm._e(), _vm._v(" "), (entry.player.name) ? _c('span', [_vm._v(_vm._s(entry.player.name))]) : _vm._e(), _vm._v(" "), (!entry.player.name && entry.player.addressTrunc) ? _c('span', [_vm._v(_vm._s(entry.player.addressTrunc))]) : _vm._e(), _vm._v(" "), (!entry.player.name && !entry.player.addressTrunc) ? _c('span', [_vm._v("Anon")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('h4', {
      staticClass: "mr-1 honk-text"
    }, [(entry.didWin) ? _c('span', {
      staticClass: "pr-2"
    }, [_vm._v("🏆")]) : _vm._e(), _vm._v(_vm._s(entry.score))])])])
  })], 2)])]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "honk-text"
  }, [_vm._v("Million Bit Break")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-left"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Player")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Score")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fvhm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Leaderboard_vue__ = __webpack_require__("IYJr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27cb39ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Leaderboard_vue__ = __webpack_require__("iDxL");
function injectStyle (ssrContext) {
  __webpack_require__("f8kC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27cb39ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Leaderboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27cb39ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Leaderboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GexG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GjOD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_S3_BUCKET_TRX = "https://millionbithomepage.com/trx/";
var BASE_S3_BUCKET = "https://millionbithomepage.com/static/billboard/";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'spaces',
  data: function data() {
    return {
      variantNavButton: 'warning',
      spaces: [],
      nextPast: 'next',
      s3Base: BASE_S3_BUCKET_TRX,
      dataSrc: BASE_S3_BUCKET + 'spaces.json?' + Date.now(),
      dataSrcPast: BASE_S3_BUCKET + 'spaces-past.json?' + Date.now()
    };
  },

  inject: ['updateAppRoute', 'appData', 'postToLambda'],
  created: function created() {
    var _this = this;

    this.updateAppRoute('spaces');
    axios.get(this.dataSrc).then(function (response) {
      _this.spacesNext = response.data;
      _this.spaces = _this.spacesNext;
    });
  },
  methods: {
    togglePastNext: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.nextPast === 'next')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return this.fetchPastSpaces();

              case 3:
                this.spaces = this.spacesPast;
                this.nextPast = 'past';
                _context.next = 9;
                break;

              case 7:
                this.spaces = this.spacesNext;
                this.nextPast = 'next';

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function togglePastNext() {
        return _ref.apply(this, arguments);
      }

      return togglePastNext;
    }(),
    fetchPastSpaces: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  axios.get(_this2.dataSrcPast).then(function (response) {
                    _this2.spacesPast = response.data;
                    resolve();
                  });
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchPastSpaces() {
        return _ref2.apply(this, arguments);
      }

      return fetchPastSpaces;
    }(),
    formatDate: function formatDate(date) {
      var d = new Date(date);
      // Format the date
      var options = {
        weekday: 'short', // "Tue"
        month: 'short', // "Sep"
        day: 'numeric', // "27"
        hour: 'numeric', // "2"
        minute: '2-digit', // "00"
        hour12: true, // "2:00 pm" (12-hour format)
        // timeZone: 'America/New_York', // Timezone for EST
        timeZoneName: 'short' // "EST"
      };

      var formattedDate = d.toLocaleString('en-US', options);
      return formattedDate;
    },
    clickSpace: function clickSpace(space) {
      console.log('clicked space', space);
    }
  }
});

/***/ }),

/***/ "HZTw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "He5e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IUNK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_S3_BUCKET_TRX = "https://millionbithomepage.com/trx/";
var BASE_S3_BUCKET = "https://millionbithomepage.com/static/billboard/";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transactions',
  data: function data() {
    return {
      toggledView: 'mint',
      pixelCount: 0,
      transactions: [],
      transactionsFiltered: [],
      s3Base: BASE_S3_BUCKET_TRX,
      dataSrc: BASE_S3_BUCKET + 'transactions.json?' + Date.now()
    };
  },

  inject: ['updateAppRoute'],
  created: function created() {
    var _this = this;

    this.updateAppRoute('list');
    axios.get(this.dataSrc).then(function (response) {
      _this.transactions = response.data;
      _this.filterTransactions();
    });
  },
  methods: {
    toggleView: function toggleView() {
      if (this.toggledView === 'mint') {
        this.toggledView = 'repaint';
      } else {
        this.toggledView = 'mint';
      }
      this.filterTransactions();
    },
    filterTransactions: function filterTransactions() {
      var _this2 = this;

      this.transactionsFiltered = this.transactions.filter(function (transaction) {
        return _this2.toggledView === 'repaint' ? transaction.isRepaint : !transaction.isRepaint;
      });
      var sum = this.transactionsFiltered.reduce(function (accumulator, currentObject) {
        return accumulator + currentObject.pixels;
      }, 0);
      this.pixelCount = sum;
    }
  }
});

/***/ }),

/***/ "IYJr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_S3_BUCKET_TRX = "https://millionbithomepage.com/trx/";
var BASE_S3_BUCKET = "https://millionbithomepage.com/static/billboard/";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'leaderboard',
  data: function data() {
    return {
      leaderboardView: 'pixels',
      teams: [{ "team": { "_id": "66c43fe72ccc6c5a634a7b42", "name": "ShibaPunkz" }, "pixels": 26368, "seqs": [{ "seq": 18, "url": "https://t.me/ShibaPunkzisBased", "hash": "0xdcdd6ddd5cdde1ba96d4bf08d293c9bd32bc7b68ffa2ebbef373850a729a9e60" }, { "seq": 17, "url": "https://shibapunkz.art", "hash": "0x68858170cd1780e88d7de85ee1de3424a420affdc91fc7a08a856dca223f75a9" }, { "seq": 19, "url": "https://x.com/luckycharmspunk?s=21&t=LNn5RtgixeELpaAbERLC8w", "hash": "0xa020ccd9986bbcd414ed151da1d57c265a73b8922447a1ba69c6a13cebe27595" }, { "seq": 20, "url": "https://x.com/Arcturus_TA", "hash": "0x0949b678a576d45cfc6a340b422e5da1e4ac632ea591b01a1f511300c4f39856" }, { "seq": 21, "url": "https://x.com/WenMoonSer420", "hash": "0xad07f85e92a2d874c01e90da199c221d1485707917fafc878d1041708d411eed" }, { "seq": 22, "url": "https://x.com/MrMeffU?t=D5srtuS1sAdZ_v_ZwogZyA&s=09", "hash": "0x934ba5e6e6b27672428de6ebeacc327acdb69b5ca40eb979147e8387b7268a54" }, { "seq": 23, "url": "https://x.com/TobiNckl", "hash": "0x4e1a732a058ddf447a1f7eeb8ab2ac5492122ffe11ad090c28bd8075c541e657" }, { "seq": 25, "url": "https://ibb.co/1QfnnCM", "hash": "0xdb6ca1560842b0426a206fd9300e9b938ea8c578f64385a8552f7985be14c479" }, { "seq": 24, "url": "https://x.com/cryptoclown85", "hash": "0xe452bd1f3addddad1fd469a5e2e8627ac18c7ff05149e36b559c6efe8ed8eccd" }, { "seq": 28, "url": "https://t.me/ShibaPunkzisBased", "hash": "0xd275eaa9cf3927c13a472403ee4297d110aaa2a675bfe12f2076f81913fe0875" }, { "seq": 29, "url": "https://x.com/b_t_furfoot", "hash": "0x8eda96fedd37a8e2b972efb41bfdc294a3c81918ac0ecf77705208d93a51d281" }, { "seq": 33, "url": "https://x.com/WenMoonSer420", "hash": "0xd6d5dbe22ce7a57ae804378ec76ed84b33a87546d22a8dc941bbbbc06a2af975" }, { "seq": 34, "url": "https://x.com/WenMoonSer420", "hash": "0x5c4de12bf767f21090ef86fb09215cfd42ddc04c6b43e75ef7b4c908d5417848" }, { "seq": 35, "url": "https://t.me/ShibaPunkzisBased", "hash": "0xcfd29ba76de65ae36c0f2806e6c55946cf450e694cdc8d40864b5d81b729bf03" }, { "seq": 36, "url": "https://magiceden.io/collections/base/0x5a0e41fff63659f64a9e328eaaf81183bf9e43cd?activeTab=items", "hash": "0xc47fbaa7a4a0b7812557b28386b1ee3a837c52f9c00618822c9bb87234762bbc" }, { "seq": 56, "url": "https://t.me/ShibaPunkzisBased", "hash": "0xa3ebbc879e2350981069b3fb844d08051b5196a3849dd8fc92ebe9ce797ba9d7" }], "rank": 1 }, { "team": { "_id": "66c43fe72ccc6c5a634a7b43", "name": "Froggi" }, "pixels": 8192, "seqs": [{ "seq": 30, "url": "https://froggi.app", "hash": "0x0b8d1bdb03b16bf88030a935e84e0f5f125c324cd0f6554c971ca798f2ed4d61" }, { "seq": 31, "url": "https://froggi.app", "hash": "0x96ac83e54a8e051eccd9956b5844b346d4302bba1dfab0e143a9fddf17d76e03" }], "rank": 2 }, { "team": { "_id": "66c43fe72ccc6c5a634a7b44", "name": "Fungi" }, "pixels": 5120, "seqs": [{ "seq": 32, "url": "https://fungifungi.art/", "hash": "0xc654f4f789f44a7b275f90ffc984155d33641c2cd031128633203f882df5a776" }, { "seq": 37, "url": "https://inscriptions.market/", "hash": "0x53d31d646cf5881d0b0e94b855e21e23658a7eac9af22c73ef0822e162c9f710" }], "rank": 3 }, { "team": { "_id": "66c43fe72ccc6c5a634a7b46", "name": "All Your Base" }, "pixels": 4096, "seqs": [{ "seq": 39, "url": "https://www.belongtous.xyz/", "hash": "0x774c599a3872142161fb36f9511128811421e01a41f3d7a4636f83b51fae48e8" }], "rank": 4 }, { "team": { "_id": "66c43fe72ccc6c5a634a7b47", "name": "Late Night on Base" }, "pixels": 4096, "seqs": [{ "seq": 40, "url": "https://x.com/latenightonbase", "hash": "0x796269e9a5aff885d10b557de4e0c777910f809c6699d9162718d101842c5549" }], "rank": 5 }, { "team": { "_id": "66c43fe72ccc6c5a634a7b45", "name": "Friendo" }, "pixels": 4096, "seqs": [{ "seq": 41, "url": "https://www.friendocoin.com/", "hash": "0x280a7bc19acebc55afa68699e5d93a04e5a393d3883e3ad32dd3861dd2d17ba3" }], "rank": 6 }, { "team": { "_id": "66c43fe72ccc6c5a634a7b48", "name": "Gems of Base" }, "pixels": 4096, "seqs": [{ "seq": 47, "url": "https://gemsofbase.com", "hash": "0x84f4689509ec537e4ba1779cd652a448bf5395cb41cec1713ee6e45b5b69772c" }], "rank": 7 }, { "team": { "_id": "66c43fe72ccc6c5a634a7b4e", "name": "Nascent" }, "pixels": 3072, "seqs": [{ "seq": 62, "url": "https://www.nascent.xyz/", "hash": "0xbb09cc6f7bd85c1404560a23b99f1c822a92109e2c38bdd5dda697c48bada308" }], "rank": 8 }, { "team": { "_id": "66c43fe72ccc6c5a634a7b49", "name": "Base Bulls" }, "pixels": 2560, "seqs": [{ "seq": 45, "url": "https://x.com/BaseBullsNFT", "hash": "0x5605445207a0f3438e3015213d55ee938fcaafd80710c3b26e9f239b9a0d3bf0" }, { "seq": 46, "url": "https://t.me/BaseBullsNFT", "hash": "0x1ac455abf4165fff1adfa33ad2a07a57e978937d8d32f4f9eda8e343ed927063" }], "rank": 9 }, { "team": { "_id": "66c43fe72ccc6c5a634a7b4d", "name": "Balt on Base" }, "pixels": 2304, "seqs": [{ "seq": 15, "url": "https://x.com/Balt_on_base", "hash": "0x11145fa24ea7cfc40a5eaa5d67e9a6f001d5baf9e1b1e2c37aaeb9d0de2e8d09" }], "rank": 10 }, { "team": { "_id": "66c43fe72ccc6c5a634a7b4c", "name": "Memgen" }, "pixels": 2304, "seqs": [{ "seq": 49, "url": "https://www.memgen.io/", "hash": "0xafe0fcb216b72110ac2a24b39a9f56b019c0c4af36e840597b8bc2d0b67cbe95" }], "rank": 11 }, { "team": { "_id": "66c43fe72ccc6c5a634a7b4b", "name": "Based Chad" }, "pixels": 2304, "seqs": [{ "seq": 53, "url": "https://basedchad.io", "hash": "0xdbc8e4c5b9c7af56f8ee3ee705f14d04a9b887baaa0fec8bedfad01de43c9930" }], "rank": 12 }],
      clicks: [],
      s3Base: BASE_S3_BUCKET_TRX,
      dataSrc: BASE_S3_BUCKET + 'leaderboard.json?' + Date.now(),
      dataSrcClicks: BASE_S3_BUCKET + 'clicks.json?' + Date.now()
    };
  },

  inject: ['updateAppRoute'],
  created: function created() {
    var _this = this;

    this.updateAppRoute('list');
    axios.get(this.dataSrc).then(function (response) {
      _this.teams = response.data;
    });
  },
  methods: {
    toggleView: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.leaderboardView = this.leaderboardView === 'pixels' ? 'clicks' : 'pixels';

                if (!(this.clicks.length === 0)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this.fetchClicks();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toggleView() {
        return _ref.apply(this, arguments);
      }

      return toggleView;
    }(),
    fetchClicks: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  axios.get(_this2.dataSrcClicks).then(function (response) {
                    _this2.clicks = response.data;
                    resolve();
                  });
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchClicks() {
        return _ref2.apply(this, arguments);
      }

      return fetchClicks;
    }()
  }
});

/***/ }),

/***/ "JQLy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy container",
    attrs: {
      "id": "million-bit-privacy"
    }
  }, [_c('h2', [_vm._v("Privacy Policy")]), _vm._v("\n        \n        \n        Effective Date: July 1st, 2024\n\n"), _c('p', [_vm._v("\nThank you for visiting the Million Bit Homepage. Your privacy and trust are essential to us, and we are committed to maintaining the confidentiality of your personal information. This Privacy Policy describes how we collect, use, and protect your information when you interact with our website.\n")]), _vm._v(" "), _c('h3', [_vm._v("1. Information We Collect")]), _vm._v(" "), _c('p', [_vm._v("\nWe collect information to better understand our users and improve the functionality and performance of the Million Bit Homepage. Information collected includes:\n")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Personal Information: When you voluntarily submit inquiries or interact with features on our site, we may collect personal information like your name, email address, wallet address, and contact details.")]), _vm._v(" "), _c('li', [_vm._v("Device and Usage Information: This includes your IP address, browser type, device information, pages you visit, the time spent on each page, and how you interact with the site. This data helps us analyze traffic and optimize the website’s performance.")]), _vm._v(" "), _c('li', [_vm._v("Cookies and Similar Technologies: We use cookies and tracking technologies to gather data on user preferences and enhance your experience on our website. You may adjust your cookie preferences through your browser settings at any time.")])]), _vm._v(" "), _c('h3', [_vm._v("2. How We Use Your Information")]), _vm._v(" "), _c('p', [_vm._v("\n  The information we collect is used for various purposes, including:\n")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Site Operations: Ensuring that our website functions smoothly, including troubleshooting and user support.")]), _vm._v(" "), _c('li', [_vm._v("Enhancement of User Experience: Personalizing your experience, understanding user preferences, and improving content and features.")]), _vm._v(" "), _c('li', [_vm._v("Communication: Responding to your inquiries and providing updates about our services, promotions, or changes to this Privacy Policy.")])]), _vm._v(" "), _c('h3', [_vm._v("3. Sharing and Disclosure of Information")]), _vm._v(" "), _c('p', [_vm._v("\nWe do not sell or rent your personal information to third parties. We may, however, disclose your information in the following scenarios:\n")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Legal Requirements: To comply with legal obligations, such as responding to lawful requests by public authorities.")]), _vm._v(" "), _c('li', [_vm._v("Protection of Rights: To enforce our website’s policies or protect our rights, privacy, safety, and property.")]), _vm._v(" "), _c('li', [_vm._v("Service Providers: We may engage third-party providers to help us operate our website. These providers are contractually obligated to handle data in a secure manner and to use it only for the specified purpose.")])]), _vm._v(" "), _c('h3', [_vm._v("4. Data Security")]), _vm._v(" "), _c('p', [_vm._v("\n  We implement reasonable security measures to protect your data against unauthorized access or disclosure. However, please understand that no data transmission over the internet can be completely secure, and we cannot guarantee the security of data shared with us.\n")]), _vm._v(" "), _c('h3', [_vm._v("5. Your Privacy Rights")]), _vm._v(" "), _c('p', [_vm._v("\nDepending on your location, you may have certain rights regarding your personal information:\n")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Access and Correction: You can request access to your personal data and correct any inaccurate information.")]), _vm._v(" "), _c('li', [_vm._v("Data Deletion: You may request the deletion of your personal data where legally applicable.")]), _vm._v(" "), _c('li', [_vm._v("Objection to Processing: In certain cases, you may object to or request a restriction on processing your data.")]), _vm._v(" "), _c('li', [_vm._v("To exercise any of these rights, please contact us at millionbithomepage@gmail.com.")])]), _vm._v(" "), _c('h3', [_vm._v("6. Cookies and Tracking Preferences")]), _vm._v(" "), _c('p', [_vm._v("\nYou can control your cookie preferences through your browser. Please note that disabling certain cookies may impact your experience on the Million Bit Homepage.\n")]), _vm._v(" "), _c('h3', [_vm._v("7. Third-Party Websites and Links")]), _vm._v(" "), _c('p', [_vm._v("\nOur website may contain links to external sites. We are not responsible for the privacy practices or content of those sites. Please review the privacy policies of those websites independently.\n")]), _vm._v(" "), _c('h3', [_vm._v("8. Changes to This Privacy Policy")]), _vm._v(" "), _c('p', [_vm._v("\nWe may update this Privacy Policy from time to time. We will post the updated policy on this page, and we encourage you to review it periodically. Any changes will be effective as of the date they are posted.\n")]), _vm._v(" "), _c('h3', [_vm._v("9. Contact Us")]), _vm._v(" "), _c('p', [_vm._v("\nIf you have any questions or concerns about this Privacy Policy, please reach out to us at:\n")]), _vm._v("\n\nEmail: millionbithomepage@gmail.com\n\n\n    ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KlKF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("L/hj");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*global axios*/

var BASE_S3_BUCKET = "https://millionbithomepage.com/static/billboard/";
var BASE_S3_BUCKET_TRX = "https://millionbithomepage.com/trx/";
var getTsPath = function getTsPath(path) {
  return '' + BASE_S3_BUCKET + path + '?' + Date.now();
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'homepage',
  data: function data() {
    return {
      links: [],
      transactions: [],
      // links: [{c: '0,0,1,1', u: 'http://google.com'}],
      s3Base: BASE_S3_BUCKET,
      s3BaseTrx: BASE_S3_BUCKET_TRX,
      s3ImgSrc: getTsPath('homepage.jpeg'), // BASE_S3_BUCKET+'homepage.jpeg?'+Date.now(),
      s3LinkMap: getTsPath('link_map.json'), // BASE_S3_BUCKET+'link_map.json?'+Date.now(),
      s3PricesJson: getTsPath('prices.json'), // BASE_S3_BUCKET+'prices.json?'+Date.now(),
      s3TransactionsJson: getTsPath('transactions.json'), // BASE_S3_BUCKET+'transactions.json?'+Date.now(),
      isBillboardLoaded: false,
      hovering: false, // To track whether the mouse is hovering over the image
      mouseX: 0, // To store the X coordinate of the mouse
      mouseY: 0, // To store the Y coordinate of the mouse
      tooltipTxt: ''
    };
  },

  inject: ['updateAppRoute', 'saveEvent', 'doUpload', 'appData'],
  methods: {
    onBillboardLoaded: function onBillboardLoaded() {
      if (!this.isBillboardLoaded) {
        // Only trigger once (since we may reload the image later)
        this.isBillboardLoaded = true;
        this.updateAppRoute('/');
      }
    },
    clickBillboard: function clickBillboard(e) {
      // console.log('clickBillboard', e, e.target, typeof e.target, e.target.coords);
      // Don't track dragging image
      if (this.appData().canBuy) {
        return;
      }
      var offsetX = e.offsetX,
          offsetY = e.offsetY;

      if (e.target && e.target.coords) {
        var link = this.getLinkFromCoords(offsetX, offsetY);
        if (link) {
          this.saveEvent('clickBillboard', {
            url: link.u,
            x: offsetX,
            y: offsetY
          });
          __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboard', { url: link.u });
          __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboard:' + link.u);
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboard:emptySpace');
        if (!this.appData().isMobileOrTouch) {
          // Don't do this on mobile
          this.doUpload(offsetX, offsetY);
        }
      }
    },
    onMouseEnter: function onMouseEnter() {
      this.hovering = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovering = false;
    },
    onMouseMove: function onMouseMove(e) {
      if (this.appData().isMobileOrTouch) {
        return;
      }
      if (this.appData().canBuy) {
        this.hovering = false;
        return;
      }
      // Get the mouse coordinates relative to the image
      var rect = e.target.getBoundingClientRect();
      this.mouseX = e.clientX - rect.left;
      this.mouseY = e.clientY - rect.top;
      // console.log(`Mouse move: ${this.mouseX}, ${this.mouseY}`, e.target.coords);
      if (e.target && e.target.coords) {
        var offsetX = e.offsetX,
            offsetY = e.offsetY;

        var link = this.getLinkFromCoords(offsetX, offsetY);
        if (link && link.u) {
          var _link$c$split = link.c.split(','),
              _link$c$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_link$c$split, 4),
              x1 = _link$c$split2[0],
              y1 = _link$c$split2[1],
              x2 = _link$c$split2[2],
              y2 = _link$c$split2[3];
          // console.log(`Mouse over link: ${link.u}`, link, x1, y1, x2, y2);


          this.$refs.tooltip.innerHTML = link.u;
        }
      } else {
        // console.log('Mouse over blank space');
        this.$refs.tooltip.innerHTML = 'Claim this space';
      }
      this.$refs.tooltip.style.left = this.mouseX + 'px';
      this.$refs.tooltip.style.top = this.mouseY - 50 + 'px';
      this.$refs.tooltip.style.marginLeft = '-' + this.$refs.tooltip.offsetWidth / 2 + 'px';
    },

    getLinkFromCoords: function getLinkFromCoords(x, y) {
      var links = this.links;
      for (var i = 0; i < links.length; i++) {
        var link = links[i];

        var _link$c$split3 = link.c.split(','),
            _link$c$split4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_link$c$split3, 4),
            x1 = _link$c$split4[0],
            y1 = _link$c$split4[1],
            x2 = _link$c$split4[2],
            y2 = _link$c$split4[3];

        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
          return link;
        }
      }
      return null;
    },
    toastTransaction: function toastTransaction(t) {
      __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].toast({
        title: t.pixels + ' pixels sold!',
        message: 'To ' + __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].truncateString(t.from) + '<br />' + t.url,
        img: this.s3BaseTrx + t.hash + '-crop.jpeg',
        type: "success",
        duration: 10000
      });
      __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('toastTransaction');
    },
    toastTransactions: function toastTransactions() {
      var _this = this;

      try {
        var recentTransactions = this.transactions.slice(0, 5);
        if (!window.toastInterval) {
          window.toastInterval = setInterval(function () {
            if (recentTransactions.length > 0) {
              var t = recentTransactions.shift();
              var trxKey = 'toastedTrx-' + t.hash;
              if (localStorage.getItem(trxKey)) {
                return;
              }
              localStorage.setItem(trxKey, true);
              _this.toastTransaction(t);
            }
          }, 30000);
        }
      } catch (e) {
        console.error('toastTransactions', e);
      }
    },
    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(doReload) {
        var self;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;

                if (doReload) {
                  this.s3ImgSrc = getTsPath('homepage.jpeg');
                }
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  axios.get(self.s3LinkMap).then(function (response) {
                    self.links = response.data;
                    axios.get(getTsPath('prices.json')).then(function (response) {
                      window.pricesData = self.prices = response.data;
                      // if (doReload) {
                      //   _.times(1024/16/2, (x) => {
                      //     _.times(1024/16/2, (y) => {
                      //       window.pricesData.push({x: x, y: y, p: "100"});
                      //     });
                      //   });
                      // }
                      axios.get(self.s3TransactionsJson).then(function (response) {
                        self.transactions = response.data;
                        // self.toastTransaction(self.transactions[0]);
                        self.toastTransactions();

                        resolve();
                      });
                    }).catch(function (error) {
                      console.log('Error loading ' + self.s3PricesJson, error);
                      reject(error);
                    });
                  }).catch(function (error) {
                    console.log('Error loading ' + self.s3LinkMap, error);
                    reject(error);
                  });
                }));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }()
  },
  created: function created() {
    this.fetchData();
  },
  mounted: function mounted() {
    var _this2 = this;

    // Do popup on first visit
    var DID_SEE_WELCOME_SCREEN_KEY = 'DID_SEE_WELCOME_SCREEN';
    if (!localStorage.getItem(DID_SEE_WELCOME_SCREEN_KEY)) {
      setTimeout(function () {
        localStorage.setItem(DID_SEE_WELCOME_SCREEN_KEY, true);
        _this2.$bvModal.show('modal-intro');
      }, 5000);
    }
  }
});

/***/ }),

/***/ "L/hj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

// import Vue from 'vue'

// Toast function
function toast(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? "" : _ref$title,
      _ref$message = _ref.message,
      message = _ref$message === undefined ? "" : _ref$message,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "info" : _ref$type,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 3000 : _ref$duration,
      _ref$img = _ref.img,
      img = _ref$img === undefined ? "" : _ref$img;

  var main = document.getElementById("toast");
  if (main) {
    var _toast = document.createElement("div");

    // Auto remove toast
    var autoRemoveId = setTimeout(function () {
      main.removeChild(_toast);
    }, duration + 1000);

    // Remove toast when clicked
    _toast.onclick = function (e) {
      // if (e.target.closest(".toast_close")) {
      main.removeChild(_toast);
      clearTimeout(autoRemoveId);
      // }
    };

    var delay = (duration / 1000).toFixed(2);

    _toast.classList.add("toaster", "toast-" + type);
    _toast.style.animation = "slideInLeft ease .3s, fadeOut linear 1s " + delay + "s forwards";

    _toast.innerHTML = "\n                    <div class=\"toast_icon\">\n                        <img src=\"" + img + "\" />\n                    </div>\n                    <div class=\"toast_body\">\n                        <h3 class=\"toast_title\">" + title + "</h3>\n                        <p class=\"toast_msg\">" + message + "</p>\n                    </div>\n                ";
    main.appendChild(_toast);
  }
}

function isMobileOrTouch() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

var convertChainIdToCoinType = function convertChainIdToCoinType(chainId) {
  // L1 resolvers to addr
  if (chainId === 1) {
    // 1 is mainnet chain id
    return 'addr';
  }
  var cointype = (0x80000000 | chainId) >>> 0;
  return cointype.toString(16).toLocaleUpperCase();
};
var convertReverseNodeToBytes = function convertReverseNodeToBytes(address, chainId) {
  var addressFormatted = address.toLowerCase();
  var addressNode = ethers.solidityPackedKeccak256(['string'], [addressFormatted.substring(2)]); // NOTE: hash it as a string not address
  var chainCoinType = convertChainIdToCoinType(chainId);
  var baseReverseNode = ethers.namehash(chainCoinType.toLocaleUpperCase() + ".reverse");
  var addressReverseNode = ethers.solidityPackedKeccak256(['bytes32', 'bytes32'], [baseReverseNode, addressNode]);
  return addressReverseNode;
};

function getHexFromRgb(r, g, b) {
  return ("0" + r.toString(16)).slice(-2) + ("0" + g.toString(16)).slice(-2) + ("0" + b.toString(16)).slice(-2);
}

function getPixelsData(myImageData, width, height) {
  var pixels_arr = [];
  var p = 0;
  for (var i in myImageData) {
    if (i % 4 === 0) {
      pixels_arr[p] = {
        "r": myImageData[i]
      };
    } else if (i % 4 === 1) {
      pixels_arr[p]["g"] = myImageData[i];
    } else if (i % 4 === 2) {
      pixels_arr[p]["b"] = myImageData[i];
    } else if (i % 4 === 3) {
      pixels_arr[p]["a"] = myImageData[i];
      // log(pixels_arr[p]["a"])
      pixels_arr[p]["hex"] = getHexFromRgb(pixels_arr[p]["r"], pixels_arr[p]["g"], pixels_arr[p]["b"]);
      // if(p % canvas.width == 0) {
      //   log(pixels_arr[p])
      // }
      p++;
    }
  }

  var rows = [];
  var ha = new Array(height / 16);
  var wa = new Array(width / 16);
  for (var hi = 0; hi < ha.length; hi++) {
    // for each vertical section
    var cols = [];
    for (var wi = 0; wi < wa.length; wi++) {
      // for each horizontal section
      cols.push([]);
    }
    rows.push(cols);
  }

  // rows is multidimension array to hold image data

  var _loop = function _loop(row) {
    // for each vertical section
    _.times(16, function (y) {
      var _loop2 = function _loop2(col) {
        // for each horizontal section
        _.times(16, function (x) {
          rows[row][col].push(pixels_arr.shift());
        });
      };

      for (var col = 0; col < wa.length; col++) {
        _loop2(col);
      }
    });
  };

  for (var row = 0; row < ha.length; row++) {
    _loop(row);
  }

  return rows;
}

function stringDataForEth(arr, url, bid, r, c, img_offset_x, img_offset_y) {
  var DATA_ENCODING_VERSION = 1;
  // for(var i in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]) {
  //   for(var ii in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]) {
  //     is.push(""+i+","+ii+"#0000ff");
  //   }
  // }
  // log('window offset', window.img_offset_x, window.img_offset_y);
  // log('STRING DATA FOR PIXEL DATA', arr, r, c, typeof r, typeof c)

  if (typeof r === 'string') {
    r = parseInt(r, 10);
  }
  if (typeof c === 'string') {
    c = parseInt(c, 10);
  }

  var colors = [];
  for (var i in arr) {
    var p = arr[i];
    colors.push(p['hex']);
  }
  var xOffset = img_offset_x / 16 + c;
  var yOffset = img_offset_y / 16 + r;
  // log('stringDataForEth', window.img_offset_x, window.img_offset_y, xOffset, yOffset, c, r);
  return "v" + DATA_ENCODING_VERSION + "|" + xOffset + "," + yOffset + "|" + colors.join(',') + "|" + bid + "|" + encodeURIComponent(url);
}

var localStorage = {
  setItem: function setItem(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      console.error('Failed to set localstorage item', e);
    }
  },
  getItem: function getItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      console.error('Failed to get localstorage item', e);
    }
  },
  removeItem: function removeItem(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      console.error('Failed to remove localstorage item', e);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  localStorage: localStorage,
  getHexFromRgb: getHexFromRgb,
  getPixelsData: getPixelsData,
  stringDataForEth: stringDataForEth,
  convertReverseNodeToBytes: convertReverseNodeToBytes,
  truncateString: function truncateString(str) {
    return str.substring(0, 6) + '...' + str.substring(str.length - 4);
  },
  trackEvent: function trackEvent(t) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    try {
      if (window.gtag) {
        gtag('event', t, params);
      }
    } catch (e) {
      console.error('Failed to track event', e);
    }
  },

  replaceTransparent: function replaceTransparent(myImageData) {
    for (var i = 0, n = myImageData.length; i < n; i += 4) {
      // var r = myImageData[i],
      //     g = myImageData[i+1],
      //     b = myImageData[i+2],
      //     a = myImageData[i+3]

      // Completely transparent
      if (myImageData[i + 3] === 0) {
        // Set to solid white
        myImageData[i] = 255;
        myImageData[i + 1] = 255;
        myImageData[i + 2] = 255;
        myImageData[i + 3] = 255;
      }
    }
  },
  clearDraggableImage: function clearDraggableImage() {
    // Clear the draggable image from the page
    var uploadedImgCanvas = document.getElementById("uploadedImg");
    var uploadedImgCtx = uploadedImgCanvas.getContext("2d");
    uploadedImgCtx.clearRect(0, 0, uploadedImgCanvas.width, uploadedImgCanvas.height);
    uploadedImgCanvas.style.display = 'none';
  },
  confetti: function confetti(partyTime) {

    var Confettiful = function Confettiful(el) {
      document.querySelector('.confetti-wrapper').style.display = 'block';
      this.el = el;
      this.containerEl = null;

      this.confettiFrequency = 3;
      this.confettiColors = ['#ff0000', '#00ff00', '#0000ff', '#00ffff', '#ff00ff', '#ffff00'];
      this.confettiAnimations = ['slow', 'medium', 'fast'];

      this._setupElements();
      this._renderConfetti();
    };

    Confettiful.prototype._setupElements = function () {
      var containerEl = document.createElement('div');
      var elPosition = this.el.style.position;

      if (elPosition !== 'relative' || elPosition !== 'absolute') {
        this.el.style.position = 'relative';
      }

      containerEl.classList.add('confetti-container');

      this.el.appendChild(containerEl);

      this.containerEl = containerEl;
    };

    Confettiful.prototype._renderConfetti = function () {
      var _this = this;

      this.confettiInterval = setInterval(function () {
        var confettiEl = document.createElement('div');
        var confettiSize = Math.floor(Math.random() * 3) + 12 + 'px';
        var confettiBackground = _this.confettiColors[Math.floor(Math.random() * _this.confettiColors.length)];
        var confettiLeft = Math.floor(Math.random() * _this.el.offsetWidth) + 'px';
        var confettiAnimation = _this.confettiAnimations[Math.floor(Math.random() * _this.confettiAnimations.length)];

        confettiEl.classList.add('confetti', 'confetti--animation-' + confettiAnimation);
        confettiEl.style.left = confettiLeft;
        confettiEl.style.width = confettiSize;
        confettiEl.style.height = confettiSize;
        confettiEl.style.backgroundColor = confettiBackground;

        confettiEl.removeTimeout = setTimeout(function () {
          confettiEl.parentNode.removeChild(confettiEl);
        }, 3000);

        _this.containerEl.appendChild(confettiEl);
      }, 25);
    };
    Confettiful.prototype.stop = function () {
      // this.el.display = 'none';
      document.querySelector('.confetti-wrapper').style.display = 'none';
      clearInterval(this.confettiInterval);
    };

    window.confettiful = new Confettiful(document.querySelector('.js-container'));

    setTimeout(function () {
      window.confettiful.stop();
    }, partyTime);
  },
  toast: toast,
  isMobileOrTouch: isMobileOrTouch,
  wait: function wait(ms) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      return setTimeout(resolve, ms);
    });
  }
});

/***/ }),

/***/ "LqzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'terms',
  data: function data() {
    return {};
  },

  inject: ['updateAppRoute', 'appData', 'postToLambda'],
  created: function created() {
    this.updateAppRoute('terms');
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("iaho");
function injectStyle (ssrContext) {
  __webpack_require__("yA2K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MjUn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drop_vue__ = __webpack_require__("pjtm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_355e8e9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Drop_vue__ = __webpack_require__("tttU");
function injectStyle (ssrContext) {
  __webpack_require__("lebo")
  __webpack_require__("GexG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-355e8e9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_355e8e9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Drop_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







if (window.Sentry) {
  Sentry.onLoad(function () {
    Sentry.init({
      // Performance Monitoring
      tracesSampleRate: 1.0, // Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  });
}

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].directive('lazy-load', {
  inserted: function inserted(el) {
    function loadImage() {
      var imageElement = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(el.children).find(function (el) {
        return el.nodeName === "IMG";
      });
      if (imageElement) {
        imageElement.addEventListener('load', function () {
          setTimeout(function () {
            return el.classList.add('loaded');
          }, 100);
        });
        imageElement.addEventListener('error', function () {
          return console.log('error');
        });
        imageElement.src = imageElement.dataset.url;
      }
    }

    function handleIntersect(entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadImage();
          observer.unobserve(el);
        }
      });
    }

    function createObserver() {
      var options = {
        root: null,
        threshold: "0"
      };
      var observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(el);
    }

    if (window["IntersectionObserver"]) {
      createObserver();
    } else {
      loadImage();
    }
  }
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] }
});

/***/ }),

/***/ "NZaW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__ = __webpack_require__("IUNK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b1b3d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__ = __webpack_require__("FE7F");
function injectStyle (ssrContext) {
  __webpack_require__("sTm+")
  __webpack_require__("dRIF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52b1b3d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b1b3d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PD8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spaces container",
    attrs: {
      "id": "million-bit-spaces"
    }
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Based Spaces")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Twitter X Base spaces that are hosted by members of the MBH community.")]), _vm._v(" "), _c('h3', [_vm._v("Coming up " + _vm._s(_vm.nextPast === 'next' ? 'next' : 'past') + " "), _c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.togglePastNext
    }
  }, [_vm._v(_vm._s(_vm.nextPast === 'next' ? 'Past' : 'Next'))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-link btn-sm float-right",
    attrs: {
      "href": "https://calendar.google.com/calendar/embed?src=ab4b8a40f14e89db94afb2cbaf4fbef2476606632ba430555522f35c1380374a%40group.calendar.google.com&ctz=America%2FLos_Angeles",
      "target": "_blank"
    }
  }, [_vm._v("Calendar")])]), _vm._v(" "), _c('div', {
    staticClass: "space-events"
  }, _vm._l((_vm.spaces), function(space) {
    return _c('a', {
      key: space._id,
      attrs: {
        "href": 'https://x.com/i/spaces/' + space.id,
        "target": "_blank"
      }
    }, [_c('h4', [_c('img', {
      attrs: {
        "src": space.creator.profile_image_url
      }
    }), _vm._v(" " + _vm._s(space.creator.name))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(space.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.formatDate(space.scheduled_start_at)))])])
  }), 0)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PHjy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QK0B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qfom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__ = __webpack_require__("KlKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59e55d30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__ = __webpack_require__("pEEw");
function injectStyle (ssrContext) {
  __webpack_require__("AlKc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59e55d30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59e55d30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
    WEBHOOK_URL: 'https://ta2f7ylhwu46yoen7xk2pvueee0qtjjt.lambda-url.us-west-2.on.aws/',
    NFT_CA: '0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e',
    NFT_ABI: __webpack_require__("lxEZ"),
    TOKEN_CA: '0x6e1307cb2e16e53718d9a69026c14a4dd1ee2e24',
    TANG_CA: '0xCC3ABa72BB8D3e38745b4FB9941141a85B3b1fd8',
    NFT_TANG_CA: '0xf9257167ea5f0bffd4f1c727a2c35a00ac1dea90',
    SUBPAGES: {
        TANG: {
            TOKEN_CA: '0xCC3ABa72BB8D3e38745b4FB9941141a85B3b1fd8',
            NFT_CA: '0xf9257167ea5f0bffd4f1c727a2c35a00ac1dea90'
        },
        DOB: {
            TOKEN_CA: '0x0B7056f5e82B254D93BD9A1C860ff069340f347f',
            NFT_CA: '0xdd49c98ba4308ce2c6d11cc37a9040827096bee7'
        },
        PREME: {
            TOKEN_CA: '0x6e1307cb2e16e53718d9a69026c14a4dd1ee2e24',
            NFT_CA: '0x79bd982be6446be8d42497c149b2efe4d3e1f53d',
            canUseEth: true
        }
    },
    TOKEN_ABI: __webpack_require__("BEit"),
    LOCAL_STORAGE_KEYS: {
        NEWSLETTER_SUBSCRIBED: 'NEWSLETTER_SUBSCRIBED'
    }
};
/* harmony default export */ __webpack_exports__["a"] = (config);

// const transferABI = [
//     // {
//     //   name: "transfer",
//     //   type: "function",
//     //   inputs: [
//     //     {
//     //       name: "_to",
//     //       type: "address",
//     //     },
//     //     {
//     //       type: "uint256",
//     //       name: "_tokens",
//     //     },
//     //   ],
//     //   constant: false,
//     //   outputs: [],
//     //   payable: false,
//     // },
//     {
//       "inputs": [
//         {
//           "internalType": "address",
//           "name": "to",
//           "type": "address"
//         },
//         {
//           "internalType": "uint256",
//           "name": "value",
//           "type": "uint256"
//         },
//         {
//           "internalType": "string",
//           "name": "paintData",
//           "type": "string"
//         }
//       ],
//       "name": "paint",
//       "outputs": [
//         {
//           "internalType": "bool",
//           "name": "",
//           "type": "bool"
//         }
//       ],
//       "stateMutability": "nonpayable",
//       "type": "function"
//     },

//     {
//       "inputs": [
//         {
//           "internalType": "address",
//           "name": "owner",
//           "type": "address"
//         }
//       ],
//       "name": "balanceOf",
//       "outputs": [
//         {
//           "internalType": "uint256",
//           "name": "",
//           "type": "uint256"
//         }
//       ],
//       "stateMutability": "view",
//       "type": "function"
//     },
//     {
//       "inputs": [
//           {
//               "internalType": "address",
//               "name": "spender",
//               "type": "address"
//           },
//           {
//               "internalType": "uint256",
//               "name": "value",
//               "type": "uint256"
//           }
//       ],
//       "name": "approve",
//       "outputs": [
//           {
//               "internalType": "bool",
//               "name": "",
//               "type": "bool"
//           }
//       ],
//       "stateMutability": "nonpayable",
//       "type": "function"
//     },
//   ];

/***/ }),

/***/ "Rp40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__("LqzL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fddcf35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__("Xmpb");
function injectStyle (ssrContext) {
  __webpack_require__("4sUT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fddcf35"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fddcf35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S/ZD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "million-bit-demo"
    }
  }, [_c('div', {
    attrs: {
      "id": "close-demo"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close()
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Back")])]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "/static/mobile-demo-pfp.webm",
      "autoplay": "",
      "controls": ""
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TAa6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plots",
    attrs: {
      "id": "million-bit-plots"
    }
  }, [_c('h2', {
    staticClass: "mb-4 honk-text"
  }, [_vm._v("My Plots")]), _vm._v(" "), (!_vm.appData().connectedAccount.address) ? _c('p', [_vm._v("Connect your wallet to view your plots")]) : _vm._e(), _vm._v(" "), (_vm.nfts.length > 0) ? _c('div', _vm._l((_vm.nfts), function(nft, index) {
    return _c('div', {
      key: nft.tokenId,
      staticClass: "nft-card"
    }, [_c('img', {
      ref: 'cardImage-' + index,
      refInFor: true,
      staticClass: "plot-nft",
      attrs: {
        "src": nft.image,
        "alt": "NFT Image"
      }
    }), _vm._v(" "), _c('canvas', {
      ref: 'canvas-' + index,
      refInFor: true,
      attrs: {
        "width": nft.width,
        "height": nft.height
      }
    }), _vm._v(" "), _c('p', [_c('input', {
      ref: 'fileInput-' + index,
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "ref": "fileInputs",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, index, nft)
        }
      }
    })]), (nft.showForm) ? _c('div', {}, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nft.link),
        expression: "nft.link"
      }],
      staticClass: "form-control form-control-md mb-2",
      attrs: {
        "type": "text",
        "placeholder": "Enter the URL of the new image"
      },
      domProps: {
        "value": (nft.link)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nft, "link", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-warning btn-block mb-4",
      attrs: {
        "disabled": nft.isLoading
      },
      on: {
        "click": function($event) {
          return _vm.submitNewImage(index, nft)
        }
      }
    }, [_vm._v("SAVE")]), _vm._v(" "), (nft.isLoading) ? _c('div', {
      staticClass: "loader"
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "btn-group btn-block"
    }, [_c('a', {
      staticClass: "btn btn-outline-primary",
      attrs: {
        "href": 'https://magiceden.us/item-details/base/' + _vm.contractAddress + '/' + nft.tokenId,
        "target": "_blank"
      }
    }, [_vm._v("Marketplace")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-outline-primary",
      attrs: {
        "href": "#",
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.repaint(index, nft)
        }
      }
    }, [_vm._v("Repaint")])]), _vm._v(" "), _c('ul', {
      staticClass: "p-0"
    }, _vm._l((nft.attributes), function(value, key) {
      return (value.trait_type !== 'X1' && value.trait_type !== 'Y1' && value.trait_type !== 'X2' && value.trait_type !== 'Y2') ? _c('li', {
        key: key
      }, [_c('strong', [_vm._v(_vm._s(value.trait_type) + ":")]), _vm._v(" " + _vm._s(value.value) + "\n                  ")]) : _vm._e()
    }), 0), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr')])
  }), 0) : _c('div', [_c('div', [_c('p', [_vm._v("Connect your wallet to see your plot NFTs here. Then you can repaint your pixels 👩‍🎨")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.getNFTs
    }
  }, [_vm._v("Refresh")]), _vm._v(" "), (_vm.nftsLoading) ? _c('div', [_c('span', [_vm._v("Loading...")])]) : _vm._e()])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-repaint-success",
      "title": "You're a part of onchain history!",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('p', [_vm._v("\n      Your repainted plot has been submitted. "), (_vm.trxHashSuccess) ? _c('a', {
    attrs: {
      "href": 'https://basescan.org/tx/' + _vm.trxHashSuccess,
      "target": "_blank"
    }
  }, [_vm._v("View transaction")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n      Please allow a few minutes for the transaction to be confirmed.\n    ")])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UdSD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xmpb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms container",
    attrs: {
      "id": "million-bit-terms"
    }
  }, [_c('h2', [_vm._v("Terms & Conditions")]), _vm._v(" "), _c('p', [_vm._v("\n          Effective Date: July 1st, 2024\n        ")]), _vm._v(" "), _c('p', [_vm._v("\nWelcome to the Million Bit Homepage! We are committed to protecting your privacy and ensuring your experience on our website is safe. This Privacy Policy outlines how we collect, use, and protect your information. By using our website, you agree to the terms in this Privacy Policy.\n")]), _vm._v(" "), _c('h3', [_vm._v("1. Information We Collect")]), _vm._v(" "), _c('p', [_vm._v("\nWe may collect different types of information when you visit the Million Bit Homepage, including:\n")]), _vm._v(" "), _c('p', [_vm._v("\nPersonal Information: When you contact us or interact with certain parts of the website, we may collect your name, email address, or other contact details.\nUsage Data: This includes information about how you interact with our website, such as your IP address, browser type, pages viewed, and other usage details.\n")]), _vm._v(" "), _c('h3', [_vm._v("2. How We Use Your Information")]), _vm._v(" "), _c('p', [_vm._v("\nWe use the collected information for various purposes, such as:\n")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("To provide and improve our website’s features and content")]), _vm._v(" "), _c('li', [_vm._v("To communicate with you regarding inquiries, updates, or promotions")]), _vm._v(" "), _c('li', [_vm._v("To analyze and understand how users interact with the website, allowing us to make improvements")])]), _vm._v(" "), _c('h3', [_vm._v("3. Sharing Your Information")]), _vm._v(" "), _c('p', [_vm._v("\nWe value your privacy and will not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as necessary to:\n")]), _vm._v(" "), _c('p', [_c('ul', [_c('li', [_vm._v("Comply with legal obligations or government requests")]), _vm._v(" "), _c('li', [_vm._v("Enforce our website’s policies or protect our rights and safety")]), _vm._v(" "), _c('li', [_vm._v("Collaborate with trusted service providers who assist us in operating our website")])])]), _vm._v(" "), _c('h3', [_vm._v("4. Security")]), _vm._v(" "), _c('p', [_vm._v("\nWe take reasonable measures to protect your information from unauthorized access or disclosure. However, please remember that no data transmission over the internet can be guaranteed to be completely secure.\n")]), _vm._v(" "), _c('h3', [_vm._v("5. Your Rights")]), _vm._v(" "), _c('p', [_vm._v("\nDepending on your location, you may have certain rights regarding your personal information, such as:\n")]), _vm._v(" "), _c('p', [_c('ul', [_c('li', [_vm._v("The right to access, update, or delete your personal data")]), _vm._v(" "), _c('li', [_vm._v("The right to object to processing or request data portability")]), _vm._v(" "), _c('li', [_vm._v("To exercise these rights, please contact us at millionbithomepage@gmail.com.")])])]), _vm._v(" "), _c('h3', [_vm._v("6. Third-Party Links")]), _vm._v(" "), _c('p', [_vm._v("\nOur website may contain links to other websites. We are not responsible for the privacy practices or content of those sites. Please review their privacy policies independently.\n")]), _vm._v(" "), _c('h3', [_vm._v("7. Updates to this Privacy Policy")]), _vm._v(" "), _c('p', [_vm._v("\nWe may update this Privacy Policy periodically. We will notify you of significant changes by posting the new policy on this page and updating the effective date above.\n")]), _vm._v(" "), _c('h3', [_vm._v("8. Contact Us")]), _vm._v(" "), _c('p', [_vm._v("\nIf you have any questions about this Privacy Policy, please contact us at:\n")]), _vm._v(" "), _c('p', [_vm._v("\nEmail: millionbithomepage@gmail.com\n")]), _vm._v(" "), _c('hr')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xpnt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "billboard",
    class: {
      'showTooltip': _vm.hovering
    },
    attrs: {
      "id": "million-bit-billboard"
    },
    on: {
      "click": _vm.clickBillboard,
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "mousemove": _vm.onMouseMove
    }
  }, [_c('canvas', {
    attrs: {
      "id": "uploadedImg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.s3ImgSrc,
      "usemap": "#linkmap"
    },
    on: {
      "load": _vm.onBillboardLoaded
    }
  }), _vm._v(" "), _c('map', {
    attrs: {
      "name": "linkmap"
    }
  }, _vm._l((_vm.links), function(link) {
    return _c('area', {
      attrs: {
        "target": "_blank",
        "alt": "",
        "title": "",
        "shape": "rect",
        "coords": link.c,
        "href": link.u
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    ref: 'tooltip',
    attrs: {
      "id": "billboard-tooltip"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YGEE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("L/hj");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_S3_BUCKET = "https://millionbithomepage.com/static/billboard/";
var LOCAL_STORAKE_BREAK_HIGHSCORE_KEY = 'break_highscore';
var LOCAL_STORAGE_BREAK_MUTE_KEY = 'break_muted';
var sfx = {
    bounce: new Audio('/static/bounce.mp3'),
    gameover: new Audio('/static/gameover.mp3'),
    gamestart: new Audio('/static/gamestart.mp3'),
    gamewin: new Audio('/static/gamewin.mp3')
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'classic',
    data: function data() {
        return {
            isMuted: false,
            gameLeaderboard: [],
            leaderBoardToggle: 'week',
            s3Base: BASE_S3_BUCKET,
            s3ImgSrc: BASE_S3_BUCKET + 'homepage.jpeg?' + Date.now(),
            s3LinkMap: BASE_S3_BUCKET + 'link_map.json?' + Date.now(),
            score: 0,
            highscore: localStorage.getItem(LOCAL_STORAKE_BREAK_HIGHSCORE_KEY) || 0,
            isPlaying: false,
            // User Paddle
            speed: 0, // Starting speed
            acceleration: 0.5, // Speed increment over time
            maxSpeed: 10, // Maximum speed limit
            movementInterval: null, // To store the interval ID for movement
            movingLeft: false,
            movingRight: false,
            linkMap: []
        };
    },

    computed: {
        xPost: function xPost() {
            return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent('🕹️ I just scored ' + this.score + ' on Million Bit Break! Can you beat my score?') + '&url=' + encodeURIComponent('https://millionbithomepage.com/break');
        }
    },
    methods: {
        newGame: function newGame() {
            this.playGame();
            this.playSound('gamestart');
        },
        mute: function mute(doMute) {
            this.isMuted = doMute;
            localStorage.setItem(LOCAL_STORAGE_BREAK_MUTE_KEY, this.isMuted);
        },
        toggleLeaderBoard: function toggleLeaderBoard() {
            if (this.leaderBoardToggle === 'all') {
                this.leaderBoardToggle = 'week';
            } else {
                this.leaderBoardToggle = 'all';
            }
            this.gameLeaderboard = this.leaderBoardToggle === 'all' ? this.gameLeaderboards.all : this.gameLeaderboards.week;
        },
        playSound: function playSound(sound) {
            if (this.isMuted) {
                return;
            }
            sfx[sound].currentTime = 0;
            sfx[sound].play();
        },
        saveScore: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(score, didWin) {
                var player;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                player = this.appData().connectedAccount;
                                _context.next = 3;
                                return this.postToLambda('recordBreakScore', {
                                    score: score,
                                    player: player,
                                    didWin: didWin
                                });

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function saveScore(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return saveScore;
        }(),
        endGame: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(didWin) {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this.isPlaying) {
                                    _context2.next = 10;
                                    break;
                                }

                                this.isPlaying = false;
                                if (didWin) {
                                    this.playSound('gamewin');
                                    __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].confetti(12000);
                                } else {
                                    this.playSound('gameover');
                                }

                                if (!this.score) {
                                    _context2.next = 8;
                                    break;
                                }

                                _context2.next = 6;
                                return this.saveScore(this.score, didWin);

                            case 6:
                                __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('breakScore:' + this.score);
                                if (this.score > this.highscore) {
                                    this.highscore = this.score;
                                    localStorage.setItem(LOCAL_STORAKE_BREAK_HIGHSCORE_KEY, this.highscore);
                                }

                            case 8:
                                _context2.next = 10;
                                return this.loadLeaderboard();

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function endGame(_x3) {
                return _ref2.apply(this, arguments);
            }

            return endGame;
        }(),
        loadLeaderboard: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.postToLambda('getBreakLeaderboard', {});

                            case 2:
                                this.gameLeaderboards = _context3.sent;

                                this.gameLeaderboard = this.leaderBoardToggle === 'all' ? this.gameLeaderboards.all : this.gameLeaderboards.week;

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function loadLeaderboard() {
                return _ref3.apply(this, arguments);
            }

            return loadLeaderboard;
        }(),
        playGame: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var _this = this;

                var self, canvas, ctx, ball, paddle, bricks, backgroundImage, svgMarkup, svgDataUrl, paddleImg, initGame, setCanvasSize, initGameObjects, initBricks, moveHandler, drawBackground, drawBall, drawPaddle, drawBricks, hitBrick, isColliding, collisionDetection, ballBounce, lastTime, draw;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                drawPaddle = function drawPaddle() {
                                    ctx.beginPath();
                                    ctx.rect(paddle.x, paddle.y, paddle.width, paddle.height);
                                    ctx.fillStyle = '#000';
                                    ctx.fill();
                                    ctx.closePath();
                                };

                                drawBall = function drawBall() {
                                    ctx.drawImage(paddleImg, ball.x, ball.y, ball.radius * 2, ball.radius * 2);
                                };

                                drawBackground = function drawBackground() {
                                    ctx.drawImage(backgroundImage, 0, 0, canvas.width, canvas.width);
                                };

                                moveHandler = function moveHandler(e) {
                                    var relativeX = void 0;
                                    if (e.type === 'mousemove') {
                                        relativeX = e.clientX - canvas.offsetLeft;
                                    } else if (e.type === 'touchmove') {
                                        e.preventDefault(); // Prevent scrolling when touching the canvas
                                        relativeX = e.touches[0].clientX - canvas.offsetLeft;
                                    }

                                    if (relativeX > 0 && relativeX < canvas.width) {
                                        paddle.x = relativeX - paddle.width / 2;
                                    }
                                };

                                initGameObjects = function initGameObjects() {
                                    // Initialize ball
                                    ball = {
                                        // Start at random position between 1/3 and 2/3 of canvas width
                                        x: canvas.width / 3 + Math.random() * canvas.width / 3,
                                        // x: canvas.width / 1.5,
                                        y: canvas.height - canvas.height * 0.1 - 10,
                                        dx: 3, //2,
                                        dy: -3, //-2,
                                        radius: canvas.width * 0.01
                                    };

                                    // Initialize paddle
                                    paddle = {
                                        width: canvas.width * 0.15,
                                        height: canvas.height * 0.03,
                                        x: (canvas.width - canvas.width * 0.15) / 2,
                                        y: canvas.height - canvas.height * 0.1
                                    };
                                    self.paddle = paddle;

                                    // Initialize bricks
                                    initBricks();
                                };

                                setCanvasSize = function setCanvasSize() {
                                    var maxWidth = Math.min(1024, window.innerWidth);
                                    var maxHeight = window.innerHeight - 60;
                                    var aspectRatioW = 3;
                                    var aspectRatioH = 4;
                                    if (maxWidth / aspectRatioW * aspectRatioH <= maxHeight) {
                                        // If we can fit 3:4 aspect ratio, use it
                                        canvas.width = maxWidth;
                                        canvas.height = maxWidth / aspectRatioW * aspectRatioH;
                                    } else {
                                        // Otherwise, use the max height and calculate width
                                        canvas.height = maxHeight;
                                        canvas.width = maxHeight / aspectRatioH * aspectRatioW;
                                    }

                                    // Ensure width doesn't exceed maxWidth
                                    canvas.width = Math.min(canvas.width, maxWidth);
                                };

                                initGame = function initGame() {
                                    setCanvasSize();
                                    initGameObjects();
                                };

                                self = this;

                                __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('playGame:break');
                                this.isPlaying = true;
                                this.score = 0;

                                // Canvas setup
                                canvas = document.getElementById('gameCanvas');

                                this.canvas = canvas;
                                ctx = canvas.getContext('2d');

                                // Game objects

                                ball = void 0, paddle = void 0, bricks = void 0;

                                // Background image object

                                backgroundImage = new Image();

                                backgroundImage.src = 'https://millionbithomepage.com/static/billboard/homepage.jpeg'; // Replace with your image path

                                // SVG markup
                                svgMarkup = '\n<svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28Z" fill="#1B53E4"/>\n    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 28c0 11.598 9.402 21 21 21s21-9.402 21-21S39.598 7 28 7 7 16.402 7 28Zm17.234-6.766a3 3 0 0 0-3 3v7.533a3 3 0 0 0 3 3h7.533a3 3 0 0 0 3-3v-7.533a3 3 0 0 0-3-3h-7.533Z" fill="#fff"/>\n</svg>';

                                // Convert SVG to data URL

                                svgDataUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgMarkup);

                                // Create an image object

                                paddleImg = new Image();

                                paddleImg.src = svgDataUrl;

                                // Set canvas size and initialize game objects

                                initBricks = function initBricks() {
                                    bricks = [];

                                    var scale = canvas.width / 1024;

                                    // For each entry in this.linkMap, create a brick
                                    _this.linkMap.forEach(function (link) {
                                        var _link$c$split = link.c.split(','),
                                            _link$c$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_link$c$split, 4),
                                            x1 = _link$c$split2[0],
                                            y1 = _link$c$split2[1],
                                            x2 = _link$c$split2[2],
                                            y2 = _link$c$split2[3];

                                        var x0 = parseInt(x1);
                                        var y0 = parseInt(y1);
                                        x1 = parseInt(x1) * scale;
                                        y1 = parseInt(y1) * scale;
                                        x2 = parseInt(x2) * scale;
                                        y2 = parseInt(y2) * scale;

                                        bricks.push({
                                            x0: x0,
                                            y0: y0,
                                            x: x1,
                                            y: y1,
                                            width: x2 - x1 + 1,
                                            height: y2 - y1 + 1,
                                            status: 1
                                            // url: link.u
                                        });
                                    });
                                };

                                // Call initGame on load and resize


                                initGame();
                                window.addEventListener('resize', function () {
                                    _this.endGame();
                                    initGame();
                                });

                                // Event listeners for mouse and touch
                                canvas.addEventListener('mousemove', moveHandler);
                                canvas.addEventListener('touchmove', moveHandler);

                                // Drawing functions


                                // Drawing functions

                                drawBricks = function drawBricks() {
                                    // For each brick, draw it
                                    var hasBricks = false;
                                    bricks.forEach(function (brick) {
                                        if (brick.status === 0) {
                                            ctx.beginPath();
                                            ctx.rect(brick.x, brick.y, brick.width, brick.height);

                                            // fill color should be a checkboard pattern every 16px square between white and #ccc
                                            var fillColor = (Math.floor(brick.x0 / 16) + Math.floor(brick.y0 / 16)) % 2 === 0 ? '#ccc' : '#fff';
                                            // const fillColor = 
                                            ctx.fillStyle = fillColor; //'#0095DD';
                                            ctx.fill();
                                            ctx.closePath();
                                        } else {
                                            hasBricks = true;
                                        }
                                    });
                                    if (!hasBricks) {
                                        _this.endGame(true);
                                    }
                                };

                                hitBrick = function hitBrick(brick) {
                                    brick.status = 0;
                                    _this.score += 16;
                                    ballBounce();
                                };

                                // Collision detection


                                isColliding = function isColliding(ball, brick) {
                                    return ball.x < brick.x + brick.width && ball.x + ball.radius * 2 > brick.x && ball.y < brick.y + brick.height && ball.y + ball.radius * 2 > brick.y;
                                };

                                collisionDetection = function collisionDetection() {
                                    var horizontalCollision = false; // To track if horizontal velocity (dx) should flip
                                    var verticalCollision = false; // To track if vertical velocity (dy) should flip

                                    bricks.forEach(function (brick) {
                                        if (brick.status === 1 && isColliding(ball, brick)) {
                                            // Determine collision side by comparing ball's center to brick's center
                                            var ballCenterX = ball.x + ball.radius;
                                            var ballCenterY = ball.y + ball.radius;
                                            var brickCenterX = brick.x + brick.width / 2;
                                            var brickCenterY = brick.y + brick.height / 2;

                                            var distX = ballCenterX - brickCenterX;
                                            var distY = ballCenterY - brickCenterY;

                                            // Prioritize the axis with the larger absolute distance
                                            if (Math.abs(distX) > Math.abs(distY)) {
                                                // Horizontal collision
                                                if (!horizontalCollision) {
                                                    ball.dx = -ball.dx; // Reflect ball's horizontal direction
                                                    horizontalCollision = true;
                                                }
                                            } else {
                                                // Vertical collision
                                                if (!verticalCollision) {
                                                    ball.dy = -ball.dy; // Reflect ball's vertical direction
                                                    verticalCollision = true;
                                                }
                                            }

                                            hitBrick(brick); // Remove or handle brick hit
                                        }
                                    });
                                };

                                ballBounce = function ballBounce() {
                                    _this.playSound('bounce');
                                };

                                // Main game loop


                                lastTime = performance.now();

                                draw = function draw() {
                                    var timestamp = performance.now();
                                    if (!lastTime) lastTime = timestamp;
                                    var deltaTime = (timestamp - lastTime) / 10; // Convert to seconds
                                    lastTime = timestamp;

                                    var ballDx = ball.dx * deltaTime;
                                    var ballDy = ball.dy * deltaTime;

                                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                                    drawBackground();
                                    drawBricks();
                                    drawBall();
                                    drawPaddle();
                                    collisionDetection();

                                    var ballCenterX = ball.x + ball.radius;

                                    // Ball movement and collision with walls
                                    if (ball.x + ballDx > canvas.width - ball.radius * 2) {
                                        ball.dx = -ball.dx;
                                        ball.x = canvas.width - ball.radius * 2;
                                        ballBounce();
                                    } else if (ball.x + ballDx < 0) {
                                        ball.dx = -ball.dx;
                                        ball.x = 0;
                                        ballBounce();
                                    }
                                    if (ball.y + ballDy < ball.radius) {
                                        ball.dy = -ball.dy;

                                        // Move the ball to the top of the canvas to prevent glitches
                                        ball.y = ball.radius;
                                        ballBounce();
                                    } else if (ball.dy > 0 && ball.y + ballDy + ball.radius * 2 > paddle.y) {
                                        if (ballCenterX > paddle.x && ballCenterX < paddle.x + paddle.width) {

                                            // Ball hit the paddle
                                            // Reflect the ball based on where it hit the paddle
                                            ball.dx = 8 * ((ballCenterX - paddle.x) / paddle.width - 0.5);
                                            ball.dy = -ball.dy;

                                            // Move the ball to the top of the paddle to prevent glitches
                                            ball.y = paddle.y - ball.radius;

                                            // Shrink the paddle unless it's reached a minimum size
                                            if (paddle.width > canvas.width * 0.05) {
                                                paddle.width *= 0.99;
                                                paddle.x += paddle.width * 0.05 / 2;
                                            }
                                            ballBounce();
                                            // Increase ball speed when it hits the paddle
                                            // ball.dx *= 1.05;
                                            // ball.dy *= 1.05;
                                        } else {
                                            ball.dx = 0;
                                            ball.dy = 0;
                                            _this.endGame();
                                        }
                                    }

                                    // Move the ball
                                    ball.x += ballDx;
                                    ball.y += ballDy;

                                    if (_this.isPlaying) {
                                        requestAnimationFrame(draw);
                                    }
                                };

                                _context4.prev = 33;
                                _context4.next = 36;
                                return this.ensureImageLoaded(backgroundImage);

                            case 36:
                                _context4.next = 38;
                                return this.ensureImageLoaded(paddleImg);

                            case 38:
                                _context4.next = 44;
                                break;

                            case 40:
                                _context4.prev = 40;
                                _context4.t0 = _context4['catch'](33);

                                console.error('Error loading image', _context4.t0);
                                alert('Failed to load assets');

                            case 44:
                                draw();

                            case 45:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[33, 40]]);
            }));

            function playGame() {
                return _ref4.apply(this, arguments);
            }

            return playGame;
        }(),
        ensureImageLoaded: function () {
            var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(img) {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                    if (img.complete) {
                                        resolve();
                                    } else {
                                        img.onload = resolve;
                                        img.onerror = reject;
                                    }
                                }));

                            case 1:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function ensureImageLoaded(_x4) {
                return _ref5.apply(this, arguments);
            }

            return ensureImageLoaded;
        }(),
        navigateTo: function navigateTo(route) {
            this.$router.push(route);
        },
        loadBricks: function () {
            var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.prev = 0;
                                _context6.next = 3;
                                return axios.get(this.s3LinkMap);

                            case 3:
                                response = _context6.sent;

                                this.linkMap = response.data;
                                _context6.next = 10;
                                break;

                            case 7:
                                _context6.prev = 7;
                                _context6.t0 = _context6['catch'](0);

                                console.error('Error fetching link map', _context6.t0);

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this, [[0, 7]]);
            }));

            function loadBricks() {
                return _ref6.apply(this, arguments);
            }

            return loadBricks;
        }(),
        handleKeyDown: function handleKeyDown(event) {
            // Start movement only if the key isn't already being held down
            if (event.key === 'ArrowLeft' && !this.movingLeft) {
                this.startMovement('left');
            } else if (event.key === 'ArrowRight' && !this.movingRight) {
                this.startMovement('right');
            }
        },
        handleKeyUp: function handleKeyUp(event) {
            if (event.key === 'ArrowLeft') {
                this.stopMovement('left');
            } else if (event.key === 'ArrowRight') {
                this.stopMovement('right');
            }
        },
        startMovement: function startMovement(direction) {
            var _this2 = this;

            // Clear any existing interval
            this.stopMovement();

            // Set the movement flags
            if (direction === 'left') {
                this.movingLeft = true;
            } else if (direction === 'right') {
                this.movingRight = true;
            }

            // Start moving with acceleration
            this.movementInterval = setInterval(function () {
                if (direction === 'left') {
                    _this2.moveLeft();
                } else if (direction === 'right') {
                    _this2.moveRight();
                }

                // Increase speed with acceleration but cap it at maxSpeed
                if (_this2.speed < _this2.maxSpeed) {
                    _this2.speed += _this2.acceleration;
                }
            }, 16); // 60 FPS (~16ms per frame)
        },
        stopMovement: function stopMovement() {
            clearInterval(this.movementInterval);
            this.speed = 0; // Reset speed when the key is released
            this.movementInterval = null;

            // Reset movement flags
            this.movingLeft = false;
            this.movingRight = false;
        },
        moveLeft: function moveLeft() {
            // Move left, reducing the paddle's x position by the current speed
            this.paddle.x -= this.speed;
            if (this.paddle.x < 0) {
                this.paddle.x = 0;
            }
        },
        moveRight: function moveRight() {
            // Move right, increasing the paddle's x position by the current speed
            this.paddle.x += this.speed;
            if (this.paddle.x + this.paddle.width > this.canvas.width) {
                this.paddle.x = this.canvas.width - this.paddle.width;
            }
        }
    },
    mounted: function mounted() {
        this.loadBricks();
        this.loadLeaderboard();
        window.addEventListener('keydown', this.handleKeyDown);
        window.addEventListener('keyup', this.handleKeyUp);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener('keyup', this.handleKeyUp);
        this.stopMovement();
    },

    inject: ['updateAppRoute', 'appData', 'postToLambda', 'connectWallet'],
    created: function created() {
        this.updateAppRoute('break');
        var isMuted = localStorage.getItem(LOCAL_STORAGE_BREAK_MUTE_KEY);;
        this.isMuted = isMuted === 'true';
    }
});

/***/ }),

/***/ "YTo8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscribe_vue__ = __webpack_require__("19pQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd08e78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Subscribe_vue__ = __webpack_require__("0rFV");
function injectStyle (ssrContext) {
  __webpack_require__("8Bxh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cd08e78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscribe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd08e78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Subscribe_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Homepage__ = __webpack_require__("Qfom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Transactions__ = __webpack_require__("NZaW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Leaderboard__ = __webpack_require__("Fvhm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Break__ = __webpack_require__("5lUk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Drop__ = __webpack_require__("MjUn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_About__ = __webpack_require__("c27y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Menu__ = __webpack_require__("ccZh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Plots__ = __webpack_require__("1MwN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Spaces__ = __webpack_require__("eWOI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Demo__ = __webpack_require__("26cW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Terms__ = __webpack_require__("Rp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Privacy__ = __webpack_require__("8mQd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Subscribe__ = __webpack_require__("YTo8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Tang__ = __webpack_require__("8DXe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Dob__ = __webpack_require__("FIYo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Preme__ = __webpack_require__("fqzV");



















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history', // routes without the hash
  routes: [{
    path: '/',
    name: 'homepage',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Homepage__["a" /* default */],
    meta: {
      title: 'Million Bit Homepage'
    }
  }, {
    path: '/list',
    name: 'list',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Transactions__["a" /* default */],
    meta: {
      title: 'Million Bit List'
    }
  }, {
    path: '/leaderboard',
    name: 'leaderboard',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Leaderboard__["a" /* default */],
    meta: {
      title: 'Million Bit Leaderboard'
    }
  }, {
    path: '/break',
    name: 'break',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Break__["a" /* default */],
    meta: {
      title: 'Million Bit Break'
    }
  }, {
    path: '/drop',
    name: 'drop',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Drop__["a" /* default */],
    meta: {
      title: 'Million Bit Drop'
    }
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_7__components_About__["a" /* default */],
    meta: {
      title: 'About the Million Bit Homepage'
    }
  }, {
    path: '/menu',
    name: 'nav-menu',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Menu__["a" /* default */],
    meta: {
      title: 'Million Bit Menu'
    }
  }, {
    path: '/demo',
    name: 'nav-demo',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Demo__["a" /* default */],
    meta: {
      title: 'Million Bit Homepage Demo'
    }
  }, {
    path: '/plots',
    name: 'plots',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Plots__["a" /* default */],
    meta: {
      title: 'Million Bit Homepage Plots'
    }
  }, {
    path: '/spaces',
    name: 'spaces',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Spaces__["a" /* default */],
    meta: {
      title: 'Based Spaces'
    }
  }, {
    path: '/terms',
    name: 'terms',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Terms__["a" /* default */],
    meta: {
      title: 'Million Bit Homepage - Terms of Service'
    }
  }, {
    path: '/privacy',
    name: 'privacy',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Privacy__["a" /* default */],
    meta: {
      title: 'Million Bit Homepage - Privacy Policy'
    }
  }, {
    path: '/subscribe',
    name: 'subscribe',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Subscribe__["a" /* default */],
    meta: {
      title: 'Subscribe to the Million Bit Homepage'
    }
  }, {
    path: '/tang',
    name: 'tang',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Tang__["a" /* default */],
    meta: {
      title: 'Tang Tree powered by the Million Bit Homepage'
    }
  }, {
    path: '/dob',
    name: 'dob',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Dob__["a" /* default */],
    meta: {
      title: 'DOB Pixel Gallery powered by the Million Bit Homepage'
    }
  }, {
    path: '/preme',
    name: 'preme',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Preme__["a" /* default */],
    meta: {
      title: 'Preme Bit Page powered by the Million Bit Homepage'
    }
  }, {
    path: '*', // Catch-all for undefined paths in the new mode
    redirect: '/' // Redirect to home or any other default route
  }]
});

router.beforeEach(function (to, from, next) {
  // Access the title from the route's meta field
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'Million Bit Homepage'; // Fallback title
  }
  next(); // Proceed to the route
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Zs8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about',
  data: function data() {
    return {};
  },

  inject: ['updateAppRoute', 'appData', 'postToLambda'],
  created: function created() {
    this.updateAppRoute('about');
  }
});

/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Zs8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3af938a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("qA7t");
function injectStyle (ssrContext) {
  __webpack_require__("mLn8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d3af938a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3af938a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ccZh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__("gR1W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49c831be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__("5aCA");
function injectStyle (ssrContext) {
  __webpack_require__("qnmE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49c831be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49c831be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dRIF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eWOI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spaces_vue__ = __webpack_require__("GjOD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094e2f22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Spaces_vue__ = __webpack_require__("PD8U");
function injectStyle (ssrContext) {
  __webpack_require__("UdSD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-094e2f22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spaces_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094e2f22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Spaces_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f8kC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fqzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preme_vue__ = __webpack_require__("FHx6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b675e1ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Preme_vue__ = __webpack_require__("xySY");
function injectStyle (ssrContext) {
  __webpack_require__("zh3L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b675e1ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preme_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b675e1ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Preme_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gR1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-menu',
  data: function data() {
    return {
      variantNavButton: 'warning'
    };
  },

  inject: ['updateAppRoute', 'appData', 'postToLambda'],
  created: function created() {
    this.updateAppRoute('menu');
  }
});

/***/ }),

/***/ "iDuB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iDxL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leaderboard container",
    attrs: {
      "id": "million-bit-leaderboard"
    }
  }, [_c('h1', {
    staticClass: "pt-3 honk-text"
  }, [_vm._v("Leaderboard")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-block"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-block btn-primary my-3",
    class: {
      'disabled': _vm.leaderboardView === 'pixels'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleView()
      }
    }
  }, [_vm._v("\n          Pixels\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon btn-block btn-primary my-3",
    class: {
      'disabled': _vm.leaderboardView === 'clicks'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleView()
      }
    }
  }, [_vm._v("\n          Clicks\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "leaderboard-wrap mb-5"
  }, [(_vm.leaderboardView === 'pixels') ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.teams), function(team) {
    return _c('tr', {
      key: team._id
    }, [_c('td', [_c('h2', {
      staticClass: "mr-1 honk-text"
    }, [_vm._v(_vm._s(team.rank))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('h4', {
      domProps: {
        "textContent": _vm._s(team.team.name)
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, _vm._l((team.seqs), function(seq) {
      return _c('span', {
        key: seq.hash
      }, [_c('a', {
        directives: [{
          name: "lazy-load",
          rawName: "v-lazy-load"
        }],
        attrs: {
          "href": seq.url,
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "data-url": _vm.s3Base + seq.hash + '-crop.jpeg'
        }
      })])])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "text-right pixel-count"
    }, [_c('h5', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(team.pixels) + " pixels")])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.leaderboardView === 'clicks') ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.clicks), function(click, i) {
    return _c('tr', {
      key: click._id
    }, [_c('td', [_c('h2', {
      staticClass: "mr-1 honk-text"
    }, [_vm._v(_vm._s(i + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('a', {
      directives: [{
        name: "lazy-load",
        rawName: "v-lazy-load"
      }],
      attrs: {
        "href": click.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "data-url": _vm.s3Base + click.hash + '-crop.jpeg'
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('a', {
      attrs: {
        "href": click.url,
        "target": "_blank"
      }
    }, [_vm._v("\n          " + _vm._s(click.url) + "\n        ")])])])
  }), 0) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iaho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-navbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isGame),
      expression: "!isGame"
    }],
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": _vm.variant
    }
  }, [_c('div', {
    staticClass: "header-l mr-auto nav-menu text-left"
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('b-nav-form', {
    staticStyle: {
      "display": "block !important"
    }
  }, [_c('span', {
    staticClass: "btn-group nav-buttons"
  }, [(!_vm.whiteLabel) ? _c('b-button', {
    staticClass: "btn-icon",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/menu')
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-list",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.whiteLabel) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-intro",
      modifiers: {
        "modal-intro": true
      }
    }],
    staticClass: "btn-icon",
    attrs: {
      "variant": _vm.variantNavButton
    }
  }, [_c('svg', {
    staticClass: "bi bi-question-circle",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/' || _vm.$route.path === '/tang' || _vm.$route.path === '/dob' || _vm.$route.path === '/preme') ? _c('b-button', {
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.doUpload()
      }
    }
  }, [_vm._v("\n                UPLOAD \n                ")]) : _vm._e(), _vm._v(" "), (!_vm.canBuy && _vm.$route.path === '/' && _vm.connectAccountEnsAvatar != '') ? _c('b-button', {
    staticClass: "btn-icon",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": _vm.doUploadAvatar
    }
  }, [_c('img', {
    staticClass: "ensAvatar",
    attrs: {
      "src": _vm.connectAccountEnsAvatar
    }
  })]) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mr-0 p-0 header-m"
  }, [(!_vm.whiteLabel) ? _c('span', {
    staticClass: "honk-text mbh-title",
    on: {
      "click": function($event) {
        return _vm.navigateTo('/')
      }
    }
  }, [_vm._v("Million Bit Homepage")]) : _vm._e(), _vm._v(" "), (!_vm.canBuy) ? _c('p', {
    staticClass: "subtitle dm-sans-text"
  }, [_vm._v("\n        1,000,000 pixels \n        • "), (_vm.ethTokenToggle) ? _c('span', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.ethPerPixel)
    }
  }), _vm._v(" "), _c('span', [_vm._v("ETH")])]) : _vm._e(), _vm._v(" "), (!_vm.ethTokenToggle) ? _c('span', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.tokenPerPixel)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  })]) : _vm._e(), _vm._v("\n         per pixel \n        • Own a bit of onchain history!\n      ")]) : _vm._e(), _vm._v(" "), (_vm.canBuy) ? _c('div', {
    staticClass: "d-block text-center mb-3"
  }, [_c('b-nav-form', {
    staticClass: "text-center"
  }, [(_vm.canToggleEthToken) ? _c('span', {
    staticClass: "btn-group"
  }, [_c('b-button', {
    class: {
      'btn-outline-lighter': !_vm.ethTokenToggle
    },
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.doToggleEthToken(true)
      }
    }
  }, [_c('span', [_vm._v("ETH")])]), _vm._v(" "), _c('b-button', {
    class: {
      'btn-outline-lighter': _vm.ethTokenToggle
    },
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.doToggleEthToken(false)
      }
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [(_vm.ethTokenToggle) ? _c('span', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.ethAmtFormatted)
    }
  }), _vm._v(" ETH")]) : _vm._e(), _vm._v(" "), (!_vm.ethTokenToggle) ? _c('span', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.tokenAmt)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    ref: "formInputValueUrl",
    staticClass: "mr-md-2",
    attrs: {
      "size": "md",
      "placeholder": "http link address",
      "type": "url",
      "id": "link-url",
      "value": _vm.formInputUrl
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.blurInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.canSend) ? _c('b-button', {
    attrs: {
      "variant": "warning",
      "disabled": _vm.buyLoading
    },
    on: {
      "click": _vm.doBuy
    }
  }, [_c('span', [(_vm.buyLoading) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _vm._v(" "), (_vm.canMint) ? _c('span', [_vm._v("MINT")]) : _c('span', [_vm._v("SEND")])])]) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-r ml-auto connect-menu text-right"
  }, [(!_vm.connectAccountAddress) ? _c('b-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "connect-wallet",
      "variant": 'connect'
    },
    on: {
      "click": function($event) {
        return _vm.connectWallet()
      }
    }
  }, [_vm._v("\n        Connect Wallet\n      ")]) : _vm._e(), _vm._v(" "), (_vm.connectAccountAddress) ? _c('span', {
    staticClass: "btn-group"
  }, [_c('b-button', {
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/plots')
      }
    }
  }, [(_vm.connectAccountEnsAvatar) ? _c('span', [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.connectAccountEnsAvatar
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.connectAccountEnsName) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.connectAccountEnsNameTrunc)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.connectAccountEnsName) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.connectAccountAddressTrunc)
    }
  }) : _vm._e()]), _vm._v(" "), _c('b-button', {
    staticClass: "disconnect",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.doDisconnect()
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-box-arrow-right",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.connectAccountAddress && !_vm.isBaseChain(_vm.connectAccountChainId)) ? _c('div', {
    staticClass: "my-2"
  }, [_c('b-button', {
    attrs: {
      "variant": 'warning'
    },
    on: {
      "click": function($event) {
        return _vm.switchToBaseChain()
      }
    }
  }, [_vm._v("Switch to Base")])], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.showPromo) ? _c('div', {
    staticClass: "promo-header"
  }, [_vm._v("\n    25% off for Let's Touch Base listeners!\n  ")]) : _vm._e(), _vm._v(" "), _c('router-view', {
    ref: "routerViewRef"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isGame),
      expression: "!isGame"
    }],
    staticClass: "mb-5",
    attrs: {
      "id": "countdown"
    }
  }, [(!_vm.whiteLabel) ? _c('p', {
    staticClass: "text-bold"
  }, [_vm._v("Pixel price goes up with each minted plot!")]) : _vm._e(), _vm._v(" "), (_vm.whiteLabel) ? _c('p', {
    staticClass: "text-bold"
  }, [_vm._v("Powered by the "), _c('a', {
    attrs: {
      "href": "https://millionbithomepage.com",
      "target": "_blank"
    }
  }, [_vm._v("Million Bit Homepage")])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-connect",
      "title": "Connect your wallet",
      "hide-footer": "",
      "size": "sm"
    }
  }, [(!_vm.connectAccountAddress) ? _c('b-button', {
    staticClass: "btn btn-block btn-primary mb-4",
    attrs: {
      "id": "create-wallet",
      "variant": 'connect'
    },
    on: {
      "click": function($event) {
        return _vm.createWallet()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+"
    }
  }), _vm._v("\n       Create Wallet\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.connectAccountAddress && _vm.providers.length === 0) ? _c('a', {
    staticClass: "btn btn-block btn-primary mb-4",
    attrs: {
      "href": _vm.deepLinkMetamask,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,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"
    }
  }), _vm._v(" Metamask")]) : _vm._e(), _vm._v(" "), (!_vm.connectAccountAddress && _vm.providers.length === 0) ? _c('a', {
    staticClass: "btn btn-block btn-primary mb-4",
    attrs: {
      "href": _vm.deepLinkCoinbase,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+"
    }
  }), _vm._v(" Coinbase")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.providers), function(provider) {
    return _c('span', [(!_vm.connectAccountAddress) ? _c('b-button', {
      staticClass: "btn-block btn-primary mb-4",
      attrs: {
        "variant": 'connect',
        "disabled": _vm.isConnecting
      },
      on: {
        "click": function($event) {
          return _vm.doConnect(provider)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": provider.info.icon
      }
    }), _vm._v(" " + _vm._s(provider.info.name) + "\n      ")]) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-token",
      "title": "Own a bit of blockchain history!",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('h2', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('a', {
    staticClass: "btn btn-block btn-outline-dark btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "stroke": "currentColor",
      "fill": "none",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "height": "1em",
      "width": "1em",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "width": "14",
      "height": "14",
      "x": "8",
      "y": "8",
      "rx": "2",
      "ry": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
    }
  })]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.contractAddress)
    },
    on: {
      "click": function($event) {
        return _vm.doCopyToClipboard(_vm.contractAddress)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-dark btn-block",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.watchToken()
      }
    }
  }, [_vm._v("Watch token in wallet")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("Launch status")]), _vm._v(" "), _c('p', [_vm._v("Coming soon.. join us on telegram for updates on the upcoming launch!")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-alert",
      "hide-header": "",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('h3', {
    staticClass: "text-center",
    domProps: {
      "textContent": _vm._s(_vm.alertMsg)
    }
  })]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-intro",
      "title": "👋 Welcome to the Million Bit Homepage!",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('p', [_vm._v("\n      Add your image to the homepage and be forever immortalized on the blockchain!\n    ")]), _vm._v(" "), _c('h3', {
    staticClass: "my-4"
  }, [_vm._v("💰 What you get")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v("NFT of your plot!")]), _c('br'), _vm._v("\n      You own your plot forever.  You can list it on marketplaces like \n      "), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://magiceden.us/collections/base/0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e",
      "target": "_blank"
    }
  }, [_vm._v("Magic Eden")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/plots')
      }
    }
  }, [_vm._v("update your plot")]), _vm._v(".\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v("Join the MBH community")]), _c('br'), _vm._v("\n      Invited to speak in our weekly "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/spaces')
      }
    }
  }, [_vm._v("Twitter X spaces")]), _vm._v(" and access to our exclusive Twitter X group.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v("Included in marketing and games")]), _c('br'), _vm._v("\n      Instantly included in our games "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/break')
      }
    }
  }, [_vm._v("Break")]), _vm._v(" & "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/drop')
      }
    }
  }, [_vm._v("Drop")]), _vm._v(", and marketing of the homepage.\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "my-4"
  }, [_vm._v("👩‍🏫 How it works")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', {
    staticClass: "pr-2"
  }, [_vm._v("Step 1")]), _vm._v(" \n      Click on the UPLOAD button.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', {
    staticClass: "pr-2"
  }, [_vm._v("Step 2")]), _vm._v(" \n      Move and resize your image.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', {
    staticClass: "pr-2"
  }, [_vm._v("Step 3")]), _vm._v(" \n      Click the MINT button.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', {
    staticClass: "pr-2"
  }, [_vm._v("Step 4")]), _vm._v(" \n      Check back in a minute to see your addition!\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "my-4"
  }, [_vm._v("📽️ See it in action")]), _vm._v(" "), _c('p', [_vm._v("\n      Watch an example of how easy it is to claim your plot on the homepage.\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('demo')
      }
    }
  }, [_vm._v("Watch video")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-success",
      "title": "You're a part of blockchain history!",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('p', [_vm._v("\n      Thank you for being a part of blockchain history 💙\n      "), _c('br'), (_vm.trxHashSuccess) ? _c('a', {
    attrs: {
      "href": 'https://basescan.org/tx/' + _vm.trxHashSuccess,
      "target": "_blank"
    }
  }, [_vm._v("View transaction")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Please allow a few minutes to process your pixels from the blockchain and be added to the "), (!_vm.whiteLabel) ? _c('span', [_vm._v("homepage")]) : _vm._e(), (!_vm.whiteLabel) ? _c('span', [_vm._v("page")]) : _vm._e(), _vm._v(".\n      "), _c('br'), _c('br'), _vm._v("\n      Make sure to join our community on "), _c('a', {
    attrs: {
      "href": _vm.telegram,
      "target": "_blank"
    }
  }, [_vm._v("Telegram")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": _vm.twitter,
      "target": "_blank"
    }
  }, [_vm._v("Twitter")]), _vm._v(".\n      "), _c('br'), _c('br'), _vm._v(" "), (!_vm.whiteLabel) ? _c('span', [_vm._v("Share with your friends and get 15% of the spots they buy!\n      "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-outline-dark btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.shareUrl)
    },
    on: {
      "click": function($event) {
        return _vm.doCopyToClipboard(_vm.shareUrl)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-lg btn-primary",
    attrs: {
      "href": _vm.xPostSuccess,
      "target": "_blank"
    }
  }, [_vm._v("Share on X")]), _c('br')]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-invite-friends",
      "title": "Invite Friends",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('h1', [_vm._v("Refer friends and earn 15%")]), _vm._v(" "), _c('p', [_vm._v("\n      Share the Million Bit Homepage with your friends and earn 15% of the spots they buy.\n    ")]), _vm._v(" "), (!_vm.connectAccountAddress) ? _c('span', [_c('b', [_vm._v("Connect your wallet to get your referral link")])]) : _vm._e(), _vm._v(" "), (_vm.connectAccountAddress) ? _c('span', [_c('b', [_vm._v("Share invite link")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-outline-dark btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.shareUrl)
    },
    on: {
      "click": function($event) {
        return _vm.doCopyToClipboard(_vm.shareUrl)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-lg btn-primary",
    attrs: {
      "href": _vm.xPostInvite,
      "target": "_blank"
    }
  }, [_vm._v("Share on X")]), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "fine-uploader-manual-trigger"
    }
  }), _vm._v(" "), (_vm.isMobileOrTouch && _vm.canBuy) ? _c('div', {
    attrs: {
      "id": "mobile-controls"
    }
  }, [_c('div', {
    attrs: {
      "id": "control-down"
    },
    on: {
      "click": _vm.btnPress,
      "touchstart": function($event) {
        return _vm.handleTouchStart($event, 'down')
      },
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchCancel
    }
  }, [_c('svg', {
    staticClass: "bi bi-arrow-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-left"
    },
    on: {
      "click": _vm.btnPress,
      "touchstart": function($event) {
        return _vm.handleTouchStart($event, 'left')
      },
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchCancel
    }
  }, [_c('svg', {
    staticClass: "bi bi-arrow-left",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-right"
    },
    on: {
      "click": _vm.btnPress,
      "touchstart": function($event) {
        return _vm.handleTouchStart($event, 'right')
      },
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchCancel
    }
  }, [_c('svg', {
    staticClass: "bi bi-arrow-right",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-up"
    },
    on: {
      "click": _vm.btnPress,
      "touchstart": function($event) {
        return _vm.handleTouchStart($event, 'up')
      },
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchCancel
    }
  }, [_c('svg', {
    staticClass: "bi bi-arrow-up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-smaller"
    },
    on: {
      "click": function($event) {
        return _vm.resizeSpot('smaller')
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-zoom-out",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-bigger"
    },
    on: {
      "click": function($event) {
        return _vm.resizeSpot('bigger')
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-zoom-in",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isGame),
      expression: "!isGame"
    }],
    staticClass: "bg-white mbh-footer"
  }, [_c('b-navbar', {
    attrs: {
      "variant": "white"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "honk-text"
  }, [_vm._v("MBH")])]), _vm._v(" "), _c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "href": _vm.email,
      "target": "_blank",
      "variant": "link"
    }
  }, [_c('svg', {
    staticClass: "bi bi-envelope",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"
    }
  })])]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": _vm.telegram,
      "target": "_blank",
      "variant": "link"
    }
  }, [_c('svg', {
    staticClass: "bi bi-telegram",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"
    }
  })])]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": _vm.twitter,
      "target": "_blank",
      "variant": "link"
    }
  }, [_c('svg', {
    staticClass: "bi bi-twitter-x",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
    }
  })])]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "send-feedback",
    attrs: {
      "variant": "link",
      "href": "https://www.complainonchain.xyz/millionbithomepage",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/keren.webp"
    }
  }), _vm._v(" Feedback")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showInviteFriends()
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-megaphone-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25 25 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009l.496.008a64 64 0 0 1 1.51.048m1.39 1.081q.428.032.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a66 66 0 0 1 1.692.064q.491.026.966.06"
    }
  })]), _vm._v("\n        Invite friends\n      ")])], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-item', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/terms')
      }
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/privacy')
      }
    }
  }, [_vm._v("Privacy")])], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": "",
      "variant": "link",
      "id": "copyright"
    }
  }, [_vm._v("© 2025. All rights reserved. Not responsible for the content of external sites or images featured which are © of their respective owners.")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toast"
    }
  }), _vm._v(" "), (!_vm.watchedDemo && !_vm.whiteLabel) ? _c('div', {
    attrs: {
      "id": "pfp-vid-container"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showDemoVideo.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "pfp-vid"
    }
  }, [_c('video', {
    attrs: {
      "src": "/static/pfp-talking-head.webm",
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": ""
    },
    domProps: {
      "muted": true
    }
  })])]) : _vm._e()], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confetti-wrapper"
  }, [_c('div', {
    staticClass: "js-container c-container"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lebo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lxEZ":
/***/ (function(module, exports) {

module.exports = [{"inputs":[{"internalType":"address","name":"initialOwner","type":"address"},{"internalType":"address","name":"minterAddress","type":"address"},{"internalType":"address payable","name":"royaltyRecipientAddress","type":"address"},{"internalType":"address","name":"_tokenAddress","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"ERC721EnumerableForbiddenBatchMint","type":"error"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"address","name":"owner","type":"address"}],"name":"ERC721IncorrectOwner","type":"error"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ERC721InsufficientApproval","type":"error"},{"inputs":[{"internalType":"address","name":"approver","type":"address"}],"name":"ERC721InvalidApprover","type":"error"},{"inputs":[{"internalType":"address","name":"operator","type":"address"}],"name":"ERC721InvalidOperator","type":"error"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"ERC721InvalidOwner","type":"error"},{"inputs":[{"internalType":"address","name":"receiver","type":"address"}],"name":"ERC721InvalidReceiver","type":"error"},{"inputs":[{"internalType":"address","name":"sender","type":"address"}],"name":"ERC721InvalidSender","type":"error"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ERC721NonexistentToken","type":"error"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"ERC721OutOfBoundsIndex","type":"error"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"OwnableInvalidOwner","type":"error"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"OwnableUnauthorizedAccount","type":"error"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"_fromTokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"_toTokenId","type":"uint256"}],"name":"BatchMetadataUpdate","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"MetadataUpdate","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"string","name":"pixelStr","type":"string"}],"name":"PixelDataLogged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"basePrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tokenPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"burnToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint16","name":"x1","type":"uint16"},{"internalType":"uint16","name":"y1","type":"uint16"},{"internalType":"uint16","name":"x2","type":"uint16"},{"internalType":"uint16","name":"y2","type":"uint16"}],"name":"calculateCurrentPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"x1","type":"uint16"},{"internalType":"uint16","name":"y1","type":"uint16"},{"internalType":"uint16","name":"x2","type":"uint16"},{"internalType":"uint16","name":"y2","type":"uint16"}],"name":"checkOverlap","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"x1","type":"uint16"},{"internalType":"uint16","name":"y1","type":"uint16"},{"internalType":"uint16","name":"x2","type":"uint16"},{"internalType":"uint16","name":"y2","type":"uint16"},{"internalType":"string","name":"pixelStr","type":"string"}],"name":"mint","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint16","name":"x1","type":"uint16"},{"internalType":"uint16","name":"y1","type":"uint16"},{"internalType":"uint16","name":"x2","type":"uint16"},{"internalType":"uint16","name":"y2","type":"uint16"},{"internalType":"string","name":"uri","type":"string"},{"internalType":"string","name":"pixelStr","type":"string"}],"name":"ownerMint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"priceIncrement","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"string","name":"pixelStr","type":"string"}],"name":"repaintPixels","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"repaintPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"salePrice","type":"uint256"}],"name":"royaltyInfo","outputs":[{"internalType":"address","name":"receiver","type":"address"},{"internalType":"uint256","name":"royaltyAmount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"royaltyPercentage","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"royaltyRecipient","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_basePrice","type":"uint256"}],"name":"setBasePrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint16","name":"x1","type":"uint16"},{"internalType":"uint16","name":"y1","type":"uint16"},{"internalType":"uint16","name":"x2","type":"uint16"},{"internalType":"uint16","name":"y2","type":"uint16"},{"internalType":"bool","name":"isOccupied","type":"bool"}],"name":"setCoordsOccupied","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"minterAddress","type":"address"}],"name":"setMinterAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_priceIncrement","type":"uint256"}],"name":"setPriceIncrement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_repaintPrice","type":"uint256"}],"name":"setRepaintPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address payable","name":"royaltyRecipientAddress","type":"address"}],"name":"setRoyaltyAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_percentage","type":"uint256"}],"name":"setRoyaltyPercentage","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_tokenAddress","type":"address"}],"name":"setTokenAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_tokenRepaintPrice","type":"uint256"}],"name":"setTokenRepaintPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tokenAddress","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"x1","type":"uint16"},{"internalType":"uint16","name":"y1","type":"uint16"},{"internalType":"uint16","name":"x2","type":"uint16"},{"internalType":"uint16","name":"y2","type":"uint16"},{"internalType":"string","name":"pixelStr","type":"string"}],"name":"tokenMint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"string","name":"pixelStr","type":"string"}],"name":"tokenRepaintPixels","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"tokenRepaintPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"string","name":"newUri","type":"string"}],"name":"updateTokenURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"}]

/***/ }),

/***/ "mLn8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oiih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var L2ResolverAbi = [{
  inputs: [{
    internalType: 'contract ENS',
    name: 'ens_',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'registrarController_',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'reverseRegistrar_',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'owner_',
    type: 'address'
  }],
  stateMutability: 'nonpayable',
  type: 'constructor'
}, {
  inputs: [],
  name: 'AlreadyInitialized',
  type: 'error'
}, {
  inputs: [],
  name: 'CantSetSelfAsDelegate',
  type: 'error'
}, {
  inputs: [],
  name: 'CantSetSelfAsOperator',
  type: 'error'
}, {
  inputs: [],
  name: 'NewOwnerIsZeroAddress',
  type: 'error'
}, {
  inputs: [],
  name: 'NoHandoverRequest',
  type: 'error'
}, {
  inputs: [],
  name: 'Unauthorized',
  type: 'error'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: true,
    internalType: 'uint256',
    name: 'contentType',
    type: 'uint256'
  }],
  name: 'ABIChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'a',
    type: 'address'
  }],
  name: 'AddrChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'coinType',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'newAddress',
    type: 'bytes'
  }],
  name: 'AddressChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'ApprovalForAll',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'delegate',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'Approved',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'hash',
    type: 'bytes'
  }],
  name: 'ContenthashChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'name',
    type: 'bytes'
  }, {
    indexed: false,
    internalType: 'uint16',
    name: 'resource',
    type: 'uint16'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'record',
    type: 'bytes'
  }],
  name: 'DNSRecordChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'name',
    type: 'bytes'
  }, {
    indexed: false,
    internalType: 'uint16',
    name: 'resource',
    type: 'uint16'
  }],
  name: 'DNSRecordDeleted',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'lastzonehash',
    type: 'bytes'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'zonehash',
    type: 'bytes'
  }],
  name: 'DNSZonehashChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: true,
    internalType: 'bytes4',
    name: 'interfaceID',
    type: 'bytes4'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'implementer',
    type: 'address'
  }],
  name: 'InterfaceChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'string',
    name: 'name',
    type: 'string'
  }],
  name: 'NameChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'pendingOwner',
    type: 'address'
  }],
  name: 'OwnershipHandoverCanceled',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'pendingOwner',
    type: 'address'
  }],
  name: 'OwnershipHandoverRequested',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'oldOwner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'OwnershipTransferred',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'bytes32',
    name: 'x',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'bytes32',
    name: 'y',
    type: 'bytes32'
  }],
  name: 'PubkeyChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'newRegistrarController',
    type: 'address'
  }],
  name: 'RegistrarControllerUpdated',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'newReverseRegistrar',
    type: 'address'
  }],
  name: 'ReverseRegistrarUpdated',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: true,
    internalType: 'string',
    name: 'indexedKey',
    type: 'string'
  }, {
    indexed: false,
    internalType: 'string',
    name: 'key',
    type: 'string'
  }, {
    indexed: false,
    internalType: 'string',
    name: 'value',
    type: 'string'
  }],
  name: 'TextChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'uint64',
    name: 'newVersion',
    type: 'uint64'
  }],
  name: 'VersionChanged',
  type: 'event'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'uint256',
    name: 'contentTypes',
    type: 'uint256'
  }],
  name: 'ABI',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'addr',
  outputs: [{
    internalType: 'address payable',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'uint256',
    name: 'coinType',
    type: 'uint256'
  }],
  name: 'addr',
  outputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'address',
    name: 'delegate',
    type: 'address'
  }, {
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'approve',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [],
  name: 'cancelOwnershipHandover',
  outputs: [],
  stateMutability: 'payable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'clearRecords',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'pendingOwner',
    type: 'address'
  }],
  name: 'completeOwnershipHandover',
  outputs: [],
  stateMutability: 'payable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'contenthash',
  outputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes32',
    name: 'name',
    type: 'bytes32'
  }, {
    internalType: 'uint16',
    name: 'resource',
    type: 'uint16'
  }],
  name: 'dnsRecord',
  outputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'ens',
  outputs: [{
    internalType: 'contract ENS',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes32',
    name: 'name',
    type: 'bytes32'
  }],
  name: 'hasDNSRecords',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes4',
    name: 'interfaceID',
    type: 'bytes4'
  }],
  name: 'interfaceImplementer',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'address',
    name: 'delegate',
    type: 'address'
  }],
  name: 'isApprovedFor',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'account',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }],
  name: 'isApprovedForAll',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes[]',
    name: 'data',
    type: 'bytes[]'
  }],
  name: 'multicall',
  outputs: [{
    internalType: 'bytes[]',
    name: 'results',
    type: 'bytes[]'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'nodehash',
    type: 'bytes32'
  }, {
    internalType: 'bytes[]',
    name: 'data',
    type: 'bytes[]'
  }],
  name: 'multicallWithNodeCheck',
  outputs: [{
    internalType: 'bytes[]',
    name: 'results',
    type: 'bytes[]'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'name',
  outputs: [{
    internalType: 'string',
    name: '',
    type: 'string'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'owner',
  outputs: [{
    internalType: 'address',
    name: 'result',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'pendingOwner',
    type: 'address'
  }],
  name: 'ownershipHandoverExpiresAt',
  outputs: [{
    internalType: 'uint256',
    name: 'result',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'pubkey',
  outputs: [{
    internalType: 'bytes32',
    name: 'x',
    type: 'bytes32'
  }, {
    internalType: 'bytes32',
    name: 'y',
    type: 'bytes32'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: '',
    type: 'bytes32'
  }],
  name: 'recordVersions',
  outputs: [{
    internalType: 'uint64',
    name: '',
    type: 'uint64'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'registrarController',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'renounceOwnership',
  outputs: [],
  stateMutability: 'payable',
  type: 'function'
}, {
  inputs: [],
  name: 'requestOwnershipHandover',
  outputs: [],
  stateMutability: 'payable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }, {
    internalType: 'bytes',
    name: 'data',
    type: 'bytes'
  }],
  name: 'resolve',
  outputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'reverseRegistrar',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'uint256',
    name: 'contentType',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: 'data',
    type: 'bytes'
  }],
  name: 'setABI',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'uint256',
    name: 'coinType',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: 'a',
    type: 'bytes'
  }],
  name: 'setAddr',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'address',
    name: 'a',
    type: 'address'
  }],
  name: 'setAddr',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'setApprovalForAll',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes',
    name: 'hash',
    type: 'bytes'
  }],
  name: 'setContenthash',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes',
    name: 'data',
    type: 'bytes'
  }],
  name: 'setDNSRecords',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes4',
    name: 'interfaceID',
    type: 'bytes4'
  }, {
    internalType: 'address',
    name: 'implementer',
    type: 'address'
  }],
  name: 'setInterface',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'string',
    name: 'newName',
    type: 'string'
  }],
  name: 'setName',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes32',
    name: 'x',
    type: 'bytes32'
  }, {
    internalType: 'bytes32',
    name: 'y',
    type: 'bytes32'
  }],
  name: 'setPubkey',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'registrarController_',
    type: 'address'
  }],
  name: 'setRegistrarController',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'reverseRegistrar_',
    type: 'address'
  }],
  name: 'setReverseRegistrar',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'string',
    name: 'key',
    type: 'string'
  }, {
    internalType: 'string',
    name: 'value',
    type: 'string'
  }],
  name: 'setText',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes',
    name: 'hash',
    type: 'bytes'
  }],
  name: 'setZonehash',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes4',
    name: 'interfaceID',
    type: 'bytes4'
  }],
  name: 'supportsInterface',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'string',
    name: 'key',
    type: 'string'
  }],
  name: 'text',
  outputs: [{
    internalType: 'string',
    name: '',
    type: 'string'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'transferOwnership',
  outputs: [],
  stateMutability: 'payable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'zonehash',
  outputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  L2ResolverAbi: L2ResolverAbi
});

/***/ }),

/***/ "pEEw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "billboard",
    class: {
      'showTooltip': _vm.hovering
    },
    attrs: {
      "id": "million-bit-billboard"
    },
    on: {
      "click": _vm.clickBillboard,
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "mousemove": _vm.onMouseMove
    }
  }, [_c('canvas', {
    attrs: {
      "id": "uploadedImg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.s3ImgSrc,
      "usemap": "#linkmap"
    },
    on: {
      "load": _vm.onBillboardLoaded
    }
  }), _vm._v(" "), _c('map', {
    attrs: {
      "name": "linkmap"
    }
  }, _vm._l((_vm.links), function(link) {
    return _c('area', {
      attrs: {
        "target": "_blank",
        "alt": "",
        "title": "",
        "shape": "rect",
        "coords": link.c,
        "href": link.u
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    ref: 'tooltip',
    attrs: {
      "id": "billboard-tooltip"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pjtm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_imul__ = __webpack_require__("qajy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("L/hj");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_S3_BUCKET = "https://millionbithomepage.com/static/billboard/";
var LOCAL_STORAGE_DROP_HIGHSCORE_KEY = 'drop_highscore';
var LOCAL_STORAGE_DROP_MUTE_KEY = 'break_muted';
var sfx = {
  bounce: new Audio('/static/bounce.mp3'),
  gameover: new Audio('/static/gameover.mp3'),
  gamestart: new Audio('/static/gamestart.mp3'),
  gamewin: new Audio('/static/gamewin.mp3')
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop',
  data: function data() {
    return {
      isSponsored: false,
      isLoading: true,
      isMuted: false,
      gameLeaderboard: [],
      leaderBoardToggle: 'week',
      s3Base: BASE_S3_BUCKET,
      s3ImgSrc: BASE_S3_BUCKET + 'homepage.jpeg?' + Date.now(),
      s3TransactionsJson: BASE_S3_BUCKET + 'transactions.json?' + Date.now(),
      score: 0,
      highscore: localStorage.getItem(LOCAL_STORAGE_DROP_HIGHSCORE_KEY) || 0,
      isPlaying: false,
      transactions: []
    };
  },

  computed: {
    xPost: function xPost() {
      return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent('🕹️ I just scored ' + this.score + ' on Million Base Drop! Can you beat my score?') + '&url=' + encodeURIComponent('https://millionbithomepage.com/drop');
    }
  },
  methods: {
    newGame: function newGame() {
      this.playGame();
      this.playSound('gamestart');
    },
    mute: function mute(doMute) {
      this.isMuted = doMute;
      localStorage.setItem(LOCAL_STORAGE_DROP_MUTE_KEY, this.isMuted);
    },
    toggleLeaderBoard: function toggleLeaderBoard() {
      if (this.leaderBoardToggle === 'all') {
        this.leaderBoardToggle = 'week';
      } else {
        this.leaderBoardToggle = 'all';
      }
      this.gameLeaderboard = this.leaderBoardToggle === 'all' ? this.gameLeaderboards.all : this.gameLeaderboards.week;
    },
    playSound: function playSound(sound) {
      if (this.isMuted) {
        return;
      }
      sfx[sound].currentTime = 0;
      sfx[sound].play();
    },
    saveScore: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(score) {
        var player;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                player = this.appData().connectedAccount;
                _context.next = 3;
                return this.postToLambda('recordDropScore', {
                  score: score,
                  player: player
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveScore(_x) {
        return _ref.apply(this, arguments);
      }

      return saveScore;
    }(),
    endGame: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(didWin) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.isPlaying) {
                  _context2.next = 12;
                  break;
                }

                this.isPlaying = false;
                if (didWin) {
                  this.playSound('gamewin');
                  __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].confetti(12000);
                } else {
                  this.playSound('gameover');
                }

                if (!this.score) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 6;
                return this.saveScore(this.score);

              case 6:
                __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].trackEvent('dropScore:' + this.score);
                if (this.score > this.highscore) {
                  this.highscore = this.score;
                  localStorage.setItem(LOCAL_STORAGE_DROP_HIGHSCORE_KEY, this.highscore);
                }

              case 8:
                _context2.next = 10;
                return this.loadLeaderboard();

              case 10:
                _context2.next = 12;
                return this.load();

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function endGame(_x2) {
        return _ref2.apply(this, arguments);
      }

      return endGame;
    }(),
    loadLeaderboard: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.postToLambda('getDropLeaderboard', {});

              case 2:
                this.gameLeaderboards = _context3.sent;

                this.gameLeaderboard = this.leaderBoardToggle === 'all' ? this.gameLeaderboards.all : this.gameLeaderboards.week;

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadLeaderboard() {
        return _ref3.apply(this, arguments);
      }

      return loadLeaderboard;
    }(),
    playGame: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this = this;

        var self, canvases, mulberry32, rand, _Matter, Engine, Render, Runner, Composites, Common, MouseConstraint, Mouse, Composite, Bodies, Events, wallPad, loseHeight, statusBarHeight, previewBallHeight, friction, GameStates, Game, engine, runner, render, menuStatics, wallProps, gameStatics, mouse, mouseConstraint, resizeCanvas;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                mulberry32 = function mulberry32(a) {
                  return function () {
                    var t = a += 0x6D2B79F5;
                    t = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_imul___default()(t ^ t >>> 15, t | 1);
                    t ^= t + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_imul___default()(t ^ t >>> 7, t | 61);
                    return ((t ^ t >>> 14) >>> 0) / 4294967296;
                  };
                };

                self = this;

                __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].trackEvent('playGame:drop');

                canvases = document.querySelectorAll('#game-canvas canvas');

                canvases.forEach(function (canvas) {
                  canvas.remove();
                });

                this.isPlaying = true;
                this.score = 0;
                // const Matter = require('matter-js');

                rand = mulberry32(Date.now());
                _Matter = Matter, Engine = _Matter.Engine, Render = _Matter.Render, Runner = _Matter.Runner, Composites = _Matter.Composites, Common = _Matter.Common, MouseConstraint = _Matter.MouseConstraint, Mouse = _Matter.Mouse, Composite = _Matter.Composite, Bodies = _Matter.Bodies, Events = _Matter.Events;
                wallPad = 64;
                loseHeight = 84;
                statusBarHeight = 48;
                previewBallHeight = 32;
                friction = {
                  friction: 0.006,
                  frictionStatic: 0.006,
                  frictionAir: 0,
                  restitution: 0.1
                };
                GameStates = {
                  MENU: 0,
                  READY: 1,
                  DROP: 2,
                  LOSE: 3
                };
                Game = {
                  width: 640,
                  height: 960,
                  elements: {
                    canvas: document.getElementById('game-canvas'),
                    ui: document.getElementById('game-ui'),
                    score: document.getElementById('game-score'),
                    end: document.getElementById('game-end-container'),
                    endTitle: document.getElementById('game-end-title'),
                    statusValue: document.getElementById('game-highscore-value'),
                    nextFruitImg: document.getElementById('game-next-fruit'),
                    previewBall: null
                  },
                  cache: { highscore: 0 },
                  sounds: {
                    click: new Audio('/static/drop/click.mp3'),
                    pop0: new Audio('/static/drop/pop0.mp3'),
                    pop1: new Audio('/static/drop/pop1.mp3'),
                    pop2: new Audio('/static/drop/pop2.mp3'),
                    pop3: new Audio('/static/drop/pop3.mp3'),
                    pop4: new Audio('/static/drop/pop4.mp3'),
                    pop5: new Audio('/static/drop/pop5.mp3'),
                    pop6: new Audio('/static/drop/pop6.mp3'),
                    pop7: new Audio('/static/drop/pop7.mp3'),
                    pop8: new Audio('/static/drop/pop8.mp3'),
                    pop9: new Audio('/static/drop/pop9.mp3'),
                    pop10: new Audio('/static/drop/pop10.mp3')
                  },

                  stateIndex: GameStates.MENU,

                  score: 0,
                  fruitsMerged: [],
                  calculateScore: function calculateScore() {
                    var score = Game.fruitsMerged.reduce(function (total, count, sizeIndex) {
                      var value = Game.fruitSizes[sizeIndex].scoreValue * count;
                      return total + value;
                    }, 0);

                    Game.score = score;
                    Game.elements.score.innerText = Game.score;

                    if (Game.score) {
                      self.score = Game.score;
                    }
                  },
                  fruitSizes: this.fruitSizes,
                  // fruitSizes: [
                  // 	{ radius: 24,  scoreValue: 1,  img: '/static/drop/img/circle0.png'  },
                  // 	{ radius: 32,  scoreValue: 3,  img: '/static/drop/img/circle1.png'  },
                  // 	{ radius: 40,  scoreValue: 6,  img: '/static/drop/img/circle2.png'  },
                  // 	{ radius: 56,  scoreValue: 10, img: '/static/drop/img/circle3.png'  },
                  // 	{ radius: 64,  scoreValue: 15, img: '/static/drop/img/circle4.png'  },
                  // 	{ radius: 72,  scoreValue: 21, img: '/static/drop/img/circle5.png'  },
                  // 	{ radius: 84,  scoreValue: 28, img: '/static/drop/img/circle6.png'  },
                  // 	{ radius: 96,  scoreValue: 36, img: '/static/drop/img/circle7.png'  },
                  // 	{ radius: 128, scoreValue: 45, img: '/static/drop/img/circle8.png'  },
                  // 	{ radius: 160, scoreValue: 55, img: '/static/drop/img/circle9.png'  },
                  // 	{ radius: 192, scoreValue: 66, img: '/static/drop/img/circle10.png' },
                  // ],
                  currentFruitSize: 0,
                  nextFruitSize: 0,
                  setNextFruitSize: function setNextFruitSize() {
                    Game.nextFruitSize = Math.floor(rand() * 5);
                    Game.elements.nextFruitImg.src = this.fruitSizes[Game.nextFruitSize].img;
                  },

                  // showHighscore: function () {
                  // 	Game.elements.statusValue.innerText = Game.cache.highscore;
                  // },
                  // loadHighscore: function () {
                  // 	const gameCache = localStorage.getItem('suika-game-cache');
                  // 	if (gameCache === null) {
                  // 		Game.saveHighscore();
                  // 		return;
                  // 	}

                  // 	Game.cache = JSON.parse(gameCache);
                  // 	Game.showHighscore();
                  // },
                  // saveHighscore: function () {
                  // 	Game.calculateScore();
                  // 	if (Game.score < Game.cache.highscore) return;

                  // 	Game.cache.highscore = Game.score;
                  // 	Game.showHighscore();
                  // 	Game.elements.endTitle.innerText = 'New Highscore!';

                  // 	localStorage.setItem('suika-game-cache', JSON.stringify(Game.cache));
                  // },

                  initGame: function initGame() {
                    Render.run(render);
                    Runner.run(runner, engine);

                    Composite.add(engine.world, menuStatics);

                    // Game.loadHighscore();
                    Game.elements.ui.style.display = 'none';
                    Game.fruitsMerged = Array.apply(null, Array(Game.fruitSizes.length)).map(function () {
                      return 0;
                    });

                    var menuMouseDown = function menuMouseDown() {
                      if (mouseConstraint.body === null || !mouseConstraint.body || mouseConstraint.body.label !== 'btn-start') {
                        return;
                      }

                      Events.off(mouseConstraint, 'mousedown', menuMouseDown);
                      Game.startGame();
                    };

                    Events.on(mouseConstraint, 'mousedown', menuMouseDown);
                  },

                  startGame: function startGame() {
                    if (!self.isMuted) {
                      Game.sounds.click.play();
                    }

                    Composite.remove(engine.world, menuStatics);
                    Composite.add(engine.world, gameStatics);

                    Game.calculateScore();
                    Game.elements.endTitle.innerText = 'Game Over!';
                    Game.elements.ui.style.display = 'block';
                    Game.elements.end.style.display = 'none';
                    Game.elements.previewBall = Game.generateFruitBody(Game.width / 2, previewBallHeight, 0, { isStatic: true });
                    Composite.add(engine.world, Game.elements.previewBall);

                    setTimeout(function () {
                      Game.stateIndex = GameStates.READY;
                    }, 250);

                    Events.on(mouseConstraint, 'mouseup', function (e) {
                      Game.addFruit(e.mouse.position.x);
                    });

                    Events.on(mouseConstraint, 'mousemove', function (e) {
                      if (Game.stateIndex !== GameStates.READY) return;
                      if (Game.elements.previewBall === null) return;

                      Game.elements.previewBall.position.x = e.mouse.position.x;
                    });

                    Events.on(engine, 'collisionStart', function (e) {
                      for (var i = 0; i < e.pairs.length; i++) {
                        var _e$pairs$i = e.pairs[i],
                            bodyA = _e$pairs$i.bodyA,
                            bodyB = _e$pairs$i.bodyB;

                        // Skip if collision is wall

                        if (bodyA.isStatic || bodyB.isStatic) continue;

                        var aY = bodyA.position.y + bodyA.circleRadius;
                        var bY = bodyB.position.y + bodyB.circleRadius;

                        // Uh oh, too high!
                        if (aY < loseHeight || bY < loseHeight) {
                          Game.loseGame();
                          return;
                        }

                        // Skip different sizes
                        if (bodyA.sizeIndex !== bodyB.sizeIndex) continue;

                        // Skip if already popped
                        if (bodyA.popped || bodyB.popped) continue;

                        var newSize = bodyA.sizeIndex + 1;

                        // Go back to smallest size
                        if (bodyA.circleRadius >= Game.fruitSizes[Game.fruitSizes.length - 1].radius) {
                          newSize = 0;
                        }

                        Game.fruitsMerged[bodyA.sizeIndex] += 1;

                        // Therefore, circles are same size, so merge them.
                        var midPosX = (bodyA.position.x + bodyB.position.x) / 2;
                        var midPosY = (bodyA.position.y + bodyB.position.y) / 2;

                        bodyA.popped = true;
                        bodyB.popped = true;

                        if (!self.isMuted) {
                          Game.sounds['pop' + bodyA.sizeIndex].play();
                        }
                        Composite.remove(engine.world, [bodyA, bodyB]);
                        Composite.add(engine.world, Game.generateFruitBody(midPosX, midPosY, newSize));
                        Game.addPop(midPosX, midPosY, bodyA.circleRadius);
                        Game.calculateScore();
                      }
                    });
                  },

                  addPop: function addPop(x, y, r) {
                    var circle = Bodies.circle(x, y, r, {
                      isStatic: true,
                      collisionFilter: { mask: 0x0040 },
                      angle: rand() * (Math.PI * 2),
                      render: {
                        sprite: {
                          texture: '/static/drop/img/pop.png',
                          xScale: r / 384,
                          yScale: r / 384
                        }
                      }
                    });

                    Composite.add(engine.world, circle);
                    setTimeout(function () {
                      Composite.remove(engine.world, circle);
                    }, 100);
                  },

                  loseGame: function loseGame() {
                    Game.stateIndex = GameStates.LOSE;
                    // Game.elements.end.style.display = 'flex';
                    runner.enabled = false;
                    // Game.saveHighscore();

                    self.endGame();
                  },

                  // Returns an index, or null
                  lookupFruitIndex: function lookupFruitIndex(radius) {
                    var sizeIndex = Game.fruitSizes.findIndex(function (size) {
                      return size.radius == radius;
                    });
                    if (sizeIndex === undefined) return null;
                    if (sizeIndex === Game.fruitSizes.length - 1) return null;

                    return sizeIndex;
                  },

                  generateFruitBody: function generateFruitBody(x, y, sizeIndex) {
                    var extraConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

                    var size = Game.fruitSizes[sizeIndex];
                    var circle = Bodies.circle(x, y, size.radius, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, friction, extraConfig, {
                      label: 'fruit',
                      render: {
                        sprite: {
                          texture: size.img,
                          xScale: size.radius / Math.min(size.h, size.w),
                          yScale: size.radius / Math.min(size.h, size.w)
                        }
                      }
                    }));
                    circle.sizeIndex = sizeIndex;
                    circle.popped = false;

                    return circle;
                  },

                  addFruit: function addFruit(x) {
                    if (Game.stateIndex !== GameStates.READY) return;

                    if (!self.isMuted) {
                      Game.sounds.click.play();
                    }

                    Game.stateIndex = GameStates.DROP;
                    var latestFruit = Game.generateFruitBody(x, previewBallHeight, Game.currentFruitSize);
                    Composite.add(engine.world, latestFruit);

                    Game.currentFruitSize = Game.nextFruitSize;
                    Game.setNextFruitSize();
                    Game.calculateScore();

                    Composite.remove(engine.world, Game.elements.previewBall);
                    Game.elements.previewBall = Game.generateFruitBody(render.mouse.position.x, previewBallHeight, Game.currentFruitSize, {
                      isStatic: true,
                      collisionFilter: { mask: 0x0040 }
                    });

                    setTimeout(function () {
                      if (Game.stateIndex === GameStates.DROP) {
                        Composite.add(engine.world, Game.elements.previewBall);
                        Game.stateIndex = GameStates.READY;
                      }
                    }, 500);
                  }
                };
                engine = Engine.create();
                runner = Runner.create();
                render = Render.create({
                  element: Game.elements.canvas,
                  engine: engine,
                  options: {
                    width: Game.width,
                    height: Game.height,
                    wireframes: false,
                    background: 'transparent'

                    // showDebug: true,
                    // showBroadphase: false,
                    // showBounds: true,
                    // showVelocity: false,
                    // showCollisions: false,
                    // showSeparations: false,
                    // showAxes: false,
                    // showPositions: true,
                    // showAngleIndicator: false,
                    // showIds: true,
                    // showShadows: false,
                    // showVertexNumbers: false,
                    // showConvexHulls: false,
                    // showInternalEdges: false,
                    // showMousePosition: false
                  }
                });
                menuStatics = [Bodies.rectangle(Game.width / 2, Game.height * 0.4, 512, 512, {
                  isStatic: true,
                  render: { sprite: { texture: '/static/drop/img/bg-menu.png' } }
                })].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Array.apply(null, Array(Game.fruitSizes.length)).map(function (_, index) {
                  var x = Game.width / 2 + 192 * Math.cos(Math.PI * 2 * index / 12);
                  var y = Game.height * 0.4 + 192 * Math.sin(Math.PI * 2 * index / 12);
                  var r = 64;

                  return Bodies.circle(x, y, r, {
                    isStatic: true,
                    render: {
                      sprite: {
                        texture: _this.fruitSizes[index].img,
                        xScale: r / 2 / Math.min(_this.fruitSizes[index].w, _this.fruitSizes[index].h), // (this.fruitSizes[index].w * (this.fruitSizes[index].h / this.fruitSizes[index].w)),
                        yScale: r / 2 / Math.min(_this.fruitSizes[index].w, _this.fruitSizes[index].h) //(this.fruitSizes[index].h * (this.fruitSizes[index].w / this.fruitSizes[index].h)),
                      }
                    }
                  });
                })), [Bodies.rectangle(Game.width / 2, Game.height * 0.75, 512, 96, {
                  isStatic: true,
                  label: 'btn-start',
                  render: { sprite: { texture: '/static/drop/img/btn-start.png' } }
                })]);
                wallProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
                  isStatic: true,
                  render: { fillStyle: '#0063cd' }
                }, friction);
                gameStatics = [
                // Render BG with grid pattern
                Bodies.rectangle(Game.width / 2, Game.height / 2 + loseHeight, Game.width, Game.height, {
                  isStatic: true,
                  label: 'bg',
                  render: { sprite: { texture: '/static/drop/img/grid.jpeg' } },
                  collisionFilter: {
                    category: 0x0001, // This is an arbitrary category not used by other objects
                    mask: 0 // Prevents any collision
                  }
                }),
                // Left
                Bodies.rectangle(-(wallPad / 2), Game.height / 2, wallPad, Game.height, wallProps),

                // Right
                Bodies.rectangle(Game.width + wallPad / 2, Game.height / 2, wallPad, Game.height, wallProps),

                // Bottom
                Bodies.rectangle(Game.width / 2, Game.height + wallPad / 2 - statusBarHeight, Game.width, wallPad, wallProps)];

                // add mouse control

                mouse = Mouse.create(render.canvas);
                mouseConstraint = MouseConstraint.create(engine, {
                  mouse: mouse,
                  constraint: {
                    stiffness: 0.2,
                    render: {
                      visible: false
                    }
                  }
                });

                render.mouse = mouse;

                Game.initGame();

                resizeCanvas = function resizeCanvas() {
                  // console.log(`resizeCanvas`);
                  var screenWidth = document.body.clientWidth; // window.innerWidth
                  var gameMenu = document.getElementById('game-menu');
                  var screenHeight = window.innerHeight - gameMenu.offsetHeight - 0; // document.body.clientHeight

                  var newWidth = Game.width;
                  var newHeight = Game.height;
                  var scaleUI = 1;

                  if (screenWidth * 1.5 > screenHeight) {
                    newHeight = Math.min(Game.height, screenHeight);
                    newWidth = newHeight / 1.5;
                    scaleUI = newHeight / Game.height;
                  } else {
                    newWidth = Math.min(Game.width, screenWidth);
                    newHeight = newWidth * 1.5;
                    scaleUI = newWidth / Game.width;
                  }
                  // console.log(`screenWidth: ${screenWidth}, screenHeight: ${screenHeight}, newWidth: ${newWidth}, newHeight: ${newHeight}, scaleUI: ${scaleUI}`);

                  // render.canvas.style.width = `${newWidth}px`;
                  // render.canvas.style.height = `${newHeight}px`;

                  Game.elements.ui.style.width = Game.width + 'px';
                  Game.elements.ui.style.height = Game.height + 'px';
                  Game.elements.ui.style.transform = 'scale(' + scaleUI + ')';

                  // paintGrid(render.canvas);
                };

                this.resizeCanvas = resizeCanvas;

                resizeCanvas();
                // document.body.onresize = resizeCanvas;
                window.addEventListener('resize', this.resizeCanvas); // Add resize event listener

              case 30:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function playGame() {
        return _ref4.apply(this, arguments);
      }

      return playGame;
    }(),
    ensureImageLoaded: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5(img) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  if (img.complete) {
                    resolve();
                  } else {
                    img.onload = resolve;
                    img.onerror = reject;
                  }
                }));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function ensureImageLoaded(_x4) {
        return _ref5.apply(this, arguments);
      }

      return ensureImageLoaded;
    }(),
    navigateTo: function navigateTo(route) {
      this.$router.push(route);
    },
    load: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _this2 = this;

        var response, getRandomPlot, getPlotUrl, getPlotFruit;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.isLoading = true;
                _context7.prev = 1;
                _context7.next = 4;
                return axios.get(this.s3TransactionsJson);

              case 4:
                response = _context7.sent;

                this.transactions = response.data;
                _context7.next = 11;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7['catch'](1);

                console.error('Error fetching link map', _context7.t0);

              case 11:
                // console.log(this.transactions);
                this.plotSizes = {
                  smallest: this.transactions.filter(function (t) {
                    return t.pixels <= 256;
                  }),
                  small: this.transactions.filter(function (t) {
                    return t.pixels > 256 && t.pixels <= 1024;
                  }),
                  medium: this.transactions.filter(function (t) {
                    return t.pixels > 1024 && t.pixels <= 2304;
                  }),
                  large: this.transactions.filter(function (t) {
                    return t.pixels > 2304;
                  })
                };

                getRandomPlot = function getRandomPlot(size, tokenId) {
                  var plots = _this2.plotSizes[size];
                  var plot = void 0;
                  if (tokenId) {
                    plot = plots.find(function (t) {
                      return t.tokenId === tokenId;
                    });
                    if (!plot) {
                      return getRandomPlot(size);
                    }
                  } else {
                    // Pick a random plot
                    plot = plots[Math.floor(Math.random() * plots.length)];
                  }
                  // Remove it from the list
                  // console.log(`getRandomPlot: ${size}, tokenId: ${tokenId}, plot: ${plot}`);
                  _this2.plotSizes[size] = _this2.plotSizes[size].filter(function (t) {
                    return t.hash !== plot.hash;
                  });
                  return plot;
                };

                getPlotUrl = function getPlotUrl(plot, r) {
                  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    var imgUrl = 'https://millionbithomepage.com/trx/' + plot.hash + '-crop.jpeg';
                    // Load the image and round it into a circle, resulting in a data URL
                    var img = new Image();
                    img.crossOrigin = 'anonymous'; // Ensure cross-origin friendly loading
                    img.src = imgUrl;

                    img.onload = function () {
                      // console.log('loaded', imgUrl);
                      var canvas = document.createElement('canvas');
                      var ctx = canvas.getContext('2d');
                      canvas.width = r * 2;
                      canvas.height = r * 2;

                      // Calculate dimensions for cropping
                      var cropSize = Math.min(img.width, img.height); // Use the smaller dimension
                      var cropX = (img.width - cropSize) / 2; // Center crop
                      var cropY = (img.height - cropSize) / 2; // Center crop

                      // Create a circular clipping path
                      ctx.beginPath();
                      ctx.arc(r, r, r, 0, 2 * Math.PI);
                      ctx.closePath();
                      ctx.clip();

                      // Draw the cropped image centered in the circular area
                      ctx.drawImage(img, cropX, cropY, cropSize, cropSize, 0, 0, r * 2, r * 2);

                      // Get the data URL from the canvas
                      var dataURL = canvas.toDataURL();
                      // console.log(dataURL);

                      resolve(dataURL);
                    };
                  });
                };

                getPlotFruit = function () {
                  var _ref7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6(radius, scoreValue, size, tokenId) {
                    var plot, width, height, img;
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            plot = getRandomPlot(size, tokenId);

                            if (plot.x2) {
                              _context6.next = 25;
                              break;
                            }

                            // return getPlotFruit(size);
                            plot.x1 = 0;
                            plot.y1 = 0;

                            if (!(plot.pixels == 256)) {
                              _context6.next = 9;
                              break;
                            }

                            plot.x2 = 256;
                            plot.y2 = 256;
                            _context6.next = 25;
                            break;

                          case 9:
                            if (!(plot.pixels == 1024)) {
                              _context6.next = 14;
                              break;
                            }

                            plot.x2 = 1024;
                            plot.y2 = 1024;
                            _context6.next = 25;
                            break;

                          case 14:
                            if (!(plot.pixels == 2304)) {
                              _context6.next = 19;
                              break;
                            }

                            plot.x2 = 2304;
                            plot.y2 = 2304;
                            _context6.next = 25;
                            break;

                          case 19:
                            if (!(plot.pixels == 4096)) {
                              _context6.next = 24;
                              break;
                            }

                            plot.x2 = 4096;
                            plot.y2 = 4096;
                            _context6.next = 25;
                            break;

                          case 24:
                            return _context6.abrupt('return', getPlotFruit(radius, scoreValue, size));

                          case 25:
                            width = plot.x2 - plot.x1;
                            height = plot.y2 - plot.y1;
                            // if (size === 'medium' && width === height) {
                            //   // return getPlotFruit(size);
                            //   return getPlotFruit(radius, scoreValue, size);
                            // }

                            _context6.next = 29;
                            return getPlotUrl(plot, Math.min(width, height));

                          case 29:
                            img = _context6.sent;
                            return _context6.abrupt('return', {
                              radius: radius,
                              scoreValue: scoreValue,
                              img: img,
                              w: plot.x2 - plot.x1,
                              h: plot.y2 - plot.y1
                            });

                          case 31:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this2);
                  }));

                  return function getPlotFruit(_x5, _x6, _x7, _x8) {
                    return _ref7.apply(this, arguments);
                  };
                }();

                this.fruitSizes = [
                  // { radius: 16,  scoreValue: 1,  img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1 },
                  // { radius: 32,  scoreValue: 3,  img: await getPlotUrl(getRandomPlot('small')), scale: 0.1  },
                  // { radius: 40,  scoreValue: 6,  img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
                  // { radius: 56,  scoreValue: 2, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
                  // { radius: 64,  scoreValue: 15, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
                  // { radius: 72,  scoreValue: 21, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
                  // { radius: 84,  scoreValue: 28, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
                  // { radius: 96,  scoreValue: 36, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
                  // { radius: 128, scoreValue: 45, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
                  // { radius: 160, scoreValue: 55, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
                  // { radius: 192, scoreValue: 66, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1 },
                ];

                _context7.t1 = this.fruitSizes;
                _context7.next = 19;
                return getPlotFruit(16, 1, 'smallest');

              case 19:
                _context7.t2 = _context7.sent;

                _context7.t1.push.call(_context7.t1, _context7.t2);

                _context7.t3 = this.fruitSizes;
                _context7.next = 24;
                return getPlotFruit(32, 3, 'small');

              case 24:
                _context7.t4 = _context7.sent;

                _context7.t3.push.call(_context7.t3, _context7.t4);

                _context7.t5 = this.fruitSizes;
                _context7.next = 29;
                return getPlotFruit(40, 6, 'small');

              case 29:
                _context7.t6 = _context7.sent;

                _context7.t5.push.call(_context7.t5, _context7.t6);

                _context7.t7 = this.fruitSizes;
                _context7.next = 34;
                return getPlotFruit(56, 12, 'medium');

              case 34:
                _context7.t8 = _context7.sent;

                _context7.t7.push.call(_context7.t7, _context7.t8);

                _context7.t9 = this.fruitSizes;
                _context7.next = 39;
                return getPlotFruit(64, 15, 'medium');

              case 39:
                _context7.t10 = _context7.sent;

                _context7.t9.push.call(_context7.t9, _context7.t10);

                _context7.t11 = this.fruitSizes;
                _context7.next = 44;
                return getPlotFruit(72, 21, 'medium');

              case 44:
                _context7.t12 = _context7.sent;

                _context7.t11.push.call(_context7.t11, _context7.t12);

                _context7.t13 = this.fruitSizes;
                _context7.next = 49;
                return getPlotFruit(84, 28, 'medium');

              case 49:
                _context7.t14 = _context7.sent;

                _context7.t13.push.call(_context7.t13, _context7.t14);

                _context7.t15 = this.fruitSizes;
                _context7.next = 54;
                return getPlotFruit(96, 36, 'large');

              case 54:
                _context7.t16 = _context7.sent;

                _context7.t15.push.call(_context7.t15, _context7.t16);

                _context7.t17 = this.fruitSizes;
                _context7.next = 59;
                return getPlotFruit(128, 45, 'large');

              case 59:
                _context7.t18 = _context7.sent;

                _context7.t17.push.call(_context7.t17, _context7.t18);

                _context7.t19 = this.fruitSizes;
                _context7.next = 64;
                return getPlotFruit(160, 55, 'large');

              case 64:
                _context7.t20 = _context7.sent;

                _context7.t19.push.call(_context7.t19, _context7.t20);

                _context7.t21 = this.fruitSizes;
                _context7.next = 69;
                return getPlotFruit(192, 66, 'large');

              case 69:
                _context7.t22 = _context7.sent;

                _context7.t21.push.call(_context7.t21, _context7.t22);

                this.isLoading = false;

              case 72:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 8]]);
      }));

      function load() {
        return _ref6.apply(this, arguments);
      }

      return load;
    }()
  },
  mounted: function () {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var Matter;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "6wRV"));

            case 2:
              Matter = _context8.sent;

              window.Matter = Matter;
              _context8.next = 6;
              return this.load();

            case 6:
              // this.playGame();
              this.loadLeaderboard();

            case 7:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function mounted() {
      return _ref8.apply(this, arguments);
    }

    return mounted;
  }(),
  inject: ['updateAppRoute', 'appData', 'postToLambda', 'connectWallet'],
  created: function created() {
    this.updateAppRoute('drop');
    var isMuted = localStorage.getItem(LOCAL_STORAGE_DROP_MUTE_KEY);
    this.isMuted = isMuted === 'true';
  },
  beforeDestroy: function beforeDestroy() {
    // this.endGame();
    window.removeEventListener('resize', this.resizeCanvas);
  }
});

/***/ }),

/***/ "qA7t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about container",
    attrs: {
      "id": "million-bit-about"
    }
  }, [_c('h3', [_vm._v("About")]), _vm._v(" "), _c('p', [_vm._v("\n        Welcome to the Million Bit Homepage, where nostalgia meets blockchain innovation! Inspired by the original Million Dollar Homepage, we've brought the fun to Ethereum on Base for Onchain Summer.\n        "), _c('br'), _c('br'), _vm._v("\n        Be forever immortalized on the blockchain. Use ETH to upload your image and a link, to secure your spot on the homepage. At the end of onchain summer, the resulting image will be minted.\n        "), _c('br'), _c('br'), _vm._v("\n        Share your contribution and make sure to join our community on "), _c('a', {
    attrs: {
      "href": _vm.appData().telegram,
      "target": "_blank"
    }
  }, [_vm._v("Telegram")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": _vm.appData().twitter,
      "target": "_blank"
    }
  }, [_vm._v("Twitter")]), _vm._v(" for updates.\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Roadmap")]), _vm._v(" "), _vm._m(0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("✅ Homepage launch [done]")]), _vm._v(" "), _c('li', [_vm._v("✅ Affiliate program [done]")]), _vm._v(" "), _c('li', [_vm._v("✅ NFT launch to pixel owners [done]")]), _vm._v(" "), _c('li', [_vm._v("⏳ Community building (ongoing)")]), _vm._v(" "), _c('li', [_vm._v("🔜 Token launch (coming soon)")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qnmE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rk29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("L/hj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("QmSG");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'plots',
    data: function data() {
        return {
            contractAddress: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].NFT_CA,
            nftsLoading: true,
            nfts: [],
            repaintPrice: undefined,
            trxHashSuccess: undefined
        };
    },

    computed: {},
    methods: {
        navigateTo: function navigateTo(route) {
            this.$router.push(route);
        },
        repaint: function repaint(index, nft) {
            console.log('Repainting NFT', nft);
            this.$refs['fileInput-' + index][0].click();
        },
        onFileChange: function onFileChange(event, index, nft) {
            var _this = this;

            nft.showForm = true;
            console.log('File changed', index, nft);
            // return (event) => {
            console.log('File changed event', event);
            // Get the selected file
            var file = event.target.files[0];
            console.log('File', file);
            if (file && file.type.startsWith('image/')) {
                // Create a FileReader to read the image
                var reader = new FileReader();
                reader.onload = function (e) {
                    console.log('File reader loaded', e);
                    // Create a new image element
                    var img = new Image();
                    img.onload = function () {
                        // Get the canvas context and draw the image
                        var canvas = _this.$refs['canvas-' + index][0];
                        var ctx = canvas.getContext('2d');

                        // Clear the canvas before drawing a new image
                        ctx.clearRect(0, 0, nft.width, nft.height);

                        // Draw the image onto the canvas
                        ctx.drawImage(img, 0, 0, nft.width, nft.height);

                        // Place the canvas over the card image
                        var cardImage = _this.$refs['cardImage-' + index][0];
                        var cardImageWidth = cardImage.width;
                        var imgRatio = cardImageWidth / 128;
                        canvas.style.width = nft.width * imgRatio + 'px';
                        canvas.style.height = nft.height * imgRatio + 'px';
                        canvas.style.top = (128 / 2 + 16 - nft.height / 2) * imgRatio + 'px'; // (((144 * imgRatio)) / 2) + (17 * imgRatio) - ((nft.height * imgRatio)) + 'px';
                        canvas.style.left = 128 * imgRatio / 2 - nft.width * imgRatio / 2 + 'px';
                    };
                    // Set the source of the image element to the file data
                    img.src = e.target.result;
                };
                // Read the image file as a data URL
                reader.readAsDataURL(file);
            }
            // };
        },
        getRepaintPrice: function getRepaintPrice() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, provider, contract, price;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                console.log('Getting repaint price');
                                _context.next = 3;
                                return _this2.getProviderSigner();

                            case 3:
                                _ref = _context.sent;
                                provider = _ref.provider;
                                contract = new ethers.Contract(_this2.contractAddress, __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].NFT_ABI, provider);
                                _context.next = 8;
                                return contract.repaintPrice();

                            case 8:
                                price = _context.sent;

                                console.log('Repaint price', price);
                                _this2.repaintPrice = price;
                                return _context.abrupt('return', price);

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },

        // Get the NFTs owned by the connected wallet
        getNFTs: function getNFTs() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var userAddress, _ref2, provider, signer, contract, balance, nftData, i, tokenId, nft, tokenURI, metadata, nftLink, nftCoordinates, nftCoords, nftXY1, nftXY2, nftWidth, nftHeight;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this3.nftsLoading = true;
                                _context2.prev = 1;
                                userAddress = _this3.appData().connectedAccount.address;
                                _context2.next = 5;
                                return _this3.getProviderSigner();

                            case 5:
                                _ref2 = _context2.sent;
                                provider = _ref2.provider;
                                signer = _ref2.signer;
                                contract = new ethers.Contract(_this3.contractAddress, __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].NFT_ABI, signer);

                                // Get the user's balance of NFTs

                                _context2.next = 11;
                                return contract.balanceOf(userAddress);

                            case 11:
                                balance = _context2.sent;
                                nftData = [];

                                // Loop through each token the user owns

                                i = 0;

                            case 14:
                                if (!(i < balance)) {
                                    _context2.next = 44;
                                    break;
                                }

                                _context2.next = 17;
                                return contract.tokenOfOwnerByIndex(userAddress, i);

                            case 17:
                                tokenId = _context2.sent;
                                nft = {
                                    showForm: false,
                                    canBuy: false,
                                    tokenId: tokenId.toString(),
                                    isLoading: false

                                    // Fetch the metadata for each token (assuming it uses tokenURI)
                                };
                                _context2.next = 21;
                                return contract.tokenURI(tokenId);

                            case 21:
                                tokenURI = _context2.sent;
                                _context2.prev = 22;
                                _context2.next = 25;
                                return fetch(tokenURI).then(function (response) {
                                    return response.json();
                                });

                            case 25:
                                metadata = _context2.sent;
                                nftLink = metadata.attributes.find(function (attr) {
                                    return attr.trait_type === 'Link';
                                }).value;
                                nftCoordinates = metadata.attributes.find(function (attr) {
                                    return attr.trait_type === 'Coordinates';
                                }).value;
                                nftCoords = nftCoordinates.split(' to ');
                                nftXY1 = nftCoords[0].substring(1, nftCoords[0].length - 1).split(',');
                                nftXY2 = nftCoords[1].substring(1, nftCoords[1].length - 1).split(',');
                                nftWidth = parseInt(nftXY2[0]) - parseInt(nftXY1[0]);
                                nftHeight = parseInt(nftXY2[1]) - parseInt(nftXY1[1]);


                                nftData.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, nft, {
                                    width: nftWidth,
                                    height: nftHeight,
                                    x1: parseInt(nftXY1[0]),
                                    y1: parseInt(nftXY1[1]),
                                    link: nftLink
                                }, metadata));
                                _context2.next = 41;
                                break;

                            case 36:
                                _context2.prev = 36;
                                _context2.t0 = _context2['catch'](22);

                                console.log('Error fetching metadata for token ' + tokenId, _context2.t0);
                                nftData.push(nft);
                                _this3.nftsLoading = false;

                            case 41:
                                i++;
                                _context2.next = 14;
                                break;

                            case 44:

                                // Set the NFTs in the component's state
                                _this3.nfts = nftData;
                                _this3.nftsLoading = false;
                                _context2.next = 52;
                                break;

                            case 48:
                                _context2.prev = 48;
                                _context2.t1 = _context2['catch'](1);

                                console.error('Error getting NFTs', _context2.t1);
                                _this3.nftsLoading = false;

                            case 52:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3, [[1, 48], [22, 36]]);
            }))();
        },
        submitNewImage: function submitNewImage(index, nft) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _ref3, provider, signer, contract, canvas, ctx, imageData, pixels_data, pixels_data_strs, pixels_data_str, pixels_data_gzip_str, tx, tokenContract, repaintTokenPrice, approveTrx, approveReceipt, estimatedGas, gasLimit, overrides, receipt, hash;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                console.log('Submitting new image');
                                _context3.next = 3;
                                return _this4.getRepaintPrice();

                            case 3:
                                _context3.next = 5;
                                return _this4.getProviderSigner();

                            case 5:
                                _ref3 = _context3.sent;
                                provider = _ref3.provider;
                                signer = _ref3.signer;
                                contract = new ethers.Contract(_this4.contractAddress, __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].NFT_ABI, signer);
                                canvas = _this4.$refs['canvas-' + index][0];
                                ctx = canvas.getContext('2d');
                                imageData = ctx.getImageData(0, 0, nft.width, nft.height).data;
                                pixels_data = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].getPixelsData(imageData, nft.width, nft.height);
                                pixels_data_strs = [];

                                _.times(nft.height / 16, function (h) {
                                    _.times(nft.width / 16, function (w) {
                                        pixels_data_strs.push(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].stringDataForEth(pixels_data[h][w], nft.link, 0, h, w, nft.x1, nft.y1));
                                    });
                                });

                                console.log('pixels_data_strs', pixels_data_strs);
                                pixels_data_str = pixels_data_strs.join('\n');
                                pixels_data_gzip_str = pako.deflate(pixels_data_str, { to: 'string' });


                                console.log('pixels_data_str length: ' + pixels_data_str.length);
                                console.log('pixels_data_gzip_str length: ' + pixels_data_gzip_str.length);
                                console.log('compression ratio: ' + pixels_data_str.length / pixels_data_gzip_str.length);

                                // console.log('New image', pixels_data_gzip_str);
                                _context3.prev = 21;

                                nft.isLoading = true;
                                tx = void 0;

                                if (true) {
                                    _context3.next = 43;
                                    break;
                                }

                                tokenContract = new ethers.Contract(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].TOKEN_CA, __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].TOKEN_ABI, signer);
                                // TODO get live value from contract

                                _context3.next = 28;
                                return contract.tokenRepaintPrice();

                            case 28:
                                repaintTokenPrice = _context3.sent;

                                // console.log(`Repaint token price: ${tokens}`);
                                // const repaintTokenPrice = ethers.parseUnits(tokens.toString(), 18);
                                console.log('Repaint token price', repaintTokenPrice);
                                _context3.next = 32;
                                return tokenContract.approve(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].NFT_CA, repaintTokenPrice);

                            case 32:
                                approveTrx = _context3.sent;

                                console.log('Approved ' + repaintTokenPrice + ' tokens for NFT contract:', approveTrx);
                                _context3.next = 36;
                                return approveTrx.wait();

                            case 36:
                                approveReceipt = _context3.sent;

                                console.log('Approval receipt:', approveReceipt);
                                _context3.next = 40;
                                return contract.tokenRepaintPixels(nft.tokenId, pixels_data_gzip_str);

                            case 40:
                                tx = _context3.sent;
                                _context3.next = 51;
                                break;

                            case 43:
                                _context3.next = 45;
                                return contract.repaintPixels.estimateGas(nft.tokenId, pixels_data_gzip_str, { value: _this4.repaintPrice });

                            case 45:
                                estimatedGas = _context3.sent;
                                gasLimit = _this4.getGasLimitFromEstimate(estimatedGas);
                                overrides = {
                                    gasLimit: gasLimit,
                                    value: _this4.repaintPrice
                                };
                                _context3.next = 50;
                                return contract.repaintPixels(nft.tokenId, pixels_data_gzip_str, overrides);

                            case 50:
                                tx = _context3.sent;

                            case 51:

                                console.log('Repaint transaction', tx);

                                _context3.next = 54;
                                return tx.wait();

                            case 54:
                                receipt = _context3.sent;
                                hash = receipt.hash;

                                nft.isLoading = false;

                                // Show modal with success message
                                _this4.trxHashSuccess = hash;
                                _this4.$bvModal.show('modal-repaint-success');
                                __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].confetti(10000);

                                // Trigger lambda
                                try {
                                    fetch(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].WEBHOOK_URL + '?trigger=true', {
                                        method: 'GET'
                                    });
                                } catch (e) {
                                    console.log('Error triggering lambda', e);
                                }
                                _context3.next = 69;
                                break;

                            case 63:
                                _context3.prev = 63;
                                _context3.t0 = _context3['catch'](21);

                                nft.isLoading = false;

                                __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].trackEvent('trxFailed');
                                console.error('Error sending:', _context3.t0);
                                _this4.handleWalletError(_context3.t0);

                            case 69:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4, [[21, 63]]);
            }))();
        }
    },
    mounted: function mounted() {
        if (this.appData().connectedAccount) {
            this.getNFTs();
        } else {
            this.$on('accountConnected', this.getNFTs);
        }
    },
    inject: ['updateAppRoute', 'appData', 'postToLambda', 'getProviderSigner', 'handleWalletError', 'getGasLimitFromEstimate'],
    created: function created() {
        this.updateAppRoute('plots');
    }
});

/***/ }),

/***/ "sTm+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sWtQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "billboard",
    class: {
      'showTooltip': _vm.hovering
    },
    attrs: {
      "id": "million-bit-billboard"
    },
    on: {
      "click": _vm.clickBillboard,
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "mousemove": _vm.onMouseMove
    }
  }, [_c('canvas', {
    attrs: {
      "id": "uploadedImg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.s3ImgSrc,
      "usemap": "#linkmap"
    },
    on: {
      "load": _vm.onBillboardLoaded
    }
  }), _vm._v(" "), _c('map', {
    attrs: {
      "name": "linkmap"
    }
  }, _vm._l((_vm.links), function(link) {
    return _c('area', {
      attrs: {
        "target": "_blank",
        "alt": "",
        "title": "",
        "shape": "rect",
        "coords": link.c,
        "href": link.u
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    ref: 'tooltip',
    attrs: {
      "id": "billboard-tooltip"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tmNq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tttU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bit-drop",
    attrs: {
      "id": "million-bit-drop"
    }
  }, [_c('div', {
    attrs: {
      "id": "game-menu"
    }
  }, [_c('div', [_c('span', {
    staticClass: "btn-group nav-buttons"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-outline-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/')
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-house",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z"
    }
  })])]), _vm._v(" "), (!_vm.isMuted) ? _c('button', {
    staticClass: "btn btn-icon btn-outline-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.mute(true)
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-volume-up-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isMuted) ? _c('button', {
    staticClass: "btn btn-icon btn-outline-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.mute(false)
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-volume-mute-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"
    }
  })])]) : _vm._e()])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('h3', [_c('span', {
    attrs: {
      "id": "score-label"
    }
  }, [_vm._v("Score")]), _vm._v(" "), _c('span', {
    staticClass: "honk-text",
    domProps: {
      "textContent": _vm._s(_vm.score)
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "game-frame"
    }
  }, [(!_vm.isPlaying) ? _c('div', {
    attrs: {
      "id": "game-over"
    }
  }, [_c('h1', [_vm._v("Your Score "), _c('span', {
    staticClass: "honk-text",
    domProps: {
      "textContent": _vm._s(_vm.score)
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("High Score "), _c('span', {
    staticClass: "honk-text",
    domProps: {
      "textContent": _vm._s(_vm.highscore)
    }
  })]), _vm._v(" "), (_vm.isSponsored) ? _c('div', {
    staticClass: "bg-danger border text-left p-1 text-center"
  }, [_c('span', {}, [_vm._v("Win Moon Credits by getting on the leaderboard and sharing your score on Twitter X!")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.score > 0) ? _c('a', {
    staticClass: "btn btn-block btn-lg btn-outline-light",
    attrs: {
      "href": _vm.xPost,
      "target": "_blank"
    }
  }, [_vm._v("Share on X")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-lg btn-warning my-5",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.newGame();
      }
    }
  }, [_vm._v("New Game")]), _vm._v(" "), _c('div', {
    staticClass: "mt-4",
    attrs: {
      "id": "game-leaderboard"
    }
  }, [_c('h3', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Leaderboard")]), _vm._v(" "), (!_vm.appData().connectedAccount.address) ? _c('p', [_vm._v("Join the leaderboard by first connecting your wallet! "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon btn-block btn-info mt-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.connectWallet()
      }
    }
  }, [_vm._v("\n            Connect Wallet\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-block"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-block btn-outline-light my-3",
    class: {
      'disabled': this.leaderBoardToggle === 'all'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLeaderBoard()
      }
    }
  }, [_vm._v("\n            This Week\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon btn-block btn-outline-light my-3",
    class: {
      'disabled': this.leaderBoardToggle === 'week'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLeaderBoard()
      }
    }
  }, [_vm._v("\n            All Time\n          ")])]), _vm._v(" "), (_vm.appData().connectedAccount.address) ? _c('p', [_vm._v("\n          Player: \n          "), (_vm.appData().connectedAccount.avatar) ? _c('img', {
    staticClass: "ensAvatar",
    staticStyle: {
      "max-height": "22px"
    },
    attrs: {
      "src": _vm.appData().connectedAccount.avatar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.appData().connectedAccount.name) ? _c('span', [_vm._v(_vm._s(_vm.appData().connectedAccount.name))]) : _vm._e(), _vm._v(" "), (!_vm.appData().connectedAccount.name) ? _c('span', [_vm._v(_vm._s(_vm.appData().connectedAccount.addressTrunc))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.gameLeaderboard.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.gameLeaderboard), function(entry, index) {
    return _c('tr', {
      key: entry._id
    }, [_c('td', [_c('h5', {
      staticClass: "mr-1 honk-text"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [(entry.player.avatar) ? _c('span', [_c('img', {
      staticClass: "ensAvatar",
      staticStyle: {
        "max-height": "22px"
      },
      attrs: {
        "src": entry.player.avatar
      }
    })]) : _vm._e(), _vm._v(" "), (entry.player.name) ? _c('span', [_vm._v(_vm._s(entry.player.name))]) : _vm._e(), _vm._v(" "), (!entry.player.name && entry.player.addressTrunc) ? _c('span', [_vm._v(_vm._s(entry.player.addressTrunc))]) : _vm._e(), _vm._v(" "), (!entry.player.name && !entry.player.addressTrunc) ? _c('span', [_vm._v("Anon")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('h4', {
      staticClass: "mr-1 honk-text"
    }, [(entry.didWin) ? _c('span', {
      staticClass: "pr-2"
    }, [_vm._v("🏆")]) : _vm._e(), _vm._v(_vm._s(entry.score))])])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _vm._m(3)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "honk-text"
  }, [_vm._v("Million Base Drop")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-justify"
  }, [_c('a', {
    staticClass: "btn btn-sm",
    attrs: {
      "href": "https://x.com/BitHomepage/status/1858604087782371539",
      "target": "_blank"
    }
  }, [_vm._v("Learn more")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm float-right",
    attrs: {
      "href": "https://x.com/Moon_Credits",
      "target": "_blank"
    }
  }, [_vm._v("Sponsor "), _c('img', {
    staticStyle: {
      "border-radius": "50%",
      "max-height": "16px"
    },
    attrs: {
      "src": "https://millionbithomepage.com/trx/0xe1ce4dc5a815a3d9324947ef8cd6569745e19f76af013442a49b7c9b6eda9c54-crop.jpeg"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-left"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Player")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Score")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "game-canvas"
    }
  }, [_c('div', {
    attrs: {
      "id": "game-ui"
    }
  }, [_c('p', {
    attrs: {
      "id": "game-score"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "game-end-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "game-end"
    }
  }, [_c('div', {
    attrs: {
      "id": "game-end-title"
    }
  }, [_vm._v("Game Over!")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "game-end-link",
      "href": ""
    }
  }, [_vm._v("Try Again")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "game-status"
    }
  }, [_c('div', {
    staticClass: "game-status-item"
  }, [_c('div', {
    staticClass: "game-status-label"
  }, [_vm._v("Highscore")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "game-highscore-value"
    }
  }, [_vm._v("0")])]), _vm._v(" "), _c('div', {
    staticClass: "game-status-item"
  }, [_c('div', {
    staticClass: "game-status-label"
  }, [_vm._v("Next")]), _vm._v(" "), _c('img', {
    attrs: {
      "id": "game-next-fruit",
      "src": "/static/drop/img/circle0.png"
    }
  })])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__("L/hj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__("oiih");








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/*global ethers*/
/*global ethereum*/
/*global qq*/
/*global interact*/
/*global pako*/
/*global _*/
var Buffer = __webpack_require__("63KW").Buffer;
window.Buffer = Buffer;





__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default.a);





var DEMO_MODE = __webpack_require__.i({"NODE_ENV":"production","BASE_S3_BUCKET":"https://millionbithomepage.com/static/billboard/","BASE_S3_BUCKET_TRX":"https://millionbithomepage.com/trx/"}).DEMO_MODE || false;
var DEMO_ADDRESS = __webpack_require__.i({"NODE_ENV":"production","BASE_S3_BUCKET":"https://millionbithomepage.com/static/billboard/","BASE_S3_BUCKET_TRX":"https://millionbithomepage.com/trx/"}).DEMO_ADDRESS || false;
var WEBHOOK_URL = 'https://ta2f7ylhwu46yoen7xk2pvueee0qtjjt.lambda-url.us-west-2.on.aws/';
var PUSH_SUB_URL = 'https://nnwj3qjluewoavvztzguep5yse0dgbet.lambda-url.us-west-2.on.aws/';
var TOKEN_PIXEL_PRICE = 1;
var ETH_PIXEL_PRICE = DEMO_ADDRESS ? 0.00008 : 0.00008; // 0.00026 // $1 USD at 5/29/2024
var BID_TO_ADDRESS = DEMO_ADDRESS ? '0xCF6ecdA3F26F2fbd242Ec7f7Aa59a3B627e912ab' : '0x5493dB14A2b6fd71B531fa1CFc752FdFaD734AcD'; // MBH
var TOKEN_IMAGE_URL = 'https://millionbithomepage.com/static/favicon-32x32.png';
var ETH_NETWORK = '1'; // '1' is the Ethereum main network ID.
var BASE_NETWORK = '8453'; // Base Mainnet
var BASE_CHAIN_ID = '0x2105'; // Base Mainnet
var ETH_GAS_PRICE = __webpack_require__.i({"NODE_ENV":"production","BASE_S3_BUCKET":"https://millionbithomepage.com/static/billboard/","BASE_S3_BUCKET_TRX":"https://millionbithomepage.com/trx/"}).ETH_GAS_PRICE || '0.000000002';
var ETH_GAS_LIMIT = __webpack_require__.i({"NODE_ENV":"production","BASE_S3_BUCKET":"https://millionbithomepage.com/static/billboard/","BASE_S3_BUCKET_TRX":"https://millionbithomepage.com/trx/"}).ETH_GAS_LIMIT || 6000000; // max is around 8000000?
var PIXEL_PER_SQUARE = 16;
var MAX_IMAGE_SIZE = PIXEL_PER_SQUARE * 4;
var applicationServerPublicKey = 'BESOSUO9VPh2EnimIVXt9MjactiD21wbBivbfB4JZr5UWtVN8dQGUOg0uFzB9uWFdLPGfYFkCCDq3pv6XzNIGrQ';
var DID_PROMPT_NOTIFICATIONS = 'DID_PROMPT_NOTIFICATIONS';
var LOCAL_STORAGE_NOTIFICATION_SUB_ENDPOINT = 'NOTIFICATION_SUB_ENDPOINT';
var LOCAL_STORAGE_KEY_REFERRAL = 'REF_CODE';
var LOCAL_STORAGE_KEY_DEMO_VID = 'DEMO_VID';
var BASENAME_L2_RESOLVER_ADDRESS = '0xC6d566A56A1aFf6508b41f6c90ff131615583BCD';

var DO_LOG = "production" !== 'production';
function log() {
  if (DO_LOG) {
    console.log.apply(console, arguments);
  }
}

function urlB64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function trackEvent(t) {
  try {
    if (window.gtag) {
      gtag('event', t);
    }
  } catch (e) {
    console.error('Failed to track event', e);
  }
}

function doCountdown() {
  var second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;

  var countDownEndDate = new Date("10/10/2024");
  var countDown = countDownEndDate.getTime();
  window.countdownInterval = setInterval(function () {
    var now = new Date().getTime();
    var distance = countDown - now;
    if (distance < 0) {
      distance = 0;
      clearInterval(window.countdownInterval);
    }

    document.getElementById("days").innerText = Math.floor(distance / day), document.getElementById("hours").innerText = Math.floor(distance % day / hour), document.getElementById("minutes").innerText = Math.floor(distance % hour / minute), document.getElementById("seconds").innerText = Math.floor(distance % minute / second);

    //do something later when date is reached
    if (distance < 0) {
      // document.getElementById("countdown").style.display = "none";
      clearInterval(window.countdownInterval);
    }
    //seconds
  }, 0);
}

function stringDataForEth(arr, url, bid, r, c) {
  var DATA_ENCODING_VERSION = 1;
  // for(var i in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]) {
  //   for(var ii in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]) {
  //     is.push(""+i+","+ii+"#0000ff");
  //   }
  // }
  // log('window offset', window.img_offset_x, window.img_offset_y);
  // log('STRING DATA FOR PIXEL DATA', arr, r, c, typeof r, typeof c)

  if (typeof r === 'string') {
    r = parseInt(r, 10);
  }
  if (typeof c === 'string') {
    c = parseInt(c, 10);
  }

  var colors = [];
  for (var i in arr) {
    var p = arr[i];
    colors.push(p['hex']);
  }
  var xOffset = window.img_offset_x / 16 + c;
  var yOffset = window.img_offset_y / 16 + r;
  log('stringDataForEth', window.img_offset_x, window.img_offset_y, xOffset, yOffset, c, r);
  return "v" + DATA_ENCODING_VERSION + "|" + xOffset + "," + yOffset + "|" + colors.join(',') + "|" + bid + "|" + encodeURIComponent(url);
}

function getPriceForPosition(img_offset_x, img_offset_y, canvasWidth, canvasHeight, disallowExistingPixels) {
  var tokenCost = 0;
  // log('getPriceForPosition', img_offset_x, img_offset_y, canvasWidth, canvasHeight)
  window.segmentPrices = [];

  var coversExistingPixels = false;
  var pixelsPerSegment = 16 * 16;

  _.times(canvasHeight / 16, function (h) {
    var cols = [];
    _.times(canvasWidth / 16, function (w) {
      // log('get price for section', h, w)
      var price = "0.000";

      // FIND price in data
      var priceDoc = _.find(window.pricesData, { 'x': img_offset_x / 16 + w, 'y': img_offset_y / 16 + h });
      if (priceDoc) {
        price = priceDoc.p;
        coversExistingPixels = true;
      }

      // let sectionPriceInWei = ethers.parseEther(price).add(ethers.parseEther(DONATION_PIXEL_PRICE).mul(pixelsPerSegment));
      // costInWei = costInWei.add(sectionPriceInWei);
      var sectionPriceInWei = pixelsPerSegment;
      tokenCost = tokenCost + sectionPriceInWei;

      cols.push(tokenCost);
    });
    window.segmentPrices.push(cols);
  });

  if (disallowExistingPixels && coversExistingPixels) {
    return false;
  }

  // log('window.segmentPrices', window.segmentPrices)
  return tokenCost;
}

function getHexFromRgb(r, g, b) {
  return ("0" + r.toString(16)).slice(-2) + ("0" + g.toString(16)).slice(-2) + ("0" + b.toString(16)).slice(-2);
}

function getPixelsData(myImageData, width, height) {
  log('getPixelsData', myImageData, width, height);
  var pixels_arr = [];
  var p = 0;
  for (var i in myImageData) {
    if (i % 4 === 0) {
      pixels_arr[p] = {
        "r": myImageData[i]
      };
    } else if (i % 4 === 1) {
      pixels_arr[p]["g"] = myImageData[i];
    } else if (i % 4 === 2) {
      pixels_arr[p]["b"] = myImageData[i];
    } else if (i % 4 === 3) {
      pixels_arr[p]["a"] = myImageData[i];
      // log(pixels_arr[p]["a"])
      pixels_arr[p]["hex"] = getHexFromRgb(pixels_arr[p]["r"], pixels_arr[p]["g"], pixels_arr[p]["b"]);
      // if(p % canvas.width == 0) {
      //   log(pixels_arr[p])
      // }
      p++;
    }
  }

  var rows = [];
  var ha = new Array(height / 16);
  var wa = new Array(width / 16);
  for (var hi = 0; hi < ha.length; hi++) {
    // for each vertical section
    var cols = [];
    for (var wi = 0; wi < wa.length; wi++) {
      // for each horizontal section
      cols.push([]);
    }
    rows.push(cols);
  }

  // rows is multidimension array to hold image data

  var _loop = function _loop(row) {
    // for each vertical section
    _.times(16, function (y) {
      var _loop2 = function _loop2(col) {
        // for each horizontal section
        _.times(16, function (x) {
          rows[row][col].push(pixels_arr.shift());
        });
      };

      for (var col = 0; col < wa.length; col++) {
        _loop2(col);
      }
    });
  };

  for (var row = 0; row < ha.length; row++) {
    _loop(row);
  }

  return rows;
}

function getScaledContext(origWidth, origHeight, width, height, imgd) {

  var newCanvas = document.createElement('canvas');
  newCanvas.width = width;
  newCanvas.height = height;
  newCanvas.style.visibility = 'hidden';

  document.body.appendChild(newCanvas);

  var destCtx = newCanvas.getContext("2d");

  var tmpCanvas = document.createElement('canvas');
  tmpCanvas.width = origWidth;
  tmpCanvas.height = origHeight;
  tmpCanvas.style.visibility = 'hidden';
  document.body.appendChild(tmpCanvas);

  tmpCanvas.getContext("2d").putImageData(imgd, 0, 0);

  destCtx.drawImage(tmpCanvas, 0, 0, width, height);

  return destCtx;
}

function fetchImage(url) {
  return fetch(url).then(function (response) {
    return response.blob();
  }).then(function (blob) {
    var fileName = url.substring(url.lastIndexOf('/') + 1);
    return new File([blob], fileName, { type: blob.type });
  });
}

function initUploader(self) {
  log('initUploader');
  // if (!document.querySelector('#million-bit-billboard > img')) {
  //   return;
  // }
  window.img_offset_x = 0;
  window.img_offset_y = 0;

  if (window.manualUploader) {
    __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].clearDraggableImage();
    window.manualUploader.reset();
    delete window.manualUploader;
  }

  if (window.interactable) {
    window.interactable.unset();
    delete window.interactable;
  }

  if (self.loader) {
    self.loader.hide();
  }

  function resizeImageMax(canvas, img) {
    // Resize if too large
    var maxSize = MAX_IMAGE_SIZE;
    var width = canvas.width;
    var height = canvas.height;
    if (width > height) {
      if (width > maxSize) {
        height *= maxSize / width;
        width = maxSize;
      }
    } else {
      if (height > maxSize) {
        width *= maxSize / height;
        height = maxSize;
      }
    }

    // Scale to PIXEL_PER_SQUARE 
    if (width % PIXEL_PER_SQUARE !== 0) {
      width = width - width % PIXEL_PER_SQUARE;
    }
    if (height % PIXEL_PER_SQUARE !== 0) {
      height = height - height % PIXEL_PER_SQUARE;
    }
    return { canvasWidth: width, canvasHeight: height };
  }

  window.uploadedImgData = null;

  window.manualUploader = new qq.FineUploader({
    element: document.getElementById('fine-uploader-manual-trigger'),
    template: 'qq-template-manual-trigger',
    callbacks: {
      onStatusChange: function onStatusChange(id, old, newStatus) {
        log("onStatusChange", arguments);
        if (newStatus === 'submitting') {
          log('submitting');
          self.loader = self.$loading.show({
            // Optional parameters
            // container: this.fullPage ? null : this.$refs.formContainer,
            // canCancel: true,
            // onCancel: this.onCancel,
          });
        } else if (newStatus === 'submitted') {
          log('submitted');
        } else if (newStatus === 'rejected') {
          this.reset();
          self.loader.hide();
          self.showAlert('The selected image is too large.');
        }
      }
      // onSubmitted: function(id) {
      //   log("onSubmitted", self)
      // },
      // onSubmit: function(id) {
      //   log("onSubmit", self)
      // },
      // onCancel: function(id) {
      //   log("CANCELED")
      // },
      // onProgress: function(id) {
      //   log("onProgress")
      // },
      // onValidate: function(id) {
      //   log("onValidate")
      // },
      // onError: function(id) {
      //   log("onError", arguments)
      // },
    },
    thumbnails: {
      // placeholders: {
      //     waitingPath: '/source/placeholders/waiting-generic.png',
      //     notAvailablePath: '/source/placeholders/not_available-generic.png'
      // },
      customResizer: function customResizer(resizeInfo) {
        return new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          // log(resizeInfo.sourceCanvas)
          var canvas = resizeInfo.sourceCanvas;

          log("Uploaded image", canvas.width, canvas.height, canvas);
          trackEvent('uploadedImage');
          trackEvent('add_to_cart');

          self.saveEvent('uploadedImage', {});

          document.getElementById('million-bit-billboard').classList.add('tooltip-place');

          var ctx = resizeInfo.sourceCanvas.getContext('2d');
          // log('canvas size', canvas.width, canvas.height)

          var _resizeImageMax = resizeImageMax(canvas),
              canvasWidth = _resizeImageMax.canvasWidth,
              canvasHeight = _resizeImageMax.canvasHeight;

          var imgd = ctx.getImageData(0, 0, canvas.width, canvas.height);
          var myImageData = imgd.data;
          window.uploadedImgObj = { data: imgd, width: canvas.width, height: canvas.height };

          var c = document.getElementById("uploadedImg");
          c.style.display = 'block';
          c.width = canvas.width;
          c.height = canvas.height;
          c.style.width = canvasWidth + 'px';
          c.style.height = canvasHeight + 'px';
          var uploadedImgCtx = c.getContext("2d");

          // Replace transparent pixels with white
          __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].replaceTransparent(myImageData);

          uploadedImgCtx.putImageData(imgd, 0, 0);

          window.img_offset_x = 0;
          window.img_offset_y = 0;
          window.img_width = canvasWidth;
          window.img_height = canvasHeight;
          log('customResizer', canvasWidth, canvasHeight);

          var destCtx = getScaledContext(c.width, c.height, canvasWidth, canvasHeight, imgd);
          var d = destCtx.getImageData(0, 0, canvasWidth, canvasHeight).data;
          myImageData = d;

          // let canvasPixels = (canvasWidth * canvasHeight);
          // Check if we have a spot we would like to place this
          // console.log(`Checking if we have a spot we would like to place this image on`, self.uploadToXY);
          if (self.uploadToXY && self.uploadToXY.x && self.uploadToXY.y) {
            // console.log(`Placing image on spot`, self.uploadToXY);
            self.moveImage(self.uploadToXY.x, self.uploadToXY.y, true);
            self.uploadToXY = null;
          }

          self.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);

          // target elements with the "draggable" class
          window.interactable = interact('#uploadedImg').resizable({
            origin: 'parent',
            edges: {
              top: false,
              left: false,
              bottom: true,
              right: true
            },
            modifiers: [
            // https://interactjs.io/docs/snapping/#snapsize
            interact.modifiers.snapSize({
              targets: [interact.snappers.grid({ width: 16, height: 16 })]
            }),
            // https://interactjs.io/docs/snapping/#snap
            // interact.modifiers.snap({
            //   targets: [
            //     interact.createSnapGrid({ x: 16, y: 16 })
            //   ],
            //   relativePoints: [ { x: 0, y: 0 } ]
            // }),
            interact.modifiers.restrictSize({
              min: { width: 16, height: 16 },
              max: { width: MAX_IMAGE_SIZE, height: MAX_IMAGE_SIZE }
            })]
          }).on('resizemove', function (event) {
            log('resizemove', event.rect.width, event.rect.height);
            // let { x, y } = event.target.dataset
            // document.getElementById('million-bit-billboard').classList.remove('tooltip-place');

            __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(event.target.style, {
              width: event.rect.width + 'px',
              height: event.rect.height + 'px'
              // transform: `translate(${event.deltaRect.left}px, ${event.deltaRect.top}px)`
            });
            window.img_width = event.rect.width;
            window.img_height = event.rect.height;

            var destCtx = getScaledContext(c.width, c.height, event.rect.width, event.rect.height, imgd);
            var d = destCtx.getImageData(0, 0, event.rect.width, event.rect.height).data;
            window.myImageData = d;
            // window.pixels_data = getPixelsData(d, event.rect.width, event.rect.height);
            // log(window.pixels_data)
            self.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
            // self.setEthAmt(getPriceForPosition(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height));
            // Object.assign(event.target.dataset, { x, y })
          }).draggable({
            origin: 'parent',
            inertia: false, // disable inertial throwing
            // keep the element within the area of it's parent
            // edges: { top: true, left: true },
            modifiers: [interact.modifiers.snap({
              targets: [interact.createSnapGrid({ x: 16, y: 16 })],
              relativePoints: [{ x: 0, y: 0 }]
            }), interact.modifiers.restrict({
              restriction: "parent",
              endOnly: false,
              elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
            })],
            autoScroll: true,
            // call this function on every dragmove event
            onmove: dragMoveListener,
            // call this function on every dragend event
            onend: function onend(event) {
              var parentPos = document.getElementById('million-bit-billboard').getBoundingClientRect();
              var childrenPos = document.getElementById('uploadedImg').getBoundingClientRect();
              window.img_offset_x = Math.floor(childrenPos.left - parentPos.left);
              window.img_offset_y = Math.floor(childrenPos.top - parentPos.top);
              // Update price
              // log('Set price for position', window.img_offset_x, window.img_offset_y, 'size', window.img_width, window.img_height);
              self.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
            }
          });

          function dragMoveListener(event) {
            // document.getElementById('million-bit-billboard').classList.remove('tooltip-place');
            var target = event.target,

            // keep the dragged position in the data-x/data-y attributes
            x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
                y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

            // translate the element
            // target.style.webkitTransform =
            target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

            // update the position attributes
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
          }

          window.interactable.reflow({ name: 'drag', axis: 'xy' });

          window.myImageData = myImageData;
          // window.pixels_data = getPixelsData(myImageData, canvas.width, canvas.height);
          // log(window.pixels_data)
          // log('pixel data done....');
          self.loader.hide();
          self.canBuy = true;

          resolve();
        });
      }
    },
    autoUpload: false,
    debug: DO_LOG,
    validation: {
      allowedExtensions: ["jpeg", "jpg", "png"],
      acceptFiles: "image/jpeg, image/png",
      stopOnFirstInvalidFile: true,
      sizeLimit: 1000 * 1000
    }
  });
}

function getEncodedEthDataValue(DATA_VALUE_UNENCODED) {
  return ethers.AbiCoder.defaultAbiCoder().encode([{ "name": "_value", "type": "string" }], [DATA_VALUE_UNENCODED]);
}

function pollForCompletion(txHash, callback) {
  var calledBack = false;

  // Normal ethereum blocks are approximately every 15 seconds.
  // Here we'll poll every 2 seconds.
  var checkInterval = setInterval(function () {

    var notYet = 'response has no error or result';

    ethereum.sendAsync({
      method: 'eth_getTransactionByHash',
      params: [txHash]
    }, function (err, response) {
      if (calledBack) return;
      if (err || response.error) {
        if (err.message.includes(notYet)) {
          return 'transaction is not yet mined';
        }
        callback(err || response.error);
      }
      // We have successfully verified the mined transaction.
      // Mind you, we should do this server side, with our own blockchain connection.
      // Client side we are trusting the user's connection to the blockchain.
      var transaction = response.result;
      clearInterval(checkInterval);
      calledBack = true;
      callback(null, transaction);
    });
  }, 2000);
}

var multiplyEth = function multiplyEth(eth, multiplier) {
  var multipliedWeiValue = ethers.parseUnits(eth) * BigInt(multiplier);
  return ethers.formatEther(multipliedWeiValue);
};
var divEth = function divEth(eth, divisor) {
  var dividedWeiValue = ethers.parseUnits(eth) / BigInt(divisor);
  return ethers.formatEther(dividedWeiValue);
};

var infuraProvider = new ethers.InfuraProvider("mainnet", "64e05046ef9d4b55866de25292aee3df");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: {
    isGame: function isGame() {
      return this.$route.path === '/break' || this.$route.path === '/drop';
    },
    xPostSuccess: function xPostSuccess() {
      var tweetText = 'I just got my spot on the Million Bit Homepage! Go check it out and get yours @BitHomepage';
      var tweetUrl = this.shareUrl;
      if (this.$route.path == '/dob') {
        tweetText = 'I just got my spot on the DOB Pixel Gallery! Go check it out and get yours @doodle_on_base';
        tweetUrl = 'https://www.dob-nft.io/dob-millionpixelpage/';
      }
      return 'https://x.com/intent/post?text=' + encodeURIComponent(tweetText) + '&url=' + encodeURIComponent(tweetUrl);
    },
    xPostInvite: function xPostInvite() {
      return 'https://x.com/intent/post?text=' + encodeURIComponent('Get your spot on the Million Bit Homepage to be a part of onchain history! @BitHomepage') + '&url=' + encodeURIComponent(this.shareUrl);
    },
    queryRefCode: function queryRefCode() {
      var ref = '';
      if (window.location && window.location.search) {
        var urlParams = new URLSearchParams(window.location.search);
        ref = urlParams.get('ref');
      }
      return localStorage.getItem(LOCAL_STORAGE_KEY_REFERRAL) || ref || '';
    },
    deepLinkMetamask: function deepLinkMetamask() {
      var refCode = this.queryRefCode;
      var host = window.location.host;
      return 'https://metamask.app.link/dapp/' + host + '/' + (refCode ? '?ref=' + refCode : '');
    },
    deepLinkCoinbase: function deepLinkCoinbase() {
      var refCode = this.queryRefCode;
      var host = window.location.host;
      return 'https://go.cb-w.com/dapp?cb_url=' + encodeURIComponent('https://' + host + '/' + (refCode ? '?ref=' + refCode : ''));
    },
    shareUrl: function shareUrl() {
      // URL with refCode if available
      var url = 'https://millionbithomepage.com/';
      if (this.refCode) {
        url += '?ref=' + this.refCode;
      }
      return url;
    },
    ethAmtFormatted: function ethAmtFormatted() {
      return parseFloat(this.ethAmt).toFixed(3);
    }
  },
  data: function data() {
    return {
      demoMode: DEMO_MODE,
      test_msg: '',
      logoMoji: '💠',
      title: 'Million Bit Homepage',
      tagline: 'Own a bit of onchain history!',
      variant: 'primary',
      variantNavButton: 'outline-light',
      isMobileOrTouch: false,
      touchTimer: null,
      alertMsg: '',
      canBuy: false,
      buyLoading: false,
      canSend: false,
      ethPerPixel: ETH_PIXEL_PRICE,
      ethAmt: "0.000",
      tokenAmt: "0.000",
      tokenPerPixel: TOKEN_PIXEL_PRICE,
      ethTokenToggle: true, // TRUE is ETH
      canToggleEthToken: false, // Can toggle between ETH and token?
      canMint: true, // Enable for NFT minting
      formInputUrl: DEMO_ADDRESS ? 'https://x.com/BitHomepage' : '',
      toggleHomepageList: true,
      requireEthBalance: true,
      isSmartWallet: false,
      trxHashSuccess: '',
      watchedDemo: false,
      email: 'mailto:millionbithomepage@gmail.com',
      telegram: 'https://t.me/+_gBV-0hdCmQzYzgx',
      discord: 'https://discord.gg/WGJwK5jkrU',
      twitter: 'https://x.com/BitHomepage',
      tiktok: 'https://www.tiktok.com/@bithomepage',
      youtube: 'https://www.youtube.com/channel/UCQtsrxAC_JT91CtGtCIxmrg',
      warpcast: 'https://warpcast.com/wopr',
      drakula: 'https://drakula.app/user/million?invite=NfmzCk',
      refCode: '',
      whiteLabel: false,
      contractAddress: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_CA,
      nftAddress: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_CA,
      symbol: 'BITPIX',
      swapLink: 'https://millionbithomepage.com/', // TODO
      isConnecting: false,
      provider: null,
      connectAccountAddress: '',
      connectAccountAddressTrunc: '',
      providers: [],
      tokenBalance: '',
      connectAccountChainId: '',
      connectAccountEnsName: '',
      connectAccountEnsNameTrunc: '',
      connectAccountEnsAvatar: '',
      connectAccountEnsWebsite: '',
      showPromo: false
    };
  },
  provide: function provide() {
    var _this = this;

    return {
      updateAppRoute: this.updateAppRoute,
      postToLambda: this.postToLambda,
      saveEvent: this.saveEvent,
      getProviderSigner: this.getProviderSigner,
      doUpload: this.doUpload,
      handleWalletError: this.handleWalletError,
      getGasLimitFromEstimate: this.getGasLimitFromEstimate,
      connectWallet: this.connectWallet,
      appData: function appData() {
        return {
          isMobileOrTouch: _this.isMobileOrTouch,
          canBuy: _this.canBuy,

          twitter: _this.twitter,
          discord: _this.discord,
          telegram: _this.telegram,
          email: _this.email,
          tiktok: _this.tiktok,
          youtube: _this.youtube,
          warpcast: _this.warpcast,
          drakula: _this.drakula,

          connectedAccount: {
            address: _this.connectAccountAddress,
            addressTrunc: _this.connectAccountAddressTrunc,
            name: _this.connectAccountEnsName,
            avatar: _this.connectAccountEnsAvatar,
            website: _this.connectAccountEnsWebsite
          }
        };
      }
    };
  },

  methods: {
    showDemoVideo: function showDemoVideo() {
      __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].trackEvent('showDemoVideo');
      this.saveEvent('showDemoVideo', {});
      localStorage.setItem(LOCAL_STORAGE_KEY_DEMO_VID, 'true');
      this.watchedDemo = true;
      this.$router.push('demo');
    },

    updateAppRoute: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(newValue, oldValue) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                log('updateAppRoute', newValue, oldValue);
                this.toggleHomepageList = false;
                if (newValue === '/') {
                  this.resetBuy();
                }

                // TODO cleanup with map

                if (!(newValue === '/tang')) {
                  _context.next = 20;
                  break;
                }

                this.contractAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TANG_CA;
                this.nftAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_TANG_CA;
                this.symbol = 'TANG'; // TODO fetch from contract
                this.tokenPerPixel = 1; // TODO fetch from contract
                _context.next = 10;
                return this.updatePixelPrice();

              case 10:
                _context.next = 12;
                return this.updateTokenPixelPrice();

              case 12:
                _context.next = 14;
                return this.checkCanPayWithToken();

              case 14:
                this.ethTokenToggle = false;
                this.canToggleEthToken = false;
                this.showPromo = false;

                this.resetBuy();
                _context.next = 66;
                break;

              case 20:
                if (!(newValue === '/dob')) {
                  _context.next = 38;
                  break;
                }

                this.whiteLabel = true;
                this.contractAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].SUBPAGES.DOB.TOKEN_CA;
                this.nftAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].SUBPAGES.DOB.NFT_CA;
                this.symbol = 'DOB'; // TODO fetch from contract
                this.tokenPerPixel = 1; // TODO fetch from contract
                _context.next = 28;
                return this.updatePixelPrice();

              case 28:
                _context.next = 30;
                return this.updateTokenPixelPrice();

              case 30:
                _context.next = 32;
                return this.checkCanPayWithToken();

              case 32:
                this.ethTokenToggle = false;
                this.canToggleEthToken = false;
                this.showPromo = false;

                this.resetBuy();
                _context.next = 66;
                break;

              case 38:
                if (!(newValue === '/preme')) {
                  _context.next = 56;
                  break;
                }

                this.whiteLabel = false;
                this.contractAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].SUBPAGES.PREME.TOKEN_CA;
                this.nftAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].SUBPAGES.PREME.NFT_CA;
                this.symbol = 'PBP'; // TODO fetch from contract
                this.tokenPerPixel = 1; // TODO fetch from contract
                _context.next = 46;
                return this.updatePixelPrice();

              case 46:
                _context.next = 48;
                return this.updateTokenPixelPrice();

              case 48:
                _context.next = 50;
                return this.checkCanPayWithToken();

              case 50:
                this.ethTokenToggle = true;
                this.canToggleEthToken = false;
                this.showPromo = false;

                this.resetBuy();
                _context.next = 66;
                break;

              case 56:
                this.whiteLabel = false;
                this.contractAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_CA;
                this.nftAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_CA;
                this.symbol = 'BITPIX';
                this.tokenPerPixel = 1;
                _context.next = 63;
                return this.updatePixelPrice();

              case 63:
                _context.next = 65;
                return this.checkCanPayWithToken();

              case 65:
                this.ethTokenToggle = true;
                // this.canToggleEthToken = true;

              case 66:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateAppRoute(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return updateAppRoute;
    }(),
    setPixelsToBuy: function setPixelsToBuy(pixels) {
      this.ethAmt = multiplyEth(this.ethPerPixel.toString(), pixels).toString();
      this.tokenAmt = multiplyEth(this.tokenPerPixel.toString(), pixels).toString();
    },
    validateImageLocation: function validateImageLocation(img_offset_x, img_offset_y, img_width, img_height) {
      log('validateImageLocation', img_offset_x, img_offset_y, img_width, img_height);

      // Verify that the img_offset_x and img_offset_y are on the 16 x 16 grid
      if (img_offset_x % 16 !== 0 || img_offset_y % 16 !== 0) {
        // Calculate the difference between the current position and the nearest 16 x 16 grid
        var dx = img_offset_x - Math.floor(img_offset_x / 16) * 16;
        var dy = img_offset_y - Math.floor(img_offset_y / 16) * 16;

        // Snap the image to the nearest 16 x 16 grid
        var image = document.getElementById('uploadedImg');
        var x = (img_offset_x || 0) - dx;
        var y = (img_offset_y || 0) - dy;

        // Apply the transformation
        image.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

        // Update the position attributes
        image.setAttribute('data-x', x);
        image.setAttribute('data-y', y);
        img_offset_x = Math.floor(img_offset_x / 16) * 16;
        img_offset_y = Math.floor(img_offset_y / 16) * 16;
      }

      var p = getPriceForPosition(img_offset_x, img_offset_y, img_width, img_height, true);
      if (p) {
        this.setPixelsToBuy(p);
        document.getElementById('million-bit-billboard').classList.remove('tooltip-place');
        this.canSend = true;
        return true;
      } else {
        // Cannot buy this location
        document.getElementById('million-bit-billboard').classList.add('tooltip-place');
        this.canSend = false;
        return false;
      }
    },
    navigateTo: function navigateTo(route) {
      this.$bvModal.hide('modal-intro');
      if (route === '/') {
        this.toggleHomepageList = true;
      } else {
        this.toggleHomepageList = false;
      }
      this.$router.push(route);
    },
    doToggleEthToken: function doToggleEthToken(isEth) {
      if (!isEth) {
        this.ethTokenToggle = false;
      } else {
        this.ethTokenToggle = true;
      }
    },
    doUpload: function doUpload(x, y) {
      if (this.canBuy) {
        this.cancelBuy();
        return;
      }
      this.uploadToXY = { x: x, y: y };
      trackEvent('doUpload:file');
      document.querySelector('input[name="qqfile"]').click();
    },
    doUploadAvatar: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(event) {
        var img;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                trackEvent('doUpload:avatar');
                _context2.next = 3;
                return fetchImage(this.connectAccountEnsAvatar);

              case 3:
                img = _context2.sent;

                window.manualUploader.addFiles(img);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function doUploadAvatar(_x3) {
        return _ref2.apply(this, arguments);
      }

      return doUploadAvatar;
    }(),
    connectWallet: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                trackEvent('connectWallet');
                log('connectWallet');
                this.$bvModal.show('modal-connect');
                this.loadProviders();

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function connectWallet() {
        return _ref3.apply(this, arguments);
      }

      return connectWallet;
    }(),
    createWallet: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var coinbaseWalletSDK, coinbaseWalletProvider, _ref5, _ref6, address;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                trackEvent('createWallet');
                log('create Wallet');
                this.isConnecting = true;

                _context4.prev = 3;
                coinbaseWalletSDK = new CoinbaseWalletSDK({
                  appName: 'Million Bit Homepage',
                  appLogoUrl: 'https://millionbithomepage.com/static/mbh.png',
                  appChainIds: [8453]
                });
                _context4.next = 7;
                return coinbaseWalletSDK.makeWeb3Provider();

              case 7:
                coinbaseWalletProvider = _context4.sent;

                this.provider = coinbaseWalletProvider;
                log('coinbaseWalletProvider', coinbaseWalletProvider);
                _context4.next = 12;
                return coinbaseWalletProvider.request({
                  method: 'eth_requestAccounts'
                });

              case 12:
                _ref5 = _context4.sent;
                _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref5, 1);
                address = _ref6[0];

                log('created Wallet', address, coinbaseWalletProvider);
                _context4.next = 18;
                return this.setConnectedAccount(address);

              case 18:
                // await this.ensureBaseChain(this.provider);

                // const capabilities = await coinbaseWalletProvider.request({
                //   method: 'wallet_getCapabilities',
                //   // params:[address],
                // });
                // log('capabilities', capabilities);

                this.requireEthBalance = false; // Magic spend // https://www.smartwallet.dev/guides/magic-spend
                this.isSmartWallet = true;
                trackEvent('createdWallet');
                this.isConnecting = false;
                _context4.next = 28;
                break;

              case 24:
                _context4.prev = 24;
                _context4.t0 = _context4['catch'](3);

                this.isConnecting = false;
                this.handleError(_context4.t0);

              case 28:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 24]]);
      }));

      function createWallet() {
        return _ref4.apply(this, arguments);
      }

      return createWallet;
    }(),
    handleError: function handleError(error) {
      console.error(error);
      this.showAlert('An error occurred. Please try again.');
    },
    getBaseName: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5(address, baseProvider) {
        var addressReverseNode, contract, basename;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                addressReverseNode = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].convertReverseNodeToBytes(address, 8453); // 8453 is base chain id

                contract = new ethers.Contract(BASENAME_L2_RESOLVER_ADDRESS, __WEBPACK_IMPORTED_MODULE_13__constants__["a" /* default */].L2ResolverAbi, baseProvider);
                _context5.next = 5;
                return contract.name(addressReverseNode);

              case 5:
                basename = _context5.sent;
                return _context5.abrupt('return', basename);

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);

                console.error('Error getting basename', _context5.t0);

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 9]]);
      }));

      function getBaseName(_x4, _x5) {
        return _ref7.apply(this, arguments);
      }

      return getBaseName;
    }(),
    getEnsName: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6(address) {
        var ensName;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return infuraProvider.lookupAddress(address);

              case 2:
                ensName = _context6.sent;
                return _context6.abrupt('return', ensName);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getEnsName(_x6) {
        return _ref8.apply(this, arguments);
      }

      return getEnsName;
    }(),
    getEnsAvatar: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7(ensName) {
        var avatar;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return infuraProvider.getAvatar(ensName);

              case 2:
                avatar = _context7.sent;

                log('Avatar for ' + ensName + ' URL: ' + avatar);
                return _context7.abrupt('return', avatar);

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getEnsAvatar(_x7) {
        return _ref9.apply(this, arguments);
      }

      return getEnsAvatar;
    }(),
    getEnsWebsite: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8(ensName) {
        var resolver, website;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return infuraProvider.getResolver(ensName);

              case 2:
                resolver = _context8.sent;

                if (!resolver) {
                  _context8.next = 8;
                  break;
                }

                _context8.next = 6;
                return resolver.getText("url");

              case 6:
                website = _context8.sent;
                return _context8.abrupt('return', website);

              case 8:
                return _context8.abrupt('return', null);

              case 9:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getEnsWebsite(_x8) {
        return _ref10.apply(this, arguments);
      }

      return getEnsWebsite;
    }(),
    // resolveEnsAvatar: async function(ensName, provider) {
    //   const resolver = await ethers.EnsResolver.fromName(provider, ensName);
    //   console.log('resolver', resolver)
    //   if (resolver) {
    //       // Resolve the avatar
    //       const avatarUrl = await resolver.getAvatar();
    //       if (avatarUrl) {
    //           console.log(`Avatar URL: ${avatarUrl}`);
    //       } else {
    //           console.log("No avatar found for this ENS name.");
    //       }
    //   } else {
    //       console.log("ENS name not found.");
    //   }
    // },
    setConnectedAccount: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9(account) {
        var _ref12, provider, signer, baseName, ensAvatar, ensWebsite, ensName, _ensAvatar, resolver, website;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                log('setConnectedAccount', account);

                if (!account) {
                  _context9.next = 56;
                  break;
                }

                // Hide modal
                this.$bvModal.hide('modal-connect');
                this.connectAccountAddress = account;
                this.connectAccountAddressTrunc = account.substring(0, 6) + '…' + account.substring(account.length - 4);

                if (this.$refs.routerViewRef) {
                  this.$refs.routerViewRef.$emit('accountConnected', { message: 'Hello from parent' });
                }

                _context9.next = 8;
                return this.ensureBaseChain(this.provider);

              case 8:
                _context9.next = 10;
                return this.updatePixelPrice();

              case 10:
                _context9.next = 12;
                return this.checkCanPayWithToken();

              case 12:
                _context9.next = 14;
                return this.getProviderSigner();

              case 14:
                _ref12 = _context9.sent;
                provider = _ref12.provider;
                signer = _ref12.signer;
                _context9.next = 19;
                return this.getBaseName(account, signer);

              case 19:
                baseName = _context9.sent;

                if (!baseName) {
                  _context9.next = 32;
                  break;
                }

                this.setEnsName(baseName, 'baseName');
                _context9.next = 24;
                return this.getEnsAvatar(this.connectAccountEnsName);

              case 24:
                ensAvatar = _context9.sent;

                this.connectAccountEnsAvatar = ensAvatar || '';
                _context9.next = 28;
                return this.getEnsWebsite(this.connectAccountEnsName);

              case 28:
                ensWebsite = _context9.sent;

                if (ensWebsite) {
                  this.connectAccountEnsWebsite = ensWebsite;
                  this.formInputUrl = ensWebsite;
                } else {
                  log('No website found for address ' + this.connectAccountEnsName);
                  this.connectAccountEnsWebsite = '';
                }
                _context9.next = 53;
                break;

              case 32:
                log('No base name found for address ' + this.connectAccountAddress);
                _context9.next = 35;
                return this.getEnsName(this.connectAccountAddress);

              case 35:
                ensName = _context9.sent;

                if (!ensName) {
                  _context9.next = 53;
                  break;
                }

                this.setEnsName(ensName, 'ensName');
                _context9.next = 40;
                return infuraProvider.getAvatar(this.connectAccountEnsName);

              case 40:
                _ensAvatar = _context9.sent;

                this.connectAccountEnsAvatar = _ensAvatar;
                _context9.next = 44;
                return infuraProvider.getResolver(ensName);

              case 44:
                resolver = _context9.sent;

                if (!resolver) {
                  _context9.next = 52;
                  break;
                }

                _context9.next = 48;
                return resolver.getText("url");

              case 48:
                website = _context9.sent;

                if (website) {
                  log('The website for this.connectAccountEnsName ' + this.connectAccountEnsName + ' is ' + website);
                  this.connectAccountEnsWebsite = website;
                  this.formInputUrl = website;
                } else {
                  log('No website found for address ' + this.connectAccountEnsName);
                  this.connectAccountEnsWebsite = '';
                }
                _context9.next = 53;
                break;

              case 52:
                this.connectAccountEnsWebsite = '';

              case 53:
                this.saveEvent('connectedAccount', {});
                _context9.next = 62;
                break;

              case 56:
                this.connectAccountAddress = '';
                this.connectAccountAddressTrunc = '';
                this.connectAccountEnsName = '';
                this.connectAccountEnsNameTrunc = '';
                this.connectAccountEnsAvatar = '';
                this.connectAccountEnsWebsite = '';

              case 62:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function setConnectedAccount(_x9) {
        return _ref11.apply(this, arguments);
      }

      return setConnectedAccount;
    }(),
    setEnsName: function setEnsName(ensName, source) {
      this.connectAccountEnsName = ensName;
      if (this.connectAccountEnsName) {
        this.connectAccountEnsNameTrunc = this.connectAccountEnsName.length > 20 ? this.connectAccountEnsName.substring(0, 20) + '…' : this.connectAccountEnsName;
      } else {
        this.connectAccountEnsNameTrunc = '';
      }
      __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].trackEvent(source + ':' + ensName);
      log(source, ensName);
    },
    doConnect: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10(provider) {
        var accounts;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                // console.log(provider);
                log('do connect', provider);
                this.isConnecting = true;
                this.isSmartWallet = false;
                this.provider = provider.provider;
                _context10.prev = 4;
                _context10.next = 7;
                return this.provider.request({ method: "eth_requestAccounts" });

              case 7:
                accounts = _context10.sent;

                this.setConnectedAccount(accounts[0]);
                // this.ensureBaseChain(this.provider);
                this.isConnecting = false;
                _context10.next = 16;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10['catch'](4);

                console.error("Failed to connect to provider:", _context10.t0);
                this.isConnecting = false;

              case 16:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[4, 12]]);
      }));

      function doConnect(_x10) {
        return _ref13.apply(this, arguments);
      }

      return doConnect;
    }(),
    doDisconnect: function () {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return this.provider.request({ method: "wallet_revokePermissions", "params": [{
                    "eth_accounts": {}
                  }] });

              case 3:
                _context11.next = 8;
                break;

              case 5:
                _context11.prev = 5;
                _context11.t0 = _context11['catch'](0);

                try {
                  this.provider.close();
                } catch (e) {
                  console.log('Couldnt close wallet');
                }

              case 8:
                // this.provider = null;
                // this.getWalletPermissions(this.provider);
                log('Disconnect provider', this.provider);
                if (this.provider.disconnect) {
                  this.provider.disconnect();
                }
                this.setConnectedAccount(null);

              case 11:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 5]]);
      }));

      function doDisconnect() {
        return _ref14.apply(this, arguments);
      }

      return doDisconnect;
    }(),
    doCopyToClipboard: function doCopyToClipboard(text) {
      var _this2 = this;

      navigator.clipboard.writeText(text).then(function () {
        _this2.showAlert('Copied to clipboard!');
      }).catch(function (err) {
        console.error('Failed to copy text: ', err);
      });
      // var dummy = document.createElement("textarea");
      // document.body.appendChild(dummy);
      // dummy.value = text;
      // dummy.select();
      // document.execCommand("copy");
      // document.body.removeChild(dummy);
    },
    getWalletPermissions: function () {
      var _ref15 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12(provider, accounts) {
        var permissions, eth_accounts;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(accounts && accounts.length > 0)) {
                  _context12.next = 4;
                  break;
                }

                this.provider = provider;
                this.setConnectedAccount(accounts[0]);
                // this.ensureBaseChain(provider);
                return _context12.abrupt('return');

              case 4:
                if (!(provider.isCoinbaseBrowser || provider.isCoinbaseWallet)) {
                  _context12.next = 6;
                  break;
                }

                return _context12.abrupt('return');

              case 6:
                _context12.next = 8;
                return provider.request({ method: "wallet_getPermissions" });

              case 8:
                permissions = _context12.sent;

                log('getWalletPermissions', permissions);
                accounts = permissions.find(function (p) {
                  return p.parentCapability === "eth_accounts";
                });
                log('accounts', accounts);
                if (!accounts || !accounts.caveats) {
                  // log('Disconnect provider', provider);
                  // if (provider.disconnect) {
                  //   provider.disconnect();
                  // }
                  // this.setConnectedAccount(null);
                } else {
                  eth_accounts = accounts.caveats.find(function (c) {
                    return c.type === "restrictReturnedAccounts";
                  });

                  if (eth_accounts) {
                    log('eth accounts', eth_accounts);
                    this.provider = provider;
                    this.setConnectedAccount(eth_accounts.value[0]);
                  } else {
                    this.setConnectedAccount(null);
                  }
                }

              case 13:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getWalletPermissions(_x11, _x12) {
        return _ref15.apply(this, arguments);
      }

      return getWalletPermissions;
    }(),
    parseChainId: function parseChainId(chainId) {
      if (typeof chainId === 'string') {
        if (chainId.startsWith('0x')) {
          return parseInt(chainId, 16).toString();
        } else {
          return chainId;
        }
      } else if (typeof chainId === 'number') {
        return chainId.toString();
      }
    },
    isBaseChain: function isBaseChain(chainId) {
      log('isBaseChain', chainId, typeof chainId === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(chainId), BASE_CHAIN_ID, typeof BASE_CHAIN_ID === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(BASE_CHAIN_ID), this.parseChainId(chainId), this.parseChainId(BASE_CHAIN_ID));
      return this.parseChainId(chainId) === this.parseChainId(BASE_CHAIN_ID);
    },
    switchToBaseChain: function switchToBaseChain(event) {
      this.ensureBaseChain(this.provider);
    },
    ensureBaseChain: function () {
      var _ref16 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13(provider) {
        var chainId;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.getEthChainId(provider);

              case 2:
                chainId = _context13.sent;

                this.connectAccountChainId = chainId;

                if (this.isBaseChain(chainId)) {
                  _context13.next = 8;
                  break;
                }

                log('Switching from chain ' + chainId + ' to base ' + BASE_CHAIN_ID);
                _context13.next = 8;
                return provider.request({
                  "method": "wallet_switchEthereumChain",
                  "params": [{ "chainId": BASE_CHAIN_ID.toString() }]
                });

              case 8:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function ensureBaseChain(_x13) {
        return _ref16.apply(this, arguments);
      }

      return ensureBaseChain;
    }(),
    pollForCompletion: function () {
      var _ref17 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee15(txHash, callback) {
        var _this3 = this,
            _arguments = arguments;

        var calledBack, tries, checkInterval;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                calledBack = false;
                tries = 0;
                checkInterval = setInterval(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee14() {
                  var notYet, _response, transaction;

                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          tries++;

                          if (!(tries > 30)) {
                            _context14.next = 5;
                            break;
                          }

                          // Coinbase wallet etc. might not support the method below?
                          calledBack = true;
                          callback(true);
                          return _context14.abrupt('return');

                        case 5:
                          notYet = 'response has no error or result';

                          // ethereum.sendAsync({

                          _context14.prev = 6;
                          _context14.next = 9;
                          return _this3.provider.request({
                            method: 'eth_getTransactionByHash',
                            params: [txHash]
                          });

                        case 9:
                          _response = _context14.sent;

                          if (!calledBack) {
                            _context14.next = 12;
                            break;
                          }

                          return _context14.abrupt('return');

                        case 12:
                          console.log('eth_getTransactionByHash', _arguments);

                          // We have successfully verified the mined transaction.
                          // Mind you, we should do this server side, with our own blockchain connection.
                          // Client side we are trusting the user's connection to the blockchain.
                          transaction = _response.result;

                          clearInterval(checkInterval);
                          calledBack = true;
                          _this3.trxHashSuccess = txHash;
                          callback(null, transaction);
                          _context14.next = 27;
                          break;

                        case 20:
                          _context14.prev = 20;
                          _context14.t0 = _context14['catch'](6);

                          console.log('eth_getTransactionByHash error', _arguments);

                          if (!(err || response.error)) {
                            _context14.next = 27;
                            break;
                          }

                          if (!err.message.includes(notYet)) {
                            _context14.next = 26;
                            break;
                          }

                          return _context14.abrupt('return', 'transaction is not yet mined');

                        case 26:
                          return _context14.abrupt('return');

                        case 27:
                        case 'end':
                          return _context14.stop();
                      }
                    }
                  }, _callee14, _this3, [[6, 20]]);
                })), 2000);

              case 3:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function pollForCompletion(_x14, _x15) {
        return _ref17.apply(this, arguments);
      }

      return pollForCompletion;
    }(),
    getEthChainId: function () {
      var _ref19 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee16(provider) {
        var chainId;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return provider.request({ method: "eth_chainId", "params": [] });

              case 2:
                chainId = _context16.sent;
                return _context16.abrupt('return', chainId);

              case 4:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function getEthChainId(_x16) {
        return _ref19.apply(this, arguments);
      }

      return getEthChainId;
    }(),
    watchToken: function () {
      var _ref20 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee17() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.provider.request({
                  "method": "wallet_watchAsset",
                  "params": {
                    "type": "ERC20",
                    "options": {
                      "address": __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_CA,
                      "symbol": this.symbol,
                      "decimals": 18,
                      "image": TOKEN_IMAGE_URL
                    }
                  }
                });

              case 2:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function watchToken() {
        return _ref20.apply(this, arguments);
      }

      return watchToken;
    }(),
    getTokenBalance: function () {
      var _ref21 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee18(p) {
        var provider, signer, contract, balance;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                provider = new ethers.BrowserProvider(p);
                _context18.next = 3;
                return provider.getSigner();

              case 3:
                signer = _context18.sent;
                contract = new ethers.Contract(this.contractAddress, ["function balanceOf(address) view returns (uint256)"], signer);
                _context18.next = 7;
                return contract.balanceOf(this.connectAccountAddress);

              case 7:
                balance = _context18.sent;

                log('token balance', balance.toString());
                this.tokenBalance = balance.toString();
                return _context18.abrupt('return', balance);

              case 11:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getTokenBalance(_x17) {
        return _ref21.apply(this, arguments);
      }

      return getTokenBalance;
    }(),
    cancelBuy: function cancelBuy(event) {
      this.resetBuy();
    },
    resetBuy: function resetBuy() {
      this.buyLoading = false;
      this.canBuy = false;
      initUploader(this);
    },
    getPixelPrice: function () {
      var _ref22 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee19(x1, y1, x2, y2) {
        var _ref23, provider, contract, price;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                log('Getting pixel price');
                _context19.next = 3;
                return this.getProviderSigner();

              case 3:
                _ref23 = _context19.sent;
                provider = _ref23.provider;
                contract = new ethers.Contract(this.nftAddress, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_ABI, provider);
                _context19.next = 8;
                return contract.calculateCurrentPrice(x1, y1, x2, y2);

              case 8:
                price = _context19.sent;

                log('Pixel price', price, typeof price === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(price));
                return _context19.abrupt('return', price);

              case 11:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getPixelPrice(_x18, _x19, _x20, _x21) {
        return _ref22.apply(this, arguments);
      }

      return getPixelPrice;
    }(),
    getTokenPrice: function () {
      var _ref24 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee20() {
        var _ref25, provider, contract, price;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                log('Getting pixel price');
                _context20.next = 3;
                return this.getProviderSigner();

              case 3:
                _ref25 = _context20.sent;
                provider = _ref25.provider;
                contract = new ethers.Contract(this.nftAddress, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_ABI, provider);
                _context20.next = 8;
                return contract.tokenPrice();

              case 8:
                price = _context20.sent;

                console.log(price);
                log('Token Pixel price', price, typeof price === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(price));
                return _context20.abrupt('return', price);

              case 12:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getTokenPrice() {
        return _ref24.apply(this, arguments);
      }

      return getTokenPrice;
    }(),
    updatePixelPrice: function () {
      var _ref26 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee21() {
        var blockPrice;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (!this.canMint) {
                  _context21.next = 8;
                  break;
                }

                if (this.connectAccountAddress) {
                  _context21.next = 4;
                  break;
                }

                log('Cant get pixel price until wallet is connected');
                return _context21.abrupt('return', 0);

              case 4:
                _context21.next = 6;
                return this.getPixelPrice(0, 0, 16, 16);

              case 6:
                blockPrice = _context21.sent;

                this.ethPerPixel = ethers.formatEther(blockPrice / BigInt(16 * 16));

              case 8:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function updatePixelPrice() {
        return _ref26.apply(this, arguments);
      }

      return updatePixelPrice;
    }(),
    updateTokenPixelPrice: function () {
      var _ref27 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee22() {
        var blockPrice;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (!this.canMint) {
                  _context22.next = 9;
                  break;
                }

                if (this.connectAccountAddress) {
                  _context22.next = 5;
                  break;
                }

                log('Cant get token pixel price until wallet is connected');
                this.$refs.routerViewRef.$on('accountConnected', this.updateTokenPixelPrice);
                return _context22.abrupt('return', 0);

              case 5:
                _context22.next = 7;
                return this.getTokenPrice();

              case 7:
                blockPrice = _context22.sent;

                // this.ethPerPixel = ethers.formatEther(blockPrice / BigInt(16*16));
                this.tokenPerPixel = blockPrice;

              case 9:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function updateTokenPixelPrice() {
        return _ref27.apply(this, arguments);
      }

      return updateTokenPixelPrice;
    }(),
    doBuy: function () {
      var _ref28 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee24(event) {
        var _this4 = this;

        var isLocationValid, account, amountToSend;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                trackEvent('doBuy');
                trackEvent('begin_checkout');
                this.saveEvent('doBuy', {});

                if (this.connectAccountAddress) {
                  _context24.next = 6;
                  break;
                }

                this.showAlert('Please connect your wallet first.');
                return _context24.abrupt('return');

              case 6:
                if (this.isBaseChain(this.connectAccountChainId)) {
                  _context24.next = 9;
                  break;
                }

                this.showAlert('Please switch to base network first.');
                return _context24.abrupt('return');

              case 9:

                this.buyLoading = true;

                // Check the image location is still available since the page loaded

                if (true) {
                  _context24.next = 19;
                  break;
                }

                if (!this.$refs.routerViewRef) {
                  _context24.next = 14;
                  break;
                }

                _context24.next = 14;
                return this.$refs.routerViewRef.fetchData(true);

              case 14:

                // Check for latest image and link data before sending to prevent overlap
                isLocationValid = this.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);

                if (isLocationValid) {
                  _context24.next = 19;
                  break;
                }

                this.buyLoading = false;
                this.showAlert('Please review your image placement.');
                return _context24.abrupt('return');

              case 19:
                _context24.prev = 19;
                _context24.next = 22;
                return this.updatePixelPrice();

              case 22:
                _context24.next = 27;
                break;

              case 24:
                _context24.prev = 24;
                _context24.t0 = _context24['catch'](19);

                console.log('Error updating pixel price', _context24.t0);

              case 27:

                // Load pixel data
                window.pixels_data = getPixelsData(window.myImageData, window.img_width, window.img_height);
                log(window.pixels_data);
                log('pixel data done....');

                account = this.connectAccountAddress;
                amountToSend = this.ethTokenToggle ? this.ethAmt : this.tokenAmt;

                this.sendEtherFrom(account, amountToSend, this.ethTokenToggle, function () {
                  var _ref29 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee23(err, transaction) {
                    var refCode;
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
                      while (1) {
                        switch (_context23.prev = _context23.next) {
                          case 0:
                            // TODO render link to transaction on basescan
                            // if (err) {
                            //   console.log(err);
                            //   trackEvent('trxFailed');
                            //   return alert(`The transaction failed.`)
                            // }
                            _this4.buyLoading = false;
                            trackEvent('purchase');
                            trackEvent('trxSuccess');

                            // Show modal
                            _context23.next = 5;
                            return _this4.getRefCode();

                          case 5:
                            _this4.$bvModal.show('modal-success');
                            // this.showAlert('Your transaction is being processed.');

                            try {
                              fetch(WEBHOOK_URL + '?trigger=true', {
                                method: 'GET'
                              }).then(function (response) {
                                if (!response.ok) {
                                  // throw new Error('Network response was not ok ' + response.statusText);
                                  console.error('Network response was not ok ' + response.statusText);
                                }
                                return response.json(); // Assuming the response is JSON
                              }).then(function (data) {
                                console.log('Data received:', data);
                              }).catch(function (error) {
                                console.error('Fetch error:', error);
                              });
                              __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].confetti(10000); // PARTY!

                              // Send referral data
                              log(transaction);
                              refCode = localStorage.getItem(LOCAL_STORAGE_KEY_REFERRAL);

                              _this4.saveEvent('purchase', {
                                code: refCode,
                                transaction: transaction
                              });
                              // if (false && refCode) {
                              //   this.postToLambda('trxSuccess', {
                              //     code: refCode,
                              //     from: account,
                              //     transaction
                              //   });
                              // }
                            } catch (e) {
                              console.error('Fetch error:', e);
                            }

                          case 7:
                          case 'end':
                            return _context23.stop();
                        }
                      }
                    }, _callee23, _this4);
                  }));

                  return function (_x23, _x24) {
                    return _ref29.apply(this, arguments);
                  };
                }());

              case 33:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, this, [[19, 24]]);
      }));

      function doBuy(_x22) {
        return _ref28.apply(this, arguments);
      }

      return doBuy;
    }(),
    getEventUserEnv: function getEventUserEnv() {
      var userEnv = {
        ensName: this.connectAccountEnsName,
        address: this.connectAccountAddress,
        chainId: this.connectAccountChainId,
        agent: navigator.userAgent,
        isMobileOrTouch: this.isMobileOrTouch,
        provider: {
          isCoinbaseWallet: this.provider ? this.provider.isCoinbaseWallet : null,
          isCoinbaseBrowser: this.provider ? this.provider.isCoinbaseBrowser : null,
          isMetaMask: this.provider ? this.provider.isMetaMask : null,
          isRabby: this.provider ? this.provider.isRabby : null,
          isSmartWallet: this.isSmartWallet
        }
      };
      return userEnv;
    },
    saveEvent: function saveEvent(eventType, eventData) {
      var userEnv = this.getEventUserEnv();
      this.postToLambda('saveEvent', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, userEnv, {
        eventType: eventType,
        eventData: eventData
      }));
    },
    getRefCode: function () {
      var _ref30 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee25() {
        var userEnv, _response2;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!(!this.refCode && this.connectAccountAddress)) {
                  _context25.next = 6;
                  break;
                }

                userEnv = this.getEventUserEnv();
                _context25.next = 4;
                return this.postToLambda('getRefCode', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, userEnv));

              case 4:
                _response2 = _context25.sent;

                if (_response2 && _response2.code) {
                  this.refCode = _response2.code;
                }

              case 6:
                return _context25.abrupt('return', this.refCode);

              case 7:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function getRefCode() {
        return _ref30.apply(this, arguments);
      }

      return getRefCode;
    }(),
    handleWalletError: function handleWalletError(errMsg) {
      var userEnv = this.getEventUserEnv();
      this.postToLambda('walletError', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, userEnv, {
        error: errMsg
      }));
      if (errMsg && errMsg.message) {
        errMsg = errMsg.message;
      }
      if (!errMsg) {
        this.showAlert('An error occurred.');
      } else if (errMsg.includes('Insufficient payment')) {
        this.showAlert('Insufficient funds for plot. Please reload the page and try again.');
        trackEvent('walletError:plotClaimed');
      } else if (errMsg.includes('Coordinates overlap')) {
        this.showAlert('This plot has already been claimed.');
        trackEvent('walletError:plotClaimed');
      } else if (errMsg.includes('insufficient funds')) {
        this.showAlert('Insufficient funds for transaction.');
        trackEvent('walletError:insufficientFunds');
      } else if (errMsg.includes('user rejected action')) {
        this.showAlert('User rejected transaction.');
        trackEvent('walletError:reject');
      } else if (errMsg.includes('ERC20: insufficient allowance')) {
        this.showAlert('Please approve the token transfer first.');
        trackEvent('walletError:approve');
      } else if (errMsg.includes('execution reverted') || errMsg.includes('missing revert data')) {
        this.showAlert('Transaction would be reverted.');
        trackEvent('walletError:revert');
      } else {
        this.showAlert(errMsg);
        trackEvent('walletError:unknown');
      }
    },
    getProviderSigner: function () {
      var _ref31 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee26() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                if (this.browserProvider) {
                  _context26.next = 7;
                  break;
                }

                _context26.next = 3;
                return new ethers.BrowserProvider(this.provider);

              case 3:
                this.browserProvider = _context26.sent;
                _context26.next = 6;
                return this.browserProvider.getSigner();

              case 6:
                this.browserProviderSigner = _context26.sent;

              case 7:
                log('getProviderSigner', this.browserProvider, this.browserProviderSigner);
                return _context26.abrupt('return', {
                  provider: this.browserProvider,
                  signer: this.browserProviderSigner
                });

              case 9:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function getProviderSigner() {
        return _ref31.apply(this, arguments);
      }

      return getProviderSigner;
    }(),
    sendEtherFrom: function () {
      var _ref32 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee27(account, donation_amount, isEth, callback) {
        var link_url_el, link_url, pixels_data_strs, r, c, pixels_data_str, pixels_data_gzip_str, trxAmount, _ref33, provider, signer, balance, transactionRequest, estimatedGas, gasLimit, transactionRequestWithGasLimit, tx, receipt, hash;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                trackEvent('trxSending');
                link_url_el = document.getElementById('link-url');
                link_url = link_url_el.value;


                log('donation amount', donation_amount, typeof donation_amount === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(donation_amount));
                log('link url', link_url);

                if (!(link_url.indexOf('http') !== 0)) {
                  _context27.next = 10;
                  break;
                }

                this.showAlert('Please provide a URL your image should link to for when someone clicks on it.');
                link_url_el.focus();
                this.buyLoading = false;
                return _context27.abrupt('return', false);

              case 10:
                pixels_data_strs = [];

                for (r in window.segmentPrices) {
                  for (c in window.segmentPrices[r]) {
                    pixels_data_strs.push(stringDataForEth(window.pixels_data[r][c], link_url, window.segmentPrices[r][c], r, c));
                  }
                }

                log('pixels_data_strs', pixels_data_strs);
                pixels_data_str = pixels_data_strs.join('\n');
                pixels_data_gzip_str = pako.deflate(pixels_data_str, { to: 'string' });

                // log('pixels_data_str: '+pixels_data_str);

                log('pixels_data_str length: ' + pixels_data_str.length);
                log('pixels_data_gzip_str length: ' + pixels_data_gzip_str.length);
                log('compression ratio: ' + pixels_data_str.length / pixels_data_gzip_str.length);

                if (!this.demoMode) {
                  _context27.next = 21;
                  break;
                }

                callback();
                return _context27.abrupt('return');

              case 21:
                if (isEth) {
                  _context27.next = 24;
                  break;
                }

                if (this.canMint) {
                  this.sendPixelsToTokenNFT(pixels_data_gzip_str, donation_amount, account, callback);
                } else {
                  this.sendPixelsToToken(pixels_data_gzip_str, donation_amount, account, callback);
                }
                return _context27.abrupt('return');

              case 24:
                if (!this.canMint) {
                  _context27.next = 27;
                  break;
                }

                // NFT
                this.sendPixelsToNFT(pixels_data_gzip_str, donation_amount, account, callback);
                return _context27.abrupt('return');

              case 27:
                _context27.prev = 27;
                trxAmount = ethers.parseEther(donation_amount);

                log('trxAmount', trxAmount, typeof trxAmount === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(trxAmount));

                _context27.next = 32;
                return this.getProviderSigner();

              case 32:
                _ref33 = _context27.sent;
                provider = _ref33.provider;
                signer = _ref33.signer;

                if (!this.requireEthBalance) {
                  _context27.next = 45;
                  break;
                }

                _context27.next = 38;
                return provider.getBalance(account);

              case 38:
                balance = _context27.sent;

                log('balance', balance.toString(), trxAmount.toString());

                if (!(balance < trxAmount)) {
                  _context27.next = 45;
                  break;
                }

                this.buyLoading = false;
                this.showAlert('Insufficient funds for transaction.');
                this.saveEvent('insufficientFunds', {
                  trxAmount: trxAmount.toString(),
                  balance: balance.toString()
                });
                return _context27.abrupt('return');

              case 45:

                // console.log("SEND", account, provider, signer);
                transactionRequest = {
                  to: BID_TO_ADDRESS,
                  value: trxAmount,
                  data: getEncodedEthDataValue(pixels_data_gzip_str)
                };
                _context27.next = 48;
                return signer.estimateGas(transactionRequest);

              case 48:
                estimatedGas = _context27.sent;
                gasLimit = this.getGasLimitFromEstimate(estimatedGas);
                transactionRequestWithGasLimit = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, transactionRequest, {
                  gasLimit: gasLimit
                });


                this.saveEvent('trxReq', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, transactionRequestWithGasLimit, {
                  gasLimit: transactionRequestWithGasLimit.gasLimit.toString(),
                  value: transactionRequestWithGasLimit.value.toString()
                }));

                _context27.next = 54;
                return signer.sendTransaction(transactionRequestWithGasLimit);

              case 54:
                tx = _context27.sent;
                _context27.next = 57;
                return tx.wait();

              case 57:
                receipt = _context27.sent;
                hash = receipt.hash;

                log('receipt', receipt, hash);
                trackEvent('trxSent');
                this.pollForCompletion(hash, callback);
                this.resetBuy();
                _context27.next = 71;
                break;

              case 65:
                _context27.prev = 65;
                _context27.t0 = _context27['catch'](27);

                trackEvent('trxFailed');
                console.error('Error sending:', _context27.t0);
                this.buyLoading = false;
                this.handleWalletError(_context27.t0);

              case 71:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, this, [[27, 65]]);
      }));

      function sendEtherFrom(_x25, _x26, _x27, _x28) {
        return _ref32.apply(this, arguments);
      }

      return sendEtherFrom;
    }(),
    sendPixelsToNFT: function () {
      var _ref34 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee28(pixels_data_gzip_str, donation_amount, account, callback) {
        var trxAmount,
            x1,
            y1,
            x2,
            y2,
            _ref35,
            provider,
            signer,
            nftContract,
            calculatedPrice,
            balance,
            estimatedGas,
            gasLimit,
            overrides,
            receipt,
            txHash,
            _args28 = arguments;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                log('sendPixelsToNFT', _args28);
                trackEvent('sendPixelsToNFT');

                trxAmount = ethers.parseEther(donation_amount);

                log('trxAmount', trxAmount, typeof trxAmount === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(trxAmount));

                x1 = window.img_offset_x;
                y1 = window.img_offset_y;
                x2 = window.img_offset_x + window.img_width;
                y2 = window.img_offset_y + window.img_height;
                _context28.next = 10;
                return this.getProviderSigner();

              case 10:
                _ref35 = _context28.sent;
                provider = _ref35.provider;
                signer = _ref35.signer;
                nftContract = new ethers.Contract(this.nftAddress, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_ABI, signer);
                _context28.next = 16;
                return nftContract.calculateCurrentPrice(x1, y1, x2, y2);

              case 16:
                calculatedPrice = _context28.sent;

                log('calculatedPrice', calculatedPrice, typeof calculatedPrice === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(calculatedPrice), ethers.formatEther(calculatedPrice));

                if (!this.requireEthBalance) {
                  _context28.next = 28;
                  break;
                }

                _context28.next = 21;
                return provider.getBalance(account);

              case 21:
                balance = _context28.sent;

                log('balance', balance.toString(), trxAmount.toString());

                if (!(balance < trxAmount)) {
                  _context28.next = 28;
                  break;
                }

                this.buyLoading = false;
                this.showAlert('Insufficient funds for transaction.');
                this.saveEvent('insufficientFunds', {
                  trxAmount: trxAmount.toString(),
                  balance: balance.toString()
                });
                return _context28.abrupt('return');

              case 28:
                _context28.prev = 28;
                _context28.next = 31;
                return nftContract.mint.estimateGas(window.img_offset_x, window.img_offset_y, window.img_offset_x + window.img_width, window.img_offset_y + window.img_height, pixels_data_gzip_str, { value: trxAmount });

              case 31:
                estimatedGas = _context28.sent;
                gasLimit = this.getGasLimitFromEstimate(estimatedGas);
                overrides = {
                  gasLimit: gasLimit,
                  value: trxAmount
                };
                _context28.next = 36;
                return nftContract.mint(window.img_offset_x, window.img_offset_y, window.img_offset_x + window.img_width, window.img_offset_y + window.img_height, pixels_data_gzip_str, overrides);

              case 36:
                receipt = _context28.sent;

                trackEvent('trxSent');
                console.log('Transaction receipt:', receipt);
                txHash = receipt.hash;

                this.pollForCompletion(txHash, callback);
                this.resetBuy();
                _context28.next = 50;
                break;

              case 44:
                _context28.prev = 44;
                _context28.t0 = _context28['catch'](28);

                this.buyLoading = false;
                trackEvent('trxFailed');
                console.error('Error sending:', _context28.t0);
                this.handleWalletError(_context28.t0);

              case 50:
              case 'end':
                return _context28.stop();
            }
          }
        }, _callee28, this, [[28, 44]]);
      }));

      function sendPixelsToNFT(_x29, _x30, _x31, _x32) {
        return _ref34.apply(this, arguments);
      }

      return sendPixelsToNFT;
    }(),
    checkCanPayWithToken: function () {
      var _ref36 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee29(tokenOnly) {
        var _ref37, provider, signer, token, existingBalance;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (this.connectAccountAddress) {
                  _context29.next = 2;
                  break;
                }

                return _context29.abrupt('return');

              case 2:
                _context29.prev = 2;
                _context29.next = 5;
                return this.getProviderSigner();

              case 5:
                _ref37 = _context29.sent;
                provider = _ref37.provider;
                signer = _ref37.signer;
                token = new ethers.Contract(this.contractAddress, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_ABI, signer);
                _context29.next = 11;
                return token.balanceOf(this.connectAccountAddress);

              case 11:
                existingBalance = _context29.sent;


                console.log('Existing balance:', this.contractAddress, existingBalance.toString());

                if (existingBalance > 0) {
                  // if this route page is "tang"
                  if (this.$route.path === '/tang' || this.$route.path === '/dob') {
                    tokenOnly = true;
                  }
                  if (!tokenOnly) {
                    this.canToggleEthToken = true;
                  }
                } else {
                  this.canToggleEthToken = false;
                }
                _context29.next = 20;
                break;

              case 16:
                _context29.prev = 16;
                _context29.t0 = _context29['catch'](2);

                console.error('Error checking token balance:', _context29.t0);
                this.canToggleEthToken = false;

              case 20:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, this, [[2, 16]]);
      }));

      function checkCanPayWithToken(_x33) {
        return _ref36.apply(this, arguments);
      }

      return checkCanPayWithToken;
    }(),
    sendPixelsToTokenNFT: function () {
      var _ref38 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee30(pixels_data_gzip_str, donation_amount, account, callback) {
        var trxAmount,
            _ref39,
            provider,
            signer,
            nftContract,
            tokenContract,
            existingBalance,
            approveTrx,
            approveReceipt,
            receipt,
            txHash,
            _args30 = arguments;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                log('sendPixelsToTokenNFT', _args30);
                trackEvent('sendPixelsToTokenNFT');

                trxAmount = ethers.parseUnits(donation_amount, 18);

                // const x1 = window.img_offset_x;
                // const y1 = window.img_offset_y;
                // const x2 = window.img_offset_x + window.img_width;
                // const y2 = window.img_offset_y + window.img_height;

                _context30.next = 5;
                return this.getProviderSigner();

              case 5:
                _ref39 = _context30.sent;
                provider = _ref39.provider;
                signer = _ref39.signer;
                nftContract = new ethers.Contract(this.nftAddress, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_ABI, signer);
                _context30.prev = 9;
                tokenContract = new ethers.Contract(this.contractAddress, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_ABI, signer);

                // Check balance is enough for the transaction

                _context30.next = 13;
                return tokenContract.balanceOf(account);

              case 13:
                existingBalance = _context30.sent;

                console.log('Existing balance: ' + existingBalance.toString() + ', donation amount: ' + donation_amount);

                if (!(existingBalance < trxAmount)) {
                  _context30.next = 19;
                  break;
                }

                this.buyLoading = false;
                this.showAlert('You don\'t have enough ' + this.symbol + ' for this transaction');
                return _context30.abrupt('return');

              case 19:
                _context30.next = 21;
                return tokenContract.approve(this.nftAddress, trxAmount);

              case 21:
                approveTrx = _context30.sent;

                console.log('Approved ' + trxAmount + ' tokens for NFT contract:', approveTrx);
                _context30.next = 25;
                return approveTrx.wait();

              case 25:
                approveReceipt = _context30.sent;

                console.log('Approval receipt:', approveReceipt);

                // const estimatedGas = await nftContract.tokenMint.estimateGas(window.img_offset_x, window.img_offset_y, window.img_offset_x + window.img_width, window.img_offset_y + window.img_height, pixels_data_gzip_str);
                // const gasLimit = this.getGasLimitFromEstimate(estimatedGas);

                // const overrides = {
                //   gasLimit: gasLimit,
                //   // value: trxAmount,
                // };

                _context30.next = 29;
                return nftContract.tokenMint(window.img_offset_x, window.img_offset_y, window.img_offset_x + window.img_width, window.img_offset_y + window.img_height, pixels_data_gzip_str);

              case 29:
                receipt = _context30.sent;

                trackEvent('trxSent');
                console.log('Transaction receipt:', receipt);
                txHash = receipt.hash;

                this.pollForCompletion(txHash, callback);
                this.resetBuy();
                _context30.next = 43;
                break;

              case 37:
                _context30.prev = 37;
                _context30.t0 = _context30['catch'](9);

                this.buyLoading = false;
                trackEvent('trxFailed');
                console.error('Error sending:', _context30.t0);
                this.handleWalletError(_context30.t0);

              case 43:
              case 'end':
                return _context30.stop();
            }
          }
        }, _callee30, this, [[9, 37]]);
      }));

      function sendPixelsToTokenNFT(_x34, _x35, _x36, _x37) {
        return _ref38.apply(this, arguments);
      }

      return sendPixelsToTokenNFT;
    }(),
    sendPixelsToToken: function () {
      var _ref40 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee31(pixels_data_gzip_str, donation_amount, account, callback) {
        var amount,
            _ref41,
            provider,
            signer,
            token,
            existingBalance,
            estimatedGas,
            gasLimit,
            overrides,
            receipt,
            txHash,
            _args31 = arguments;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                log('sendPixelsToToken', _args31);
                trackEvent('sendPixelsToToken');

                amount = ethers.parseUnits(donation_amount, 18);
                _context31.next = 5;
                return this.getProviderSigner();

              case 5:
                _ref41 = _context31.sent;
                provider = _ref41.provider;
                signer = _ref41.signer;
                token = new ethers.Contract(__WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_CA, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_ABI, signer);
                _context31.next = 11;
                return token.balanceOf(account);

              case 11:
                existingBalance = _context31.sent;

                if (!(existingBalance < amount)) {
                  _context31.next = 16;
                  break;
                }

                this.buyLoading = false;
                this.showAlert('You don\'t have enough ' + this.symbol + ' for this transaction');
                return _context31.abrupt('return');

              case 16:
                _context31.prev = 16;
                _context31.next = 19;
                return token.paint.estimateGas(BID_TO_ADDRESS, amount, pixels_data_gzip_str);

              case 19:
                estimatedGas = _context31.sent;
                gasLimit = this.getGasLimitFromEstimate(estimatedGas);
                overrides = {
                  gasLimit: gasLimit
                };
                _context31.next = 24;
                return token.paint(BID_TO_ADDRESS, amount, pixels_data_gzip_str, overrides);

              case 24:
                receipt = _context31.sent;

                trackEvent('trxSent');
                console.log('Transaction receipt:', receipt);
                txHash = receipt.hash;

                this.pollForCompletion(txHash, callback);
                this.resetBuy();
                _context31.next = 38;
                break;

              case 32:
                _context31.prev = 32;
                _context31.t0 = _context31['catch'](16);

                this.buyLoading = false;
                trackEvent('trxFailed');
                console.error('Error sending:', _context31.t0);
                this.handleWalletError(_context31.t0);

              case 38:
              case 'end':
                return _context31.stop();
            }
          }
        }, _callee31, this, [[16, 32]]);
      }));

      function sendPixelsToToken(_x38, _x39, _x40, _x41) {
        return _ref40.apply(this, arguments);
      }

      return sendPixelsToToken;
    }(),
    getGasLimitFromEstimate: function getGasLimitFromEstimate(estimatedGas) {
      var gasLimit = estimatedGas * BigInt(1000) / BigInt(100); // 10x the gas price for coinbase mobile wallet
      log('Estimated gas: ' + estimatedGas + ', gasLimit: ' + gasLimit);
      return gasLimit;
    },
    showAlert: function showAlert(msg) {
      this.alertMsg = msg;
      this.$bvModal.show('modal-alert');
    },
    pushProvider: function pushProvider(p) {
      var _this5 = this;

      log('Found provider', p);
      p.on("accountsChanged", function (accounts) {
        log('accountsChanged', accounts);
        _this5.getWalletPermissions(p, accounts);
      });
      p.on("chainChanged", function (chainId) {
        log('chainChanged', chainId, typeof chainId === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(chainId));
        _this5.connectAccountChainId = chainId;
      });
      // if (p.isPhantom) {
      //   log('Phantom provider', p);
      //   this.providers.push({
      //     provider: p,
      //     info: {
      //       "uuid": "1",
      //       "name": "Phantom",
      //       "icon": "data:image/png;base64,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\n",
      //       "rdns": "app.phantom"
      //     }
      //   });
      //   this.getWalletPermissions(p);
      //   trackEvent('hasWallet:app.phantom');
      //   return;
      // }
      if (p.isMetaMask) {
        if (p.isRabby) {
          log('Rabby provider', p);
          this.providers.push({
            provider: p,
            info: {
              "uuid": "aba7b19c-2e24-4405-aff2-69dbd5bbfafd",
              "name": "Rabby",
              "icon": "data:image/svg+xml;base64,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",
              "rdns": "io.rabby"
            }
          });
          this.getWalletPermissions(p);
          trackEvent('hasWallet:io.rabby');
          return;
        }
        log('MetaMask provider', p);
        this.providers.push({
          provider: p,
          info: {
            "uuid": "eb90892c-6a12-44c9-9aea-31a4dd915385",
            "name": "MetaMask",
            "icon": "data:image/svg+xml;base64,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",
            "rdns": "io.metamask"
          }
        });
        this.getWalletPermissions(p);
        trackEvent('hasWallet:io.metamask');
      } else if (p.isCoinbaseWallet || p.isCoinbaseBrowser) {
        log('Coinbase Wallet provider', p);
        this.providers.push({
          provider: p,
          info: {
            "uuid": "22c494ca-e7ca-4c13-a5c0-6d72312046a6",
            "name": "Coinbase",
            "icon": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+",
            "rdns": "com.coinbase.wallet"
          }
        });
        trackEvent('hasWallet:com.coinbase.wallet');
      } else {
        log('Unknown provider', p);
        trackEvent('hasWallet:unknown');
      }
    },
    blurInput: function blurInput() {
      this.$refs.formInputValueUrl.blur();
    },
    initPushNotification: function initPushNotification() {
      var _this6 = this;

      if (!('serviceWorker' in navigator)) {
        // alert('No Service Worker support!')
        return;
      }
      // if (!('PushManager' in window)) {
      //   alert('No Push API Support!')
      //   return;
      // }

      // if ('serviceWorker' in navigator && 'PushManager' in window) {
      console.log('Service Worker and Push are supported');

      // Notification.requestPermission().then(async () => {
      navigator.serviceWorker.register('sw.js').then(function (swReg) {
        // alert('Service Worker is registered', swReg);
        _this6.swRegistration = swReg;
        _this6.initSubscription();
      }).catch(function (error) {
        // alert('Service Worker Error', error);
        // alert(JSON.stringify(error));
      });
      // });
      // } else {
      //   console.warn('Push messaging is not supported');
      //   pushButton.textContent = 'Push Not Supported';
      // }
    },
    initSubscription: function initSubscription() {
      var _this7 = this;

      // Set the initial subscription value
      this.swRegistration.pushManager.getSubscription().then(function (subscription) {
        _this7.isSubscribed = !(subscription === null);
        _this7.updateSubscriptionOnServer(subscription);

        if (_this7.isSubscribed) {
          console.log('User IS subscribed.', subscription);
        } else {
          console.log('User is NOT subscribed.');
          _this7.subscribeUser();
        }
      }).catch(function (error) {
        // alert('Error during getSubscription()', error);
      });
    },

    postToLambda: function () {
      var _ref42 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee32(name, data) {
        var _response3;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                log('Posting data to lambda', name, data);
                _context32.prev = 1;
                _context32.next = 4;
                return fetch(PUSH_SUB_URL + name, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)
                });

              case 4:
                _response3 = _context32.sent;

                if (!_response3.ok) {
                  _context32.next = 7;
                  break;
                }

                return _context32.abrupt('return', _response3.json());

              case 7:
                _context32.next = 13;
                break;

              case 9:
                _context32.prev = 9;
                _context32.t0 = _context32['catch'](1);

                console.error('Fetch error:', _context32.t0);
                return _context32.abrupt('return', undefined);

              case 13:
              case 'end':
                return _context32.stop();
            }
          }
        }, _callee32, this, [[1, 9]]);
      }));

      function postToLambda(_x42, _x43) {
        return _ref42.apply(this, arguments);
      }

      return postToLambda;
    }(),
    updateSubscriptionOnServer: function updateSubscriptionOnServer(subscription) {
      localStorage.setItem(LOCAL_STORAGE_NOTIFICATION_SUB_ENDPOINT, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(subscription.endpoint));
      if (subscription) {
        console.log('updateSubscriptionOnServer', subscription);
        try {
          fetch(PUSH_SUB_URL + 'subscribe', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(subscription)
          }).then(function (response) {
            if (!response.ok) {
              console.error('Network response was not ok ' + response.statusText);
            }
            trackEvent('pushSubscribed');
            return response.json(); // Assuming the response is JSON
          }).then(function (data) {
            console.log('Data received:', data);
          }).catch(function (error) {
            console.error('Fetch error:', error);
          });
          __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].toast({
            title: 'Million Bit Homepage',
            message: 'Notifications enabled',
            type: "success",
            duration: 5000
          });
        } catch (e) {
          console.error('Fetch error:', e);
        }
      }
      // TODO: Send subscription to application server

      // const subscriptionJson = document.querySelector('.js-subscription-json');
      // const subscriptionDetails =
      //   document.querySelector('.js-subscription-details');

      // if (subscription) {
      //   subscriptionJson.textContent = JSON.stringify(subscription);
      //   subscriptionDetails.classList.remove('is-invisible');
      // } else {
      //   subscriptionDetails.classList.add('is-invisible');
      // }
    },
    subscribeUser: function subscribeUser() {
      var _this8 = this;

      var applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
      this.swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      }).then(function (subscription) {
        console.log('User is subscribed', subscription);

        _this8.updateSubscriptionOnServer(subscription);

        _this8.isSubscribed = true;

        // updateBtn();
      }).catch(function (err) {
        console.log('Failed to subscribe the user: ', err);
        // updateBtn();
      });
    },

    showInviteFriends: function () {
      var _ref43 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee33() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return this.getRefCode();

              case 2:
                this.$bvModal.show('modal-invite-friends');

              case 3:
              case 'end':
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function showInviteFriends() {
        return _ref43.apply(this, arguments);
      }

      return showInviteFriends;
    }(),
    moveImage: function moveImage(dx, dy, toAbsolute) {
      var image = document.getElementById('uploadedImg');
      var imageX = parseFloat(image.getAttribute('data-x')) || 0;
      var imageY = parseFloat(image.getAttribute('data-y')) || 0;
      if (toAbsolute) {
        dx = dx - imageX;
        dy = dy - imageY;
      }
      var x = imageX + dx;
      var y = imageY + dy;

      // Apply the transformation
      image.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

      // Update the position attributes
      image.setAttribute('data-x', x);
      image.setAttribute('data-y', y);

      window.img_offset_x = x;
      window.img_offset_y = y;
    },
    moveSpot: function moveSpot(direction) {
      // var c = document.getElementById("uploadedImg");
      // c.style.display = 'block';
      // c.width = canvas.width;
      // c.height = canvas.height;
      // c.style.width = canvasWidth+'px';
      // c.style.height = canvasHeight+'px';

      if (direction === 'left') {
        this.moveImage(-16, 0);
      } else if (direction === 'right') {
        this.moveImage(16, 0);
      } else if (direction === 'up') {
        this.moveImage(0, -16);
      } else if (direction === 'down') {
        this.moveImage(0, 16);
      }
      this.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
      window.interactable.reflow({ name: 'drag', axis: 'xy' });
    },
    resizeSpot: function resizeSpot(direction) {
      function scaleImage(increment) {
        var image = document.getElementById('uploadedImg');
        var currentWidth = image.offsetWidth;
        var currentHeight = image.offsetHeight;

        if (direction === 'bigger' && (currentHeight >= MAX_IMAGE_SIZE || currentWidth >= MAX_IMAGE_SIZE) || direction === 'smaller' && (currentHeight <= 16 || currentWidth <= 16)) {
          return;
        }

        // Calculate the new dimensions
        var newWidth = currentWidth + increment;
        var newHeight = currentHeight + increment;

        // Ensure the image doesn't scale down below a minimum size (e.g., 16x16 pixels)
        if (newWidth >= 16 && newHeight >= 16) {
          image.style.width = newWidth + 'px';
          image.style.height = newHeight + 'px';
        }

        window.img_width = newWidth;
        window.img_height = newHeight;

        var destCtx = getScaledContext(window.uploadedImgObj.width, window.uploadedImgObj.height, window.img_width, window.img_height, window.uploadedImgObj.data);
        var d = destCtx.getImageData(0, 0, window.img_width, window.img_height).data;
        window.myImageData = d;
      }
      if (direction === 'bigger') {
        scaleImage(16);
      } else if (direction === 'smaller') {
        scaleImage(-16);
      }
      this.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
      window.interactable.reflow({ name: 'drag', axis: 'xy' });
      // window.myImageData = myImageData;
    },
    btnPress: function btnPress(direction) {
      // Your button press logic here
      this.moveSpot(direction);
    },
    handleTouchStart: function handleTouchStart(event, direction) {
      var _this9 = this;

      event.preventDefault(); // Prevents text selection and default touch behavior
      // Call btnPress immediately
      this.btnPress(direction);
      this.touchTimer = setTimeout(function () {
        // Start repeating every 500ms
        _this9.repeatTimer = setInterval(function () {
          _this9.btnPress(direction);
        }, 100);
      }, 500); // Adjust this timeout for long press sensitivity
    },
    handleTouchEnd: function handleTouchEnd(event) {
      event.preventDefault(); // Prevents zooming
      this.handleTouchCancel();
    },
    handleTouchCancel: function handleTouchCancel() {
      clearTimeout(this.touchTimer);
      clearInterval(this.repeatTimer);
    },

    loadProviders: function loadProviders() {
      if (this.providers.length === 0) {
        if (window.ethereum) {
          if (window.ethereum.providers && window.ethereum.providers.length) {
            for (var i = 0; i < window.ethereum.providers.length; i++) {
              var p = window.ethereum.providers[i];
              this.pushProvider(p);
            }
          } else {
            this.pushProvider(window.ethereum);
          }
        } else {
          // this.test_msg = 'no ether'
        }
      } else {
          // this.test_msg = 'has providers'
        }
    }
  },
  watch: {
    // Watch the $route object for changes
    $route: function $route(to, from) {
      log('Route changed from', from.path, 'to', to.path);

      // Track the page view with gtag
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path: to.fullPath // Use the new route's full path
        });
      }
    }
  },
  created: function created() {
    log('---------CREATED--------');
  },
  mounted: function mounted() {
    var _this10 = this;

    log('---------MOUNTED--------');
    // this.toggleHomepageList = true;
    // initUploader(this); // triggered when child view loads
    // doCountdown();
    this.providers = [];
    setTimeout(function () {
      _this10.loadProviders();
    }, 1500); // TODO this sucks, but extending helps fighting wallets

    if (!localStorage.getItem(DID_PROMPT_NOTIFICATIONS)) {
      localStorage.setItem(DID_PROMPT_NOTIFICATIONS, true);
      this.initPushNotification();
    }

    this.watchedDemo = localStorage.getItem(LOCAL_STORAGE_KEY_DEMO_VID);

    this.isMobileOrTouch = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].isMobileOrTouch();

    // Check for referral code
    if (window.location && window.location.search) {
      var urlParams = new URLSearchParams(window.location.search);
      var ref = urlParams.get('ref');
      if (ref) {
        // this.referralCode = ref;
        localStorage.setItem(LOCAL_STORAGE_KEY_REFERRAL, ref);
        this.saveEvent('referral', ref);
      }
    }

    // window.addEventListener("eip6963:announceProvider",
    //   (event) => {
    //     log('eip6963:announceProvider', event.detail);
    //     trackEvent('hasWallet:'+event.detail.info.rdns);
    //     // if (event.detail && (event.detail.info.rdns == 'com.coinbase.wallet' || event.detail.info.rdns == 'io.metamask' || event.detail.info.rdns == 'app.phantom')) {
    //     if (event.detail && ['com.coinbase.wallet', 'io.metamask', 'io.rabby', 'app.phantom'].includes(event.detail.info.rdns)) {
    //       this.pushProvider(event.detail.provider);
    //       // this.providers.push(event.detail);
    //       // event.detail.provider.on("accountsChanged", (accounts) => {
    //       //   log('accountsChanged', accounts);
    //       //   this.getWalletPermissions(event.detail.provider);
    //       // });
    //       // event.detail.provider.on("chainChanged", (chainId) => {
    //       //   log('chainChanged', chainId);
    //       //   this.connectAccountChainId = chainId;
    //       // });
    //       // event.detail.provider.on("disconnect", (error) => {
    //       //   log('disconnect', error);
    //       //   this.getWalletPermissions(event.detail.provider);
    //       // });
    //       // this.getWalletPermissions(event.detail.provider);
    //     }
    //   }
    // );
    // setTimeout(()=> {
    //   window.dispatchEvent(new Event("eip6963:requestProvider"));
    // }, 1500);
  }
});

/***/ }),

/***/ "xySY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "billboard",
    class: {
      'showTooltip': _vm.hovering
    },
    attrs: {
      "id": "million-bit-billboard"
    },
    on: {
      "click": _vm.clickBillboard,
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "mousemove": _vm.onMouseMove
    }
  }, [_c('canvas', {
    attrs: {
      "id": "uploadedImg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.s3ImgSrc,
      "usemap": "#linkmap"
    },
    on: {
      "load": _vm.onBillboardLoaded
    }
  }), _vm._v(" "), _c('map', {
    attrs: {
      "name": "linkmap"
    }
  }, _vm._l((_vm.links), function(link) {
    return _c('area', {
      attrs: {
        "target": "_blank",
        "alt": "",
        "title": "",
        "shape": "rect",
        "coords": link.c,
        "href": link.u
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    ref: 'tooltip',
    attrs: {
      "id": "billboard-tooltip"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yA2K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zh3L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.19494624a82d0bbc08aa.js